export const YealinkDevices = [
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 79,
      "PriceChangeDate": "2023-03-10T11:35:03.703",
      "ShipmentRecievedDate": "2011-04-01T00:00:00",
      "StandardPrice": 50,
      "EnergyStartCompliant": false,
      "ProductDescription": "- Headset Adapter<br/>- Supports Yealink SIP-SIP-T48S/T48G/T46S/T46G/T42S/T42G/T41S/T41P/ T40G/T40P/T29G/T27G/T27P IP Phones and a compatible wireless headset<br/>-NOTE: YEA-EHS36 is not needed when adding a YEA-WH6X headset to a Yealink SIP phone<br/>- Full compatibility with Jabra, Plantronics and Sennheiser<br/>- Phone control through a wireless headset<br/>- Plug-and-play, easy to use",
      "SKU": "YealinkIP phone wireless headset adapter",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": null,
          "ResourceUrl": "https://www.teledynamics.com/tdresources/e7abebee-9c0e-4125-8d94-ce9b8b688f65.jpg"
        },
        {
          "Description": "YEA-EHS36",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/YEA-EHS36image1.jpg"
        },
        {
          "Description": "YEA-EHS36",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/3ec51ff5-6c79-48cb-bb2e-aed3096e472d.jpg"
        }
      ],
      "Documents": [
        {
          "Description": "Data Sheet",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/cb4588a5-d9af-436d-92c1-25a278df40cb.pdf"
        },
        {
          "Description": "Wireless Headset Compatibility List",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/349b8f2b-bb49-4c8b-81ee-c86412e8f39b.pdf"
        },
        {
          "Description": "User Guide",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/5120ac2d-7f9b-42de-b141-1e32ab7b2c63.pdf"
        }
      ],
      "Relatedproducts": [
        "YEA-SIP-T42G",
        "YEA-SIP-T29G"
      ],
      "Accessories": [],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 1.5,
      "Length": 6,
      "Width": 3.5,
      "Weight": 0.35,
      "DimensionalAirWeigth": 0.23,
      "DimensionalGroundWeight": 0.19,
      "Features": [
        {
          "Name": "Headset Adapters",
          "Value": "Yes"
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": "No"
        },
        {
          "Name": "Recycled Packaging",
          "Value": "Yes"
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": "Yes"
        },
        {
          "Name": "Type of Packaging",
          "Value": "Retail Box"
        },
        {
          "Name": "Warranty",
          "Value": "1 year"
        },
        {
          "Name": "Website Link",
          "Value": "http://www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "Business Equipment",
          "SubCategories": [
            {
              "Name": "Headsets"
            }
          ]
        }
      ],
      "PartNumber": "YEA-EHS36",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-EHS36",
      "Manufacturer": "Yealink",
      "ProductName": "YealinkIP phone wireless headset adapter",
      "UnitPrice": 50,
      "MSRP": 79,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 133,
      "UPC": "6938818300606"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 0,
      "PriceChangeDate": "2018-09-28T16:15:07.593",
      "ShipmentRecievedDate": "2010-09-24T00:00:00",
      "StandardPrice": 8.75,
      "EnergyStartCompliant": false,
      "ProductDescription": "- AC/DC Switching adapter<br />- Output: 5V - 1.2A <br />- Input: 100-240V ~ 50/60Hz 250mA<br />- For use with the following Yealink phones. SIP-T41S,SIP-T42S, SIP-T27G, T53, T53W",
      "SKU": "330000011036 PSU for YL IP phones, 1.2A",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-PS5V1200US",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/ITT-5003image1.jpg"
        },
        {
          "Description": "YEA-PS5V1200US",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/ee7693e6-c945-4059-85d2-aba57074d987.jpg"
        },
        {
          "Description": "Yealink Logo",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/cdeebf6b-21bd-446e-8cd5-2a816f3eebdb.jpg"
        }
      ],
      "Documents": [],
      "Relatedproducts": [
        "YEA-SIP-T41S",
        "YEA-SIP-T42G",
        "YEA-HNDST-T4S",
        "YEA-STAND-T4S"
      ],
      "Accessories": [],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 4,
      "Length": 3,
      "Width": 2,
      "Weight": 0.1875,
      "DimensionalAirWeigth": 0.17,
      "DimensionalGroundWeight": 0.14,
      "Features": [
        {
          "Name": "Accessories",
          "Value": "Yes"
        },
        {
          "Name": "Power Supplies",
          "Value": "Yes"
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": "No"
        },
        {
          "Name": "Recycled Packaging",
          "Value": "Yes"
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": "Yes"
        },
        {
          "Name": "Type of Packaging",
          "Value": "Plastic Bag"
        },
        {
          "Name": "Warranty",
          "Value": "1 Year"
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-PS5V1200US",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-PS5V1200US",
      "Manufacturer": "Yealink",
      "ProductName": "330000011036 PSU for YL IP phones, 1.2A",
      "UnitPrice": 8.75,
      "MSRP": 12,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 1000,
      "UPC": "841885109866"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 0,
      "PriceChangeDate": "2013-05-31T09:23:10.893",
      "ShipmentRecievedDate": "2013-07-24T00:00:00",
      "StandardPrice": 9,
      "EnergyStartCompliant": false,
      "ProductDescription": "- Power Supply for Yealink 5-volt 2-amp<br/>- For use with the SIP-T29G, T46S T48S,T58A, T58-CAM,T54W, T57W, MP54-TEAMS and MP56-TEAMS",
      "SKU": "330000012027 PSU for Yealink 5-v 2-amp",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-PS5V2000US",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/e1dd0e92-5368-4278-8505-5ca48114bf5c.jpg"
        },
        {
          "Description": "YEA-PS5V2000US",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/64f78f3a-2d5c-4247-8722-07244faa4c4a.jpg"
        }
      ],
      "Documents": [],
      "Relatedproducts": [
        "YEA-SFB-T46G",
        "YEA-STAND-T46",
        "YEA-STAND-T48",
        "YEA-HNDST6",
        "YEA-WMB-T2S",
        "YEA-CPE80",
        "PY-2200-48872-001",
        "YEA-MP54-TEAMS",
        "YEA-MP56-TEAMS"
      ],
      "Accessories": [],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 3,
      "Length": 2,
      "Width": 2,
      "Weight": 0.2,
      "DimensionalAirWeigth": 0.09,
      "DimensionalGroundWeight": 0.07,
      "Features": [
        {
          "Name": "Accessories",
          "Value": "Yes"
        },
        {
          "Name": "Power Supplies",
          "Value": "Yes"
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": "No"
        },
        {
          "Name": "Recycled Packaging",
          "Value": "Yes"
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": "Yes"
        },
        {
          "Name": "Type of Packaging",
          "Value": "Plastic Bag"
        },
        {
          "Name": "Warranty",
          "Value": "1 Year"
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-PS5V2000US",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-PS5V2000US",
      "Manufacturer": "Yealink",
      "ProductName": "330000012027 PSU for Yealink 5-v 2-amp",
      "UnitPrice": 9,
      "MSRP": 15,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 1000,
      "UPC": "841885109859"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 0,
      "PriceChangeDate": "2014-04-16T17:15:25.477",
      "ShipmentRecievedDate": "2013-08-21T00:00:00",
      "StandardPrice": 5.5,
      "EnergyStartCompliant": false,
      "ProductDescription": "- Wall Mount Bracket for T46G, T46S, T46U",
      "SKU": "330100000036 Wall Mount Bracket for T46",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "Primary Image",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/02099388-54dd-4cfc-ad02-ffdc927718c6.jpg"
        },
        {
          "Description": "Secondary Image",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/845344a4-58df-4e7b-bb74-cc9da78494ce.jpg"
        },
        {
          "Description": "Yealink Logo",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/f0a9d0ee-5fde-4289-a2e4-67b27b81687c.jpg"
        }
      ],
      "Documents": [
        {
          "Description": "T46G Quick Start Guide",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/8c4888bb-6965-495b-bb86-669851a11394.pdf"
        },
        {
          "Description": "T46G User Guide",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/abd62a45-a8cf-4e07-85d2-3ff4bd9ef372.pdf"
        },
        {
          "Description": "Quick Installation Guide",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/b92c6204-d068-4d45-8e1a-7fa302f3b74a.pdf"
        }
      ],
      "Relatedproducts": [
        "YEA-SIP-T46G",
        "YEA-SIP-T46S",
        "YEA-SIP-T46U"
      ],
      "Accessories": [],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 7,
      "Length": 4,
      "Width": 1,
      "Weight": 0.1,
      "DimensionalAirWeigth": 0.2,
      "DimensionalGroundWeight": 0.17,
      "Features": [
        {
          "Name": "Accessories",
          "Value": "Yes"
        },
        {
          "Name": "Stands, Mounting Equipment, and Cases",
          "Value": "Yes"
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": "No"
        },
        {
          "Name": "Recycled Packaging",
          "Value": "No"
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": "No"
        },
        {
          "Name": "Type of Packaging",
          "Value": "Retail Box"
        },
        {
          "Name": "Warranty",
          "Value": "1 Year"
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-WMB-T46",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-WMB-T46",
      "Manufacturer": "Yealink",
      "ProductName": "330100000036 Wall Mount Bracket for T46",
      "UnitPrice": 5.5,
      "MSRP": 0,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 1000,
      "UPC": "841885105271"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 0,
      "PriceChangeDate": "2013-10-31T11:35:11.98",
      "ShipmentRecievedDate": "2013-12-20T00:00:00",
      "StandardPrice": 5.5,
      "EnergyStartCompliant": false,
      "ProductDescription": "- Wall mount bracket for T40G. T41P, T41S, T42G, T42S, and T43U",
      "SKU": "3301000000 WMB for 42,43U,44U & 44W",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-WMB-T4S",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/431494de-a6f4-4e41-9237-d6c7c5c4cab9.jpg"
        },
        {
          "Description": "Yealink Logo",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/0193abcb-dc57-4787-be34-66c8b4b17c19.jpg"
        }
      ],
      "Documents": [
        {
          "Description": "T42G User Guide",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/ff27cc18-d970-4405-a604-accf13fdbef6.pdf"
        },
        {
          "Description": "T42G Quick Reference Guide",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/974ff7f8-561d-43aa-9edb-5128a645a8b7.pdf"
        }
      ],
      "Relatedproducts": [
        "YEA-SIP-T40G",
        "YEA-SIP-T41P",
        "YEA-SIP-T41S",
        "YEA-SIP-T42G",
        "YEA-SIP-T42S",
        "YEA-SIP-T43U",
        "YEA-SIP-T44U",
        "YEA-SIP-T44W"
      ],
      "Accessories": [],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 6,
      "Length": 3,
      "Width": 1,
      "Weight": 0.5,
      "DimensionalAirWeigth": 0.13,
      "DimensionalGroundWeight": 0.11,
      "Features": [
        {
          "Name": "Accessories",
          "Value": "Yes"
        },
        {
          "Name": "Stands, Mounting Equipment, and Cases",
          "Value": "Yes"
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": "No"
        },
        {
          "Name": "Recycled Packaging",
          "Value": "No"
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": "Yes"
        },
        {
          "Name": "Type of Packaging",
          "Value": "Retail Box"
        },
        {
          "Name": "Warranty",
          "Value": "1 Year"
        },
        {
          "Name": "Website Link",
          "Value": "http://www.yealink.com/"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-WMB-T4S",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-WMB-T4S",
      "Manufacturer": "Yealink",
      "ProductName": "3301000000 WMB for 42,43U,44U & 44W",
      "UnitPrice": 5.5,
      "MSRP": 0,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 1000,
      "UPC": "841885105127"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 0,
      "PriceChangeDate": "2013-10-31T11:35:11.98",
      "ShipmentRecievedDate": "2013-12-20T00:00:00",
      "StandardPrice": 5.5,
      "EnergyStartCompliant": false,
      "ProductDescription": "- Wall mount bracket for the EXP40 expansion module",
      "SKU": "330100000017 Wall Mount Bracket EXP40",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "Primary Image",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/8097731d-7dba-4122-8426-b6e08f0a532e.jpg"
        },
        {
          "Description": "Yealink Logo",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/da21bef0-814d-4816-8d4b-e121757de374.jpg"
        }
      ],
      "Documents": [
        {
          "Description": "EXP40 Data Sheet",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/d31d5d47-9713-41a7-9906-8a7f0da2f62f.pdf"
        },
        {
          "Description": "Quick Installation Guide",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/9608a182-b64f-4b96-8170-213353e5f853.pdf"
        },
        {
          "Description": "EXP40 User Guide",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/025a7cd9-9e29-4d16-bbdb-341927e6474d.pdf"
        }
      ],
      "Relatedproducts": [
        "YEA-EXP40",
        "YEA-SFB-T46G"
      ],
      "Accessories": [],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 4,
      "Length": 2,
      "Width": 1.5,
      "Weight": 0.3,
      "DimensionalAirWeigth": 0.09,
      "DimensionalGroundWeight": 0.07,
      "Features": [
        {
          "Name": "Accessories",
          "Value": "Yes"
        },
        {
          "Name": "Stands, Mounting Equipment, and Cases",
          "Value": "Yes"
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "Warranty",
          "Value": "1 Year"
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-WMB-EXP40",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-WMB-EXP40",
      "Manufacturer": "Yealink",
      "ProductName": "330100000017 Wall Mount Bracket EXP40",
      "UnitPrice": 5.5,
      "MSRP": 0,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 0,
      "UPC": "YEA-WMB-EXP40"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 0,
      "PriceChangeDate": "2018-09-28T16:15:07.593",
      "ShipmentRecievedDate": "2013-12-20T00:00:00",
      "StandardPrice": 6,
      "EnergyStartCompliant": false,
      "ProductDescription": "- Yealink power supply for use with the SIP-T21(P), SIP-T19(P), SIP-T23(p), W52P, W52H, SIP-T23G, SIP-T40P, T30G,T31G,T33G, MP52",
      "SKU": "330000010004 PSU for Yealink phones",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "Primary Image",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/018fa2f5-8255-482f-aaef-7d8f0f9cb289.jpg"
        },
        {
          "Description": "Secondary Image",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/666029fb-fb8e-456e-a2f2-4d2dc610fe30.jpg"
        },
        {
          "Description": "Yealink Logo",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/5880b364-8a48-48e0-b99e-0ffcf231c80a.jpg"
        }
      ],
      "Documents": [],
      "Relatedproducts": [
        "YEA-SIP-T21P-E2",
        "YEA-SIP-T19P-E2",
        "YEA-SIP-T23G",
        "YEA-W52P",
        "YEA-SIP-T23G",
        "YEA-SIP-T33G"
      ],
      "Accessories": [],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 3,
      "Length": 3,
      "Width": 2,
      "Weight": 0.5,
      "DimensionalAirWeigth": 0.13,
      "DimensionalGroundWeight": 0.11,
      "Features": [
        {
          "Name": "Accessories",
          "Value": "Yes"
        },
        {
          "Name": "Power Supplies",
          "Value": "Yes"
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": "No"
        },
        {
          "Name": "Recycled Packaging",
          "Value": "No"
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": "Yes"
        },
        {
          "Name": "Type of Packaging",
          "Value": "Plastic Bag"
        },
        {
          "Name": "Warranty",
          "Value": "1 year limited"
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-PS5V600US",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-PS5V600US",
      "Manufacturer": "Yealink",
      "ProductName": "330000010004 PSU for Yealink phones",
      "UnitPrice": 6,
      "MSRP": 10,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 1000,
      "UPC": "841885109897"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 0,
      "PriceChangeDate": "2015-09-29T15:55:15.44",
      "ShipmentRecievedDate": "2013-12-20T00:00:00",
      "StandardPrice": 15,
      "EnergyStartCompliant": false,
      "ProductDescription": "- Handset for the T46 series<br/>- Compatible with T46G/T48G/T49G/T46S/T48S/VP59/T46U/T48U",
      "SKU": "220106900002 Handset for T46/T48/VP59",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "Primary",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/df3a2751-c290-42aa-bf36-81e5f9d52e36.jpg"
        },
        {
          "Description": "w/Base unit",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/61c481ab-25dc-4570-980d-9940f1b00f08.jpg"
        },
        {
          "Description": "w/Base unit",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/0a81143a-3f21-44ca-8c16-58e8a99ea140.jpg"
        }
      ],
      "Documents": [],
      "Relatedproducts": [
        "YEA-HNDST1",
        "YEA-HNDST3",
        "YEA-HNDST4",
        "YEA-HNDST-T4S",
        "YEA-HNDST5",
        "YEA-SIP-T46S",
        "YEA-SIP-T48S",
        "YEA-SIP-T48U",
        "YEA-SIP-T46U"
      ],
      "Accessories": [],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 8,
      "Length": 2,
      "Width": 2,
      "Weight": 0.4,
      "DimensionalAirWeigth": 0.23,
      "DimensionalGroundWeight": 0.19,
      "Features": [
        {
          "Name": "Accessories",
          "Value": "Yes"
        },
        {
          "Name": "Replacement Handsets",
          "Value": "Yes"
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": "No"
        },
        {
          "Name": "Recycled Packaging",
          "Value": "No"
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": "Yes"
        },
        {
          "Name": "Type of Packaging",
          "Value": "Styrofoam Bag"
        },
        {
          "Name": "Warranty",
          "Value": "1 Year"
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-HNDST-T46",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-HNDST-T46",
      "Manufacturer": "Yealink",
      "ProductName": "220106900002 Handset for T46/T48/VP59",
      "UnitPrice": 15,
      "MSRP": 0,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 351,
      "UPC": "841885111173"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 0,
      "PriceChangeDate": "2015-09-29T15:55:15.44",
      "ShipmentRecievedDate": "2013-12-20T00:00:00",
      "StandardPrice": 15,
      "EnergyStartCompliant": false,
      "ProductDescription": "- Handset for the T40P/T40G/T41P/T42G/T41S/T42S/T42U/T43U",
      "SKU": "2201066 Handset for T4x",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "pRIMARY",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/e62fca2d-f335-4069-80ad-e2c9994fc826.jpg"
        },
        {
          "Description": "Secondary ",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/fd8f41ec-7ea1-4ebc-a484-7381634d5c0a.jpg"
        },
        {
          "Description": "w/Base unit",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/36e5d1f8-aead-4f93-9163-08cacff5a96b.jpg"
        }
      ],
      "Documents": [],
      "Relatedproducts": [
        "YEA-SIP-T42G",
        "YEA-HNDST-T46",
        "YEA-HNDST-T5X",
        "YEA-SIP-T40G",
        "YEA-SIP-T41P",
        "YEA-SIP-T41S",
        "YEA-SIP-T42S",
        "YEA-SIP-T43U"
      ],
      "Accessories": [],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 8,
      "Length": 2,
      "Width": 2,
      "Weight": 0.7,
      "DimensionalAirWeigth": 0.23,
      "DimensionalGroundWeight": 0.19,
      "Features": [
        {
          "Name": "Accessories",
          "Value": "Yes"
        },
        {
          "Name": "Replacement Handsets",
          "Value": "Yes"
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": "No"
        },
        {
          "Name": "Recycled Packaging",
          "Value": "No"
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": "No"
        },
        {
          "Name": "Type of Packaging",
          "Value": "Styrofoam Bag"
        },
        {
          "Name": "Warranty",
          "Value": "1 Year"
        },
        {
          "Name": "Website Link",
          "Value": "http://www.yealink.com/"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-HNDST-T4S",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-HNDST-T4S",
      "Manufacturer": "Yealink",
      "ProductName": "2201066 Handset for T4x",
      "UnitPrice": 15,
      "MSRP": 0,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 128,
      "UPC": "YEA-HNDST-T4S"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 0,
      "PriceChangeDate": "2014-04-14T15:35:15.943",
      "ShipmentRecievedDate": "2014-04-14T00:00:00",
      "StandardPrice": 5.5,
      "EnergyStartCompliant": false,
      "ProductDescription": "- Wall mount bracket for the t48 series",
      "SKU": "Wall Mount Bracket for T48",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-WMB-T48",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/35c85ecd-7eaa-4f7c-85f6-3bbfa06087e3.jpg"
        },
        {
          "Description": "YEA-WMB-T48",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/a00d8c79-e5a8-4677-ad00-0a67531b089e.jpg"
        },
        {
          "Description": "Yealink Logo",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/021cc52a-0665-43eb-9b96-5f57ebc2f3da.jpg"
        }
      ],
      "Documents": [
        {
          "Description": "Quick Installation guide",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/c60529ea-6ff2-415d-8791-9fa38ca6cd81.pdf"
        }
      ],
      "Relatedproducts": [
        "YEA-HNDST-T46",
        "YEA-HNDSTCRD1",
        "YEA-100-048-003",
        "YEA-STAND-T48"
      ],
      "Accessories": [],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 8,
      "Length": 4,
      "Width": 1,
      "Weight": 0.35,
      "DimensionalAirWeigth": 0.23,
      "DimensionalGroundWeight": 0.19,
      "Features": [
        {
          "Name": "Accessories",
          "Value": "Yes"
        },
        {
          "Name": "Stands, Mounting Equipment, and Cases",
          "Value": "Yes"
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": "No"
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "Type of Packaging",
          "Value": "Retail Box"
        },
        {
          "Name": "Warranty",
          "Value": "1 Year"
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-WMB-T48",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-WMB-T48",
      "Manufacturer": "Yealink",
      "ProductName": "Wall Mount Bracket for T48",
      "UnitPrice": 5.5,
      "MSRP": 0,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 543,
      "UPC": "841885105288"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 119,
      "PriceChangeDate": "2018-11-16T15:35:03.523",
      "ShipmentRecievedDate": "2015-02-10T00:00:00",
      "StandardPrice": 25,
      "EnergyStartCompliant": false,
      "ProductDescription": "Optima HD voice, full duplex technology<br />10-feet (3-meters) 120°H voice pickup<br />Capacitive mute touchpad with bicolor LED<br />Echo cancellation<br />For use with Yealink CP860 full duplex technology<br />Muting the microphones with touchpad<br />Bi-color LED<br />10-feet (3-meters) 120°H voice pickup",
      "SKU": "CP860 Expansion Microphone",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "Primary",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/96e062f3-6c1a-4747-aed3-408692fe340d.jpg"
        },
        {
          "Description": "YEA-CPE80",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/bd664eee-d607-4958-a10c-4157ca89401b.jpg"
        },
        {
          "Description": "YEA-CPE80",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/00b2d5e5-0690-46bf-b6e7-129f397a171c.jpg"
        }
      ],
      "Documents": [
        {
          "Description": "Quick Start Guide_V71",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/7dcd615a-286d-4c60-ae35-4924de17daa5.pdf"
        },
        {
          "Description": "CE Cert",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/3d432408-e732-4a4a-9080-dd183bfec39f.pdf"
        },
        {
          "Description": "Datasheet",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/0b5e5b0b-d040-46f5-9133-738a08055361.pdf"
        }
      ],
      "Relatedproducts": [],
      "Accessories": [
        "YEA-CP860"
      ],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 7,
      "Length": 7,
      "Width": 3,
      "Weight": 0.6,
      "DimensionalAirWeigth": 1.06,
      "DimensionalGroundWeight": 0.89,
      "Features": [
        {
          "Name": "Accessories",
          "Value": "Yes"
        },
        {
          "Name": "No. Accessory/Replacement Microphones",
          "Value": "1"
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": "No"
        },
        {
          "Name": "Recycled Packaging",
          "Value": "No"
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": "Yes"
        },
        {
          "Name": "Type of Packaging",
          "Value": "Retail Box"
        },
        {
          "Name": "Warranty",
          "Value": "1 Year"
        },
        {
          "Name": "Website Link",
          "Value": "http://www.yealink.com/"
        }
      ],
      "Categories": [
        {
          "Name": "Business Equipment",
          "SubCategories": [
            {
              "Name": "Conferencing Equipment"
            }
          ]
        }
      ],
      "PartNumber": "YEA-CPE80",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-CPE80",
      "Manufacturer": "Yealink",
      "ProductName": "CP860 Expansion Microphone",
      "UnitPrice": 25,
      "MSRP": 119,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 189,
      "UPC": "6938818301078"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 0,
      "PriceChangeDate": "2015-03-19T14:55:13.793",
      "ShipmentRecievedDate": "2015-05-16T00:00:00",
      "StandardPrice": 5.5,
      "EnergyStartCompliant": false,
      "ProductDescription": "- Wall mount bracket for T27P and T29G",
      "SKU": "Wall Mount Bracket for T27G, T29G",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-WMB-T2S",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/4c4295c2-b54a-41e9-85ec-61cb44a2e6d3.jpg"
        },
        {
          "Description": "YEA-WMB-T2S",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/cda58e9c-9abf-4aaa-9c84-de9bbe110078.jpg"
        },
        {
          "Description": "Image",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/bbfd39bf-a2d0-4834-96a3-a07bc4d400be.jpg"
        }
      ],
      "Documents": [
        {
          "Description": "T27P Quick Start Guide",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/08cdcf8e-1270-4d6f-9a10-b1419d104dae.pdf"
        },
        {
          "Description": "T27P User Guide",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/9a9a20f1-0c3f-40b5-8b63-156c57fa2567.pdf"
        },
        {
          "Description": "T29G Quick Start Guide",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/181ca11a-1396-4529-a74a-10241fe38fb7.pdf"
        },
        {
          "Description": "Quick Installation Guide",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/452372b4-4fc9-41bf-90ff-ab2ec857b794.pdf"
        }
      ],
      "Relatedproducts": [
        "YEA-SIP-T29G",
        "YEA-STAND-T27-T29"
      ],
      "Accessories": [],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 8,
      "Length": 4,
      "Width": 1,
      "Weight": 0.5,
      "DimensionalAirWeigth": 0.23,
      "DimensionalGroundWeight": 0.19,
      "Features": [
        {
          "Name": "Accessories",
          "Value": "Yes"
        },
        {
          "Name": "Stands, Mounting Equipment, and Cases",
          "Value": "Yes"
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": "No"
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-WMB-T2S",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-WMB-T2S",
      "Manufacturer": "Yealink",
      "ProductName": "Wall Mount Bracket for T27G, T29G",
      "UnitPrice": 5.5,
      "MSRP": 0,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 187,
      "UPC": "841885105240"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 0,
      "PriceChangeDate": "2017-11-21T11:55:11.287",
      "ShipmentRecievedDate": "2015-09-03T00:00:00",
      "StandardPrice": 55.5,
      "EnergyStartCompliant": false,
      "ProductDescription": "- Yealink LCD expansion module<br />- 160x320 graphic LCD with 16-level gray scales<br />- 20 Physical keys each with a dual-color LED<br />- 20 Additional keys through page switch<br />- Supports up to 6 modules daisy-chain<br />- Different icons for each function shown on the LCD<br />- Dial-color LED for status information<br />- Supports busy lamp field, bridge line appearance<br />- Programmable for speed dialing, call pickup, intercom, hold, transfer, voicemail, forward, DND<br />- Applies to Yealink IP phone SIP-T28P and SIP-T26P and SIP-T38G<br />- Expansion module is powered by the host phone<br />- 2xRJ12 (6P6C) ports for data in and out<br />- Weight: 290g",
      "SKU": "1300034 IP Phone Expansion Module Black",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "Primary Image",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/037fd160-a602-452f-b60a-7f3f2278d7b4.jpg"
        },
        {
          "Description": "Secondary Image",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/3da2212f-6828-4f6a-8797-a92924ad01db.jpg"
        },
        {
          "Description": "Yealink Logo",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/77e16fe6-8965-4da2-8407-27a778b451bf.jpg"
        }
      ],
      "Documents": [
        {
          "Description": "Datasheet",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/04d56619-3304-4648-8377-5e97ce486ac2.pdf"
        }
      ],
      "Relatedproducts": [
        "YEA-EXP39",
        "YEA-EXP38",
        "YEA-EXP40"
      ],
      "Accessories": [],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 7,
      "Length": 4,
      "Width": 6,
      "Weight": 1.1,
      "DimensionalAirWeigth": 1.21,
      "DimensionalGroundWeight": 1.01,
      "Features": [
        {
          "Name": "Accessories",
          "Value": "Yes"
        },
        {
          "Name": "Expansion Modules",
          "Value": "Yes"
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": "No"
        },
        {
          "Name": "Recycled Packaging",
          "Value": "Yes"
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": "No"
        },
        {
          "Name": "Type of Packaging",
          "Value": "Retail Box"
        },
        {
          "Name": "Warranty",
          "Value": "1 Year"
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-EXP39-BK",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-EXP39-BK",
      "Manufacturer": "Yealink",
      "ProductName": "1300034 IP Phone Expansion Module Black",
      "UnitPrice": 55.5,
      "MSRP": 0,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 2,
      "UPC": "6938818300729"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 79,
      "PriceChangeDate": "2021-10-01T11:35:03.1",
      "ShipmentRecievedDate": "2015-11-10T00:00:00",
      "StandardPrice": 72.5,
      "EnergyStartCompliant": false,
      "ProductDescription": "- Use with Yealink T27G and T29G SIP Phones<br/>- 20 physical, dual-color LED programmable keys <br/>- 18 additional keys available <br/>- Programmable keys enable users to partake in advanced call functions such as: BFL list, multi-person conferencing, call forwarding, LDAP, XML browser functionality<br/>- Stand with two adjustable angles <br/>- Two or less expansion modules can be powered by the host phone <br/>- Supports up to six modules",
      "SKU": "Yealink IP Phone Expansion T2x Series",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-EXP20",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/cecce34d-502d-47c1-b6a7-3860d0baecd2.jpg"
        },
        {
          "Description": "YEA-EXP20",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/154fd6c5-ba2d-4dc0-9da3-698292bf70e2.jpg"
        },
        {
          "Description": "YEA-EXP20",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/6b630b8b-56fc-4c1d-9257-d5bb2dea578d.jpg"
        }
      ],
      "Documents": [
        {
          "Description": "Quick Start Guide",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/731e2c9a-aecc-4e06-b433-6b65dda0b092.pdf"
        },
        {
          "Description": "User Guide",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/691b85cb-661c-4aaf-b1c0-7d3aa98edf5a.pdf"
        },
        {
          "Description": "Datasheet",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/3c057c93-9f1a-4ba6-9f6a-6ffc00182241.pdf"
        }
      ],
      "Relatedproducts": [
        "YEA-SIP-T27G",
        "YEA-SIP-T29G"
      ],
      "Accessories": [],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 3,
      "Length": 7,
      "Width": 6,
      "Weight": 1.02,
      "DimensionalAirWeigth": 0.91,
      "DimensionalGroundWeight": 0.76,
      "Features": [
        {
          "Name": "Accessories",
          "Value": "Yes"
        },
        {
          "Name": "Expansion Modules",
          "Value": "Yes"
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": "No"
        },
        {
          "Name": "Recycled Packaging",
          "Value": "Yes"
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": "Yes"
        },
        {
          "Name": "Type of Packaging",
          "Value": "Retail Box"
        },
        {
          "Name": "Warranty",
          "Value": "1 Year"
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-EXP20",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-EXP20",
      "Manufacturer": "Yealink",
      "ProductName": "Yealink IP Phone Expansion T2x Series",
      "UnitPrice": 72.5,
      "MSRP": 89,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 3,
      "UPC": "6938818301313"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 26,
      "PriceChangeDate": "2019-09-30T21:15:05.35",
      "ShipmentRecievedDate": "2016-03-14T00:00:00",
      "StandardPrice": 23,
      "EnergyStartCompliant": false,
      "ProductDescription": "- Supports Yealink SIP-T27G, T29G, T46G, T48G, T41S, T42S, T46S, T48S, T42U, T43U, T46U, T48U, T52S, T54S, T53<br/>- For T48G: upgrade to the version of 35.80.0.95 or higher<br/>- For T29G/T46G/T46S/T48S: upgrade to the version 81 or higher<br/>- For T27G: upgrade to the version of 69.81.0.90 or higher<br/>- Reliable Connection<br/>- Ease-of-use<br/>- Plug and Play<br/>- High Transmission Rate<br/>- Lower Power Consumption",
      "SKU": "WiFi USB Dongle",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-WF40",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/43f51842-8da6-4096-b412-667b09bad0fe.jpg"
        },
        {
          "Description": "Yealink Logo",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/b6911380-3489-4730-8355-f0e62c8a9481.jpg"
        }
      ],
      "Documents": [
        {
          "Description": "Specifications",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/920dc750-c45c-430a-bf5e-cf27a2bc8153.pdf"
        },
        {
          "Description": "Manual",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/0b2bcd7a-e9ad-4b6d-8492-b3818d6ffb9a.pdf"
        }
      ],
      "Relatedproducts": [
        "YEA-SIP-T52S",
        "YEA-SIP-T27G",
        "YEA-SIP-T48S",
        "YEA-SIP-T29G"
      ],
      "Accessories": [],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 5,
      "Length": 5,
      "Width": 1,
      "Weight": 0.1,
      "DimensionalAirWeigth": 0.18,
      "DimensionalGroundWeight": 0.15,
      "Features": [
        {
          "Name": "Accessories",
          "Value": "Yes"
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": "No"
        },
        {
          "Name": "Recycled Packaging",
          "Value": "No"
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": "No"
        },
        {
          "Name": "Warranty",
          "Value": "1 Year"
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-WF40",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-WF40",
      "Manufacturer": "Yealink",
      "ProductName": "WiFi USB Dongle",
      "UnitPrice": 23,
      "MSRP": 29,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 591,
      "UPC": "841885103840"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 110,
      "PriceChangeDate": "2023-08-31T17:35:03.613",
      "ShipmentRecievedDate": "2016-06-06T00:00:00",
      "StandardPrice": 75,
      "EnergyStartCompliant": false,
      "ProductDescription": "- W56H Accessory DECT Handset<br/>- Not a stand-alone phone<br/>- Requires W56P base  or the W60B base station to provide network and communications connectivity.<br/>- Not compatible with W52P base station<br/>- Add up to 4 accessory handsets to the W56P base<br/>- Full duplex speakerphone<br/>- 2.4\" 240 x 320 pixel color screen with intuitive user interface<br/>- Headset connection via 3.5mm jack<br/>- Up to 30 hours talk time<br/>- Up to 400 hours standby time<br/>- Also compatible with W52B, W60B, W70B (after upgrade), W80MC, W90MC, VIM",
      "SKU": "Yealink IP DECT Add-on Phone W56H",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "Front",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/d70a8b80-6ccc-4f62-9f71-5a6bf51d1105.jpg"
        },
        {
          "Description": "Left",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/5e533107-91cc-4252-b161-621fdff7cb7a.jpg"
        }
      ],
      "Documents": [
        {
          "Description": "Specifications",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/48f8c039-56ea-4a5f-8143-ed3fcea6b148.pdf"
        },
        {
          "Description": "W56P Brochure",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/170d42a7-8977-42ba-942a-3e918cdc11b3.pdf"
        },
        {
          "Description": "Quick Start Guide",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/a262f032-bf37-4785-a407-dcde6debb384.pdf"
        },
        {
          "Description": "W56P FAQ",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/c9e0b7bb-da8a-450a-90e8-b9482ffec1a8.pdf"
        }
      ],
      "Relatedproducts": [
        "YEA-UH33",
        "YEA-UH36-MONO-UC",
        "YEA-UH36-DUAL-UC"
      ],
      "Accessories": [
        "YEA-W56-BATT",
        "YEA-W56H-BC",
        "YEA-W56H-PC",
        "YEA-W56-USBCHARGER",
        "YEA-BTC-W56",
        "BATT-YLW56H",
        "YEA-WARR-A"
      ],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": true,
      "Height": 4,
      "Length": 8,
      "Width": 3,
      "Weight": 0.85,
      "DimensionalAirWeigth": 0.69,
      "DimensionalGroundWeight": 0.58,
      "Features": [
        {
          "Name": "Accessories",
          "Value": "Yes"
        },
        {
          "Name": "Accessory Handsets",
          "Value": "Yes"
        },
        {
          "Name": "Color",
          "Value": "Silver"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": "No"
        },
        {
          "Name": "Recycled Packaging",
          "Value": "Yes"
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": "Yes"
        },
        {
          "Name": "Type of Packaging",
          "Value": "Retail Box"
        },
        {
          "Name": "Warranty",
          "Value": "1 Year"
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-W56H",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-W56H",
      "Manufacturer": "Yealink",
      "ProductName": "Yealink IP DECT Add-on Phone W56H",
      "UnitPrice": 75,
      "MSRP": 105,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 1000,
      "UPC": "841885104359"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 0,
      "PriceChangeDate": "2016-06-30T10:35:18.377",
      "ShipmentRecievedDate": "2016-08-23T00:00:00",
      "StandardPrice": 5,
      "EnergyStartCompliant": false,
      "ProductDescription": "- Replacement stand for Yealink T41P/T42G T41S/T42S/T43U SIP phones",
      "SKU": "330100000120 Stand for TSP-T42G",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-STAND-T4S",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/c6b3eb46-1082-4cef-aea1-03bc34913971.jpg"
        },
        {
          "Description": "Logo",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/385f4910-2d1b-483a-b35e-fe2a9424a7a1.jpg"
        }
      ],
      "Documents": [],
      "Relatedproducts": [
        "YEA-WMB-T4S",
        "YEA-HNDST-T4S",
        "YEA-STAND-T4S"
      ],
      "Accessories": [],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 7,
      "Length": 4,
      "Width": 1,
      "Weight": 0.1,
      "DimensionalAirWeigth": 0.2,
      "DimensionalGroundWeight": 0.17,
      "Features": [
        {
          "Name": "Accessories",
          "Value": "Yes"
        },
        {
          "Name": "Stands, Mounting Equipment, and Cases",
          "Value": "Yes"
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": "No"
        },
        {
          "Name": "Recycled Packaging",
          "Value": "No"
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": "No"
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-STAND-T4S",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-STAND-T4S",
      "Manufacturer": "Yealink",
      "ProductName": "330100000120 Stand for TSP-T42G",
      "UnitPrice": 5,
      "MSRP": 0,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 151,
      "UPC": "841885112323"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 0,
      "PriceChangeDate": "2016-06-30T11:55:14.25",
      "ShipmentRecievedDate": "2016-08-23T00:00:00",
      "StandardPrice": 5,
      "EnergyStartCompliant": false,
      "ProductDescription": "- Replacement stand for Yealink T46G/S SIP Phone",
      "SKU": "Yealink Stand for T46 series",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-STAND-T46",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/426de89a-d950-45a7-b6e4-c2893405605b.jpg"
        },
        {
          "Description": "Logo",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/caaf4920-23c7-4fcf-b3b2-17ed6fea9c8e.jpg"
        }
      ],
      "Documents": [],
      "Relatedproducts": [
        "YEA-EXP40",
        "YEA-WMB-T46",
        "YEA-HNDST-T46",
        "YEA-SFB-T46G",
        "YEA-STAND-T46",
        "YEA-HC-T46",
        "YEA-100-046-003",
        "YEA-SIP-T46S"
      ],
      "Accessories": [],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 7,
      "Length": 4,
      "Width": 1,
      "Weight": 0.1,
      "DimensionalAirWeigth": 0.2,
      "DimensionalGroundWeight": 0.17,
      "Features": [
        {
          "Name": "Accessories",
          "Value": "Yes"
        },
        {
          "Name": "Stands, Mounting Equipment, and Cases",
          "Value": "Yes"
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": "No"
        },
        {
          "Name": "Recycled Packaging",
          "Value": "No"
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": "No"
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-STAND-T46",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-STAND-T46",
      "Manufacturer": "Yealink",
      "ProductName": "Yealink Stand for T46 series",
      "UnitPrice": 5,
      "MSRP": 0,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 1000,
      "UPC": "841885110992"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 0,
      "PriceChangeDate": "2016-06-30T11:55:14.25",
      "ShipmentRecievedDate": "2016-08-23T00:00:00",
      "StandardPrice": 5,
      "EnergyStartCompliant": false,
      "ProductDescription": "- Replacement Stand for Yealink T48G/S SIP Phone",
      "SKU": "Yealink Stand for T48G/S Phone",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-STAND-T48",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/d1f8cc2a-2250-462f-99dc-59dbdc2d82cc.jpg"
        },
        {
          "Description": "Logo",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/3c8c4a2a-8648-4131-97a3-c2ffac0e5063.jpg"
        }
      ],
      "Documents": [],
      "Relatedproducts": [
        "YEA-EXP40",
        "YEA-HNDST-T46",
        "YEA-WMB-T48",
        "YEA-HNDSTCRD1",
        "YEA-100-048-003",
        "YEA-WMB-T48"
      ],
      "Accessories": [],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 7,
      "Length": 4,
      "Width": 1,
      "Weight": 0.1,
      "DimensionalAirWeigth": 0.2,
      "DimensionalGroundWeight": 0.17,
      "Features": [
        {
          "Name": "Accessories",
          "Value": "Yes"
        },
        {
          "Name": "Stands, Mounting Equipment, and Cases",
          "Value": "Yes"
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": "No"
        },
        {
          "Name": "Recycled Packaging",
          "Value": "No"
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": "No"
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-STAND-T48",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-STAND-T48",
      "Manufacturer": "Yealink",
      "ProductName": "Yealink Stand for T48G/S Phone",
      "UnitPrice": 5,
      "MSRP": 0,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 0,
      "UPC": "841885112958"
    },
    {
      "DisplayStatus": "Discontinued",
      "OpportunityBuy": false,
      "LastStandardPrice": 0,
      "PriceChangeDate": "2016-11-14T09:55:21.723",
      "ShipmentRecievedDate": "2017-01-09T00:00:00",
      "StandardPrice": 22.75,
      "EnergyStartCompliant": false,
      "ProductDescription": "- Yealink Power Supply for T49G, YEA-VP59, YEA-VP59G, VP59, CP920 and CP930",
      "SKU": "Power Supply for Yealink 12-volt 2-amp",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-PSU12V2AMP",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/c6581405-0b43-4ffe-ba32-7d611c1b19b4.jpg"
        }
      ],
      "Documents": [],
      "Relatedproducts": [
        "YEA-SIP-T49G"
      ],
      "Accessories": [],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 3,
      "Length": 2,
      "Width": 2,
      "Weight": 0.5,
      "DimensionalAirWeigth": 0.09,
      "DimensionalGroundWeight": 0.07,
      "Features": [
        {
          "Name": "Accessories",
          "Value": "Yes"
        },
        {
          "Name": "Power Supplies",
          "Value": "Yes"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Recycled Packaging",
          "Value": "Yes"
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "Type of Packaging",
          "Value": "Plastic Bag"
        },
        {
          "Name": "Warranty",
          "Value": "1 Year"
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-PSU12V2AMP",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-PSU12V2AMP",
      "Manufacturer": "Yealink",
      "ProductName": "Power Supply for Yealink 12-volt 2-amp",
      "UnitPrice": 22.75,
      "MSRP": 0,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 0,
      "UPC": "YEA-PSU12V2AMP"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 0,
      "PriceChangeDate": "2017-01-11T15:35:18.85",
      "ShipmentRecievedDate": "2017-02-01T00:00:00",
      "StandardPrice": 5,
      "EnergyStartCompliant": false,
      "ProductDescription": "- Belt clip for W56P and W56H<br/>- Can be attached while protective case is on (YEA-W56H-PC)",
      "SKU": "330100001012 Yealink W56H Belt Clip",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-W56-BC",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/8c668edc-9e45-4cb6-8e10-d84546305085.jpg"
        },
        {
          "Description": "YEA-W56-BC",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/fd588ac0-9a8e-431c-9474-89a826e326bc.jpg"
        },
        {
          "Description": "YEA-W56-BC",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/d6311e04-2f7f-493a-96e1-b8728c272656.jpg"
        }
      ],
      "Documents": [],
      "Relatedproducts": [
        "YEA-W56H",
        "YEA-W56-BATT",
        "YEA-W56-USBCHARGER",
        "YEA-W56H-PC",
        "YEA-W60P"
      ],
      "Accessories": [],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 2,
      "Length": 2,
      "Width": 2,
      "Weight": 0.5,
      "DimensionalAirWeigth": 0.06,
      "DimensionalGroundWeight": 0.05,
      "Features": [
        {
          "Name": "Accessories",
          "Value": "Yes"
        }
      ],
      "EnvironmentalFeatures": [],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "Warranty",
          "Value": "1 Year"
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-W56H-BC",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-W56H-BC",
      "Manufacturer": "Yealink",
      "ProductName": "330100001012 Yealink W56H Belt Clip",
      "UnitPrice": 5,
      "MSRP": 0,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 148,
      "UPC": "841885109927"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 0,
      "PriceChangeDate": "2017-03-30T18:15:19.56",
      "ShipmentRecievedDate": "2017-04-20T00:00:00",
      "StandardPrice": 1,
      "EnergyStartCompliant": false,
      "ProductDescription": "Yealink handset clip for T46/T42/T41",
      "SKU": "Yealink Handset Clip for T46",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-HC-T46",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/e353a360-0895-4e7d-851c-d0b4d9621c8b.jpg"
        }
      ],
      "Documents": [],
      "Relatedproducts": [
        "YEA-HNDSTCRD1",
        "YEA-WMB-T46",
        "YEA-HNDST-T46",
        "YEA-STAND-T46",
        "YEA-SFB-T46G"
      ],
      "Accessories": [],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 0.5,
      "Length": 0.5,
      "Width": 0.25,
      "Weight": 0.001,
      "DimensionalAirWeigth": 0,
      "DimensionalGroundWeight": 0,
      "Features": [
        {
          "Name": "Accessories",
          "Value": "Yes"
        }
      ],
      "EnvironmentalFeatures": [],
      "OtherFeatures": [
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-HC-T46",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-HC-T46",
      "Manufacturer": "Yealink",
      "ProductName": "Yealink Handset Clip for T46",
      "UnitPrice": 1,
      "MSRP": 0,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 185,
      "UPC": "YEA-HC-T46"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 99,
      "PriceChangeDate": "2021-09-30T19:35:03.403",
      "ShipmentRecievedDate": "2017-06-03T00:00:00",
      "StandardPrice": 80,
      "EnergyStartCompliant": false,
      "ProductDescription": "- Compatible with all Yealink T58X series IP Phones<br/>- 5 mega-pixel HD Camera<br/>- 720p@30fps<br/>- Ease-of-use<br/>- Plug and Play<br/>- Adjustable with privacy shutter",
      "SKU": "1300013 5 Mega-pixel HD Cam For T58X",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-CAM50",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/44ea1cb4-f4e5-46fe-86d7-36f518d8c32c.jpg"
        },
        {
          "Description": "YEA-CAM50",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/9fe0c9b3-1695-43a2-8bfb-06765994f400.jpg"
        },
        {
          "Description": "Logo",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/6a317aec-ef53-440e-93e9-c6019edd4e57.jpg"
        }
      ],
      "Documents": [
        {
          "Description": "Datasheet",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/fc3e788b-2fcc-48ca-85f9-6060c0d39279.pdf"
        }
      ],
      "Relatedproducts": [
        "YEA-SIP-T58",
        "YEA-SIP-T58V"
      ],
      "Accessories": [],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 5,
      "Length": 6,
      "Width": 2,
      "Weight": 0.2,
      "DimensionalAirWeigth": 0.43,
      "DimensionalGroundWeight": 0.36,
      "Features": [
        {
          "Name": "Accessories",
          "Value": "Yes"
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "Type of Packaging",
          "Value": "Retail Box"
        },
        {
          "Name": "Warranty",
          "Value": "1 Year"
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-CAM50",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-CAM50",
      "Manufacturer": "Yealink",
      "ProductName": "1300013 5 Mega-pixel HD Cam For T58X",
      "UnitPrice": 80,
      "MSRP": 110,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 62,
      "UPC": "6938818301795"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 95,
      "PriceChangeDate": "2021-11-30T20:55:02.997",
      "ShipmentRecievedDate": "2017-05-22T00:00:00",
      "StandardPrice": 91,
      "EnergyStartCompliant": false,
      "ProductDescription": "- 4.3\" 272 x 480-pixel color screen<br/>- Color icons for rich visual experience<br/>- 20 physical keys on each page with dual-color LEDs<br/>- Three independent control keys with illuminated LED for fast switching pages<br/>- Supports up to 3 modules daisy-chain<br/>- Stand with 2 adjustable angles<br/>- Applies to Yealink T5 Series (SIP-T58V/SIP-T58A/SIP-T56A/SIP-T54S/SIP-T52S/T53/T53W/T54W/T57W/T58W/VP59/MP56/MP58)",
      "SKU": "Yealink T5 series Expansion Module",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-EXP50",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/02a94a4a-890f-4943-ba30-4efe1fac07bc.jpg"
        },
        {
          "Description": "YEA-EXP50",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/0922711e-c8bc-453b-a938-610ec5a51a9e.jpg"
        },
        {
          "Description": "YEA-EXP50",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/e3d1e19c-69fe-4eb2-b94e-500408146004.jpg"
        }
      ],
      "Documents": [
        {
          "Description": "Quick Start Guide",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/71615bb1-1dbe-4b48-8713-11503a8b13f1.pdf"
        },
        {
          "Description": "User Guide",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/74a983b8-9eb5-4134-9ccb-56e931e2d2d4.pdf"
        },
        {
          "Description": "Datasheet",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/2a1d4eca-f766-44b4-b7e2-e982eaf7e3a6.pdf"
        }
      ],
      "Relatedproducts": [
        "YEA-SIP-T58",
        "YEA-SIP-T56A",
        "YEA-SIP-T54S",
        "YEA-SIP-T52S",
        "YEA-SIP-T58V",
        "YEA-EXP20",
        "YEA-EXP38",
        "YEA-EXP39",
        "YEA-EXP39-BK",
        "YEA-EXP40"
      ],
      "Accessories": [],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 4,
      "Length": 9,
      "Width": 6,
      "Weight": 1.52,
      "DimensionalAirWeigth": 1.55,
      "DimensionalGroundWeight": 1.3,
      "Features": [
        {
          "Name": "Accessories",
          "Value": "Yes"
        },
        {
          "Name": "Expansion Modules",
          "Value": "Yes"
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "Type of Packaging",
          "Value": "Retail Box"
        },
        {
          "Name": "Warranty",
          "Value": "1 Year"
        },
        {
          "Name": "Website Link",
          "Value": "http://www.yealink.com/"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-EXP50",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-EXP50",
      "Manufacturer": "Yealink",
      "ProductName": "Yealink T5 series Expansion Module",
      "UnitPrice": 91,
      "MSRP": 105,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 878,
      "UPC": "841885103710"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 0,
      "PriceChangeDate": "2017-07-06T08:35:10.98",
      "ShipmentRecievedDate": "2017-08-21T00:00:00",
      "StandardPrice": 5.5,
      "EnergyStartCompliant": false,
      "ProductDescription": "- Yealink Wall Bracket compatible with SIP-T52S/T54S/T56A/T58V/T58A/T57W/MP58-TEAMS",
      "SKU": "330100000033 WMB T56 T57 T58 T58W",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-WMB-T5S",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/7b64b3eb-ca11-419b-9261-a048aaf714c3.jpg"
        }
      ],
      "Documents": [],
      "Relatedproducts": [
        "YEA-SIP-T52S",
        "YEA-SIP-T54S"
      ],
      "Accessories": [],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 6,
      "Length": 3,
      "Width": 1,
      "Weight": 0.5,
      "DimensionalAirWeigth": 0.13,
      "DimensionalGroundWeight": 0.11,
      "Features": [
        {
          "Name": "Accessories",
          "Value": "Yes"
        },
        {
          "Name": "Stands, Mounting Equipment, and Cases",
          "Value": "Yes"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": null
        },
        {
          "Name": "Warranty",
          "Value": "1 Year"
        },
        {
          "Name": "Website Link",
          "Value": "http://www.yealink.com/"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-WMB-T5S",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-WMB-T5S",
      "Manufacturer": "Yealink",
      "ProductName": "330100000033 WMB T56 T57 T58 T58W",
      "UnitPrice": 5.5,
      "MSRP": 0,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 1000,
      "UPC": "841885105134"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 0,
      "PriceChangeDate": "2017-07-13T11:55:11.173",
      "ShipmentRecievedDate": "2017-09-02T00:00:00",
      "StandardPrice": 15,
      "EnergyStartCompliant": false,
      "ProductDescription": "- Handset for MP56/MP58/T58W/T57W/T56A/T58",
      "SKU": "Handset for T57W/T56A/T58A",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-HNDST-T5X",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/2b1d1174-f7b0-4c24-9241-9011a657d0b8.jpg"
        },
        {
          "Description": "Yealink Logo",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/fd1d15b0-218d-4184-b5e0-957837d4ccd6.jpg"
        }
      ],
      "Documents": [],
      "Relatedproducts": [
        "YEA-SIP-T52S",
        "YEA-SIP-T54S",
        "YEA-SIP-T56A",
        "YEA-SIP-T58",
        "YEA-SIP-T58V",
        "YEA-HNDSTCRD5",
        "YEA-STAND-T52",
        "YEA-STAND-T54",
        "YEA-WMB-T5S"
      ],
      "Accessories": [],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 8,
      "Length": 3,
      "Width": 2,
      "Weight": 0.7,
      "DimensionalAirWeigth": 0.35,
      "DimensionalGroundWeight": 0.29,
      "Features": [
        {
          "Name": "Accessories",
          "Value": "Yes"
        },
        {
          "Name": "Replacement Handsets",
          "Value": "Yes"
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": null
        },
        {
          "Name": "Warranty",
          "Value": "1 Year"
        },
        {
          "Name": "Website Link",
          "Value": "http://www.yealink.com/"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-HNDST-T5X",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-HNDST-T5X",
      "Manufacturer": "Yealink",
      "ProductName": "Handset for T57W/T56A/T58A",
      "UnitPrice": 15,
      "MSRP": 0,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 401,
      "UPC": "841885111944"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 0,
      "PriceChangeDate": "2017-07-13T11:35:11.077",
      "ShipmentRecievedDate": "2017-09-02T00:00:00",
      "StandardPrice": 5,
      "EnergyStartCompliant": false,
      "ProductDescription": "Yealink Spiral Cord for all T5X and T4X phones",
      "SKU": "Universal spiral cord T5X, T4X T3X T2X",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-HNDSTCRD5",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/4820db50-c364-408a-8bd8-c79c08e2acc6.jpg"
        },
        {
          "Description": "YEA-HNDSTCRD5",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/36bb5e44-ebd0-4448-a572-9a6f360f220c.jpg"
        },
        {
          "Description": "Logo",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/bf31ae2d-3a56-490d-b1e2-22811ea5595a.jpg"
        }
      ],
      "Documents": [],
      "Relatedproducts": [
        "YEA-SIP-T52S",
        "YEA-SIP-T54S",
        "YEA-SIP-T56A",
        "YEA-SIP-T58",
        "YEA-SIP-T58V"
      ],
      "Accessories": [],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 5,
      "Length": 5,
      "Width": 5,
      "Weight": 0.1,
      "DimensionalAirWeigth": 0.9,
      "DimensionalGroundWeight": 0.75,
      "Features": [
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": null
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": "Plastic Bag"
        },
        {
          "Name": "Warranty",
          "Value": "1 Year"
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-HNDSTCRD5",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-HNDSTCRD5",
      "Manufacturer": "Yealink",
      "ProductName": "Universal spiral cord T5X, T4X T3X T2X",
      "UnitPrice": 5,
      "MSRP": 0,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 0,
      "UPC": "841885111180"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 0,
      "PriceChangeDate": "2017-07-13T11:35:11.077",
      "ShipmentRecievedDate": "2017-09-02T00:00:00",
      "StandardPrice": 5,
      "EnergyStartCompliant": false,
      "ProductDescription": "- Stand for T52 Phone",
      "SKU": "Yealink Stand for T52 phone",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-STAND-T52",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/17f94318-dcdd-418d-85e6-7c4d62b09d16.jpg"
        }
      ],
      "Documents": [],
      "Relatedproducts": [
        "YEA-HNDST-T5X",
        "YEA-SIP-T52S"
      ],
      "Accessories": [],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 5,
      "Length": 5,
      "Width": 5,
      "Weight": 0.1,
      "DimensionalAirWeigth": 0.9,
      "DimensionalGroundWeight": 0.75,
      "Features": [
        {
          "Name": "Accessories",
          "Value": "Yes"
        },
        {
          "Name": "Stands, Mounting Equipment, and Cases",
          "Value": "Yes"
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": "No"
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": "No"
        },
        {
          "Name": "Type of Packaging",
          "Value": null
        },
        {
          "Name": "Warranty",
          "Value": null
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-STAND-T52",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-STAND-T52",
      "Manufacturer": "Yealink",
      "ProductName": "Yealink Stand for T52 phone",
      "UnitPrice": 5,
      "MSRP": 0,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 12,
      "UPC": "YEA-STAND-T5X"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 0,
      "PriceChangeDate": "2017-07-13T17:55:09.933",
      "ShipmentRecievedDate": "2017-09-02T00:00:00",
      "StandardPrice": 5,
      "EnergyStartCompliant": false,
      "ProductDescription": "Stand  for T27 and T29 models",
      "SKU": "330100000112 Stand for T27 and T29 model",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-STAND-T27-T29",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/fd676610-5440-477e-b738-f2d1b1d156d2.jpg"
        },
        {
          "Description": "YEA-STAND-T27-T29",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/6664d32d-e47f-472b-8a77-97083e9774fb.jpg"
        }
      ],
      "Documents": [],
      "Relatedproducts": [
        "YEA-HC-T27-T29",
        "YEA-HNDST6",
        "YEA-WMB-T2S",
        "YEA-SIP-T27G",
        "YEA-SIP-T29G"
      ],
      "Accessories": [],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 5,
      "Length": 5,
      "Width": 5,
      "Weight": 0.1,
      "DimensionalAirWeigth": 0.9,
      "DimensionalGroundWeight": 0.75,
      "Features": [
        {
          "Name": "Accessories",
          "Value": "Yes"
        },
        {
          "Name": "Stands, Mounting Equipment, and Cases",
          "Value": "Yes"
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": null
        },
        {
          "Name": "Warranty",
          "Value": null
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-STAND-T27-T29",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-STAND-T27-T29",
      "Manufacturer": "Yealink",
      "ProductName": "330100000112 Stand for T27 and T29 model",
      "UnitPrice": 5,
      "MSRP": 0,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 0,
      "UPC": "YEA-STAND-T27-T"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 0,
      "PriceChangeDate": "2017-07-13T17:55:09.933",
      "ShipmentRecievedDate": "2017-09-02T00:00:00",
      "StandardPrice": 10,
      "EnergyStartCompliant": false,
      "ProductDescription": "- Yealink W56P USB Charging dock<br/>- Needs a adapter for wall outlet 5v 600ma usb/ac adapter. Can be purchased online. ",
      "SKU": "CCD-W56H Yealink W56P USB Charging dock",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-W56-USBCHARGER",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/5db4391f-8fd1-4da4-8633-d514edf492f8.jpg"
        },
        {
          "Description": "YEA-W56-USBCHARGER",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/47af9ea2-06d8-4e9f-b71c-bde58dd9f4b5.jpg"
        },
        {
          "Description": "Logo",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/ac20e013-da9a-4eb5-bc3a-6b05fc25a01b.jpg"
        }
      ],
      "Documents": [],
      "Relatedproducts": [
        "YEA-W56-BATT",
        "YEA-W56H-BC",
        "YEA-W56H-PC",
        "YEA-W56P",
        "YEA-W60P"
      ],
      "Accessories": [],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 5,
      "Length": 5,
      "Width": 5,
      "Weight": 0.7,
      "DimensionalAirWeigth": 0.9,
      "DimensionalGroundWeight": 0.75,
      "Features": [
        {
          "Name": "Accessories",
          "Value": "Yes"
        },
        {
          "Name": "Power Supplies",
          "Value": "Yes"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": null
        },
        {
          "Name": "Warranty",
          "Value": "1 Year"
        },
        {
          "Name": "Website Link",
          "Value": "http://www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-W56-USBCHARGER",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-W56-USBCHARGER",
      "Manufacturer": "Yealink",
      "ProductName": "CCD-W56H Yealink W56P USB Charging dock",
      "UnitPrice": 10,
      "MSRP": 0,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 189,
      "UPC": "841885111357"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 53,
      "PriceChangeDate": "2019-09-30T21:15:05.35",
      "ShipmentRecievedDate": "2017-08-02T00:00:00",
      "StandardPrice": 29,
      "EnergyStartCompliant": false,
      "ProductDescription": "- AC PoE injector<br/>Suitable for Yealink CP925, CP960, CP965, VP59G<br/>- Package contents include: - poe injector - Ethernet Cable and Power cord",
      "SKU": "330000030000 PoE Adapter for CP925&CP965",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-YLPOE30",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/3e659550-ff52-4f7f-88ac-220b25adcd3b.jpg"
        },
        {
          "Description": "Logo",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/ff81b09f-d68e-42c3-a269-eeb5e114e95c.jpg"
        }
      ],
      "Documents": [
        {
          "Description": "Specifications",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/7b839241-5385-4217-9d3f-4036ce2c4fff.pdf"
        }
      ],
      "Relatedproducts": [
        "YEA-CP960",
        "YEA-CP960-WM",
        "YEA-CP925"
      ],
      "Accessories": [],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 7.5,
      "Length": 4.5,
      "Width": 5,
      "Weight": 1.1,
      "DimensionalAirWeigth": 1.21,
      "DimensionalGroundWeight": 1.02,
      "Features": [
        {
          "Name": "Accessories",
          "Value": "Yes"
        },
        {
          "Name": "No. Accessory/Replacement Microphones",
          "Value": null
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": "Yes"
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": "Yes"
        },
        {
          "Name": "Type of Packaging",
          "Value": "Brown Box"
        },
        {
          "Name": "Warranty",
          "Value": null
        },
        {
          "Name": "Website Link",
          "Value": "http://www.yealink.com/"
        }
      ],
      "Categories": [
        {
          "Name": "Business Equipment",
          "SubCategories": [
            {
              "Name": "Conferencing Equipment"
            }
          ]
        }
      ],
      "PartNumber": "YEA-YLPOE30",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-YLPOE30",
      "Manufacturer": "Yealink",
      "ProductName": "330000030000 PoE Adapter for CP925&CP965",
      "UnitPrice": 29,
      "MSRP": 59,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 511,
      "UPC": "841885103864"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 18,
      "PriceChangeDate": "2019-09-30T21:15:05.35",
      "ShipmentRecievedDate": "2017-09-06T00:00:00",
      "StandardPrice": 14.5,
      "EnergyStartCompliant": false,
      "ProductDescription": "- Used in combination with the Yealink Conference phone, the CPN10 is a PSTN box designed for those using Public Switched Telephone Network (PSTN)<br/>- Utilizing the CPN10 enables support for conference calls based on both SIP protocol and analogue<br/>- USB call recording<br/>- Support up to 2 cascaded CPN10<br/>- Support both SIP and PSTN modes<br/>- Linkage to mobile phones or PCs",
      "SKU": "PSTN box for Yealink conference phones",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-CPN10",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/9b08fadc-a80b-4a0b-a5ca-daffe5ef4918.jpg"
        },
        {
          "Description": "YEA-CPN10",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/3124f38c-f89f-4707-b0a7-5f15477fbf19.jpg"
        },
        {
          "Description": "Logo",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/6dbfc27a-2d50-4e29-8214-c37be27ba03e.jpg"
        }
      ],
      "Documents": [],
      "Relatedproducts": [
        "YEA-CP860"
      ],
      "Accessories": [],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 5,
      "Length": 3.5,
      "Width": 1.5,
      "Weight": 0.25,
      "DimensionalAirWeigth": 0.19,
      "DimensionalGroundWeight": 0.16,
      "Features": [
        {
          "Name": "Accessories",
          "Value": "Yes"
        },
        {
          "Name": "No. Accessory/Replacement Microphones",
          "Value": null
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": "Retail Box"
        },
        {
          "Name": "Warranty",
          "Value": "1 Year"
        },
        {
          "Name": "Website Link",
          "Value": "http://www.yealink.com/"
        }
      ],
      "Categories": [
        {
          "Name": "Business Equipment",
          "SubCategories": [
            {
              "Name": "Conferencing Equipment"
            }
          ]
        }
      ],
      "PartNumber": "YEA-CPN10",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-CPN10",
      "Manufacturer": "Yealink",
      "ProductName": "PSTN box for Yealink conference phones",
      "UnitPrice": 14.5,
      "MSRP": 20,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 83,
      "UPC": "6938818301528"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 0,
      "PriceChangeDate": "2023-05-23T12:55:03.707",
      "ShipmentRecievedDate": "2017-10-09T00:00:00",
      "StandardPrice": 275,
      "EnergyStartCompliant": false,
      "ProductDescription": "- Optimal HD audio, full duplex technology<br/>- Yealink Noise Proof Technology<br/>- 20-foot (6-meter) and 360-degree voice pickup<br/>- Built-in 3-microphone array<br/>- Sensitive touch keypad<br/>- 3.1” 248x120-pixel graphical LCD with backlight<br/>- Power over Ethernet<br/>- Includes Power Supply<br/>- 5-way conference call<br/>- Hybrid UC meeting<br/>- Built-in Wi-Fi (2.4GHz, 802.11.b/g/n)<br/>- Built-in Bluetooth 4.0<br/>- Local USB call recording",
      "SKU": "1304002 Touch-sensitive HD IP Conference",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-CP920",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/c1445692-d0c4-4091-a352-5a5cd1bb47a0.jpg"
        },
        {
          "Description": "YEA-CP920",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/8a4e9c1d-cac7-425d-bf20-ec0b43026fa1.jpg"
        },
        {
          "Description": "YEA-CP920",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/f1248fb2-ce5a-4a8f-887e-46c03a3ce2df.jpg"
        }
      ],
      "Documents": [
        {
          "Description": "Data Sheet",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/eec6a44c-5eee-4d44-9f61-6b2faa0b04d4.pdf"
        },
        {
          "Description": "Flyer",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/0d1371f7-c6f8-4fac-bf1f-a33d437c24ed.pdf"
        },
        {
          "Description": "User Guide",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/95b46d7f-f877-4b25-9a72-b7bc447bdf6e.pdf"
        }
      ],
      "Relatedproducts": [
        "YEA-CP960",
        "YEA-CP960-WM"
      ],
      "Accessories": [
        "YEA-CPN10",
        "YEA-YLPOE30",
        "E911-STICKER",
        "YEA-WARR-D_OLD",
        "YEA-PSU12V1AMP",
        "YEA-USB2-2-5M",
        "YEA-USB2-7M",
        "YEA-USB2-EXT-10M",
        "YEA-USB2-EXT-20M",
        "YEA-USB2-EXT-5M",
        "YEA-USB2CAT5E-EXT",
        "YEA-USBC-HDMI"
      ],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": true,
      "Height": 5,
      "Length": 13,
      "Width": 14,
      "Weight": 3.75,
      "DimensionalAirWeigth": 6.55,
      "DimensionalGroundWeight": 5.48,
      "Features": [
        {
          "Name": "3-Way Calling",
          "Value": "Yes"
        },
        {
          "Name": "Accessories",
          "Value": null
        },
        {
          "Name": "Bluetooth",
          "Value": "Yes"
        },
        {
          "Name": "Call Hold",
          "Value": "Yes"
        },
        {
          "Name": "Call Recording",
          "Value": "Yes"
        },
        {
          "Name": "Echo Cancellation",
          "Value": "Yes"
        },
        {
          "Name": "Full Duplex Speakerphone",
          "Value": "Yes"
        },
        {
          "Name": "LCD Display",
          "Value": "Yes"
        },
        {
          "Name": "Multiple Languages",
          "Value": "Yes"
        },
        {
          "Name": "Mute",
          "Value": "Yes"
        },
        {
          "Name": "No. Accessory/Replacement Microphones",
          "Value": null
        },
        {
          "Name": "Power Supplies",
          "Value": null
        },
        {
          "Name": "Touchscreen",
          "Value": "Yes"
        },
        {
          "Name": "Wireless/IP Base Stations",
          "Value": null
        },
        {
          "Name": "Color",
          "Value": "Silver"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": null
        },
        {
          "Name": "Warranty",
          "Value": "1 Year"
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "Business Equipment",
          "SubCategories": [
            {
              "Name": "Conferencing Equipment"
            }
          ]
        }
      ],
      "PartNumber": "YEA-CP920",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-CP920",
      "Manufacturer": "Yealink",
      "ProductName": "1304002 Touch-sensitive HD IP Conference",
      "UnitPrice": 275,
      "MSRP": 599,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 197,
      "UPC": "841885103598"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 26,
      "PriceChangeDate": "2021-10-01T11:35:03.1",
      "ShipmentRecievedDate": "2018-04-27T00:00:00",
      "StandardPrice": 26.55,
      "EnergyStartCompliant": false,
      "ProductDescription": "The Yealink DECT dongle DD10K not only enables T41S / T42S to work concurrently with Yealink DECT system as a handset after pairing with Yealink W60B DECT IP base station, but also enables T53 / T53W / T54W / T57W / T58A / VP59 to work as a base station, which can be registered with up to 4 compatible Yealink W52H/W56H/W53H handsets.<br/>- Register with up to 4 compatible Yealink W52H/W56H/W53H handsets<br/>- *DD10K allows the T5 series to add up to 4 DECT cordless handsets*<br/>- Only the T54W supports BLF in DECT mode",
      "SKU": "Yealink DECT Dongle DD10K",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-DD10K",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/4885ea84-cd47-47d4-bcee-46f603168c9a.jpg"
        }
      ],
      "Documents": [],
      "Relatedproducts": [
        "YEA-SIP-T41S",
        "YEA-SIP-T42S",
        "YEA-SIP-T53",
        "YEA-SIP-T53W",
        "YEA-SIP-T54W",
        "YEA-SIP-T56A",
        "YEA-SIP-T57W",
        "YEA-SIP-T58A"
      ],
      "Accessories": [],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": true,
      "Height": 2.6,
      "Length": 5.5,
      "Width": 3,
      "Weight": 0.1,
      "DimensionalAirWeigth": 0.31,
      "DimensionalGroundWeight": 0.26,
      "Features": [
        {
          "Name": "Accessories",
          "Value": "Yes"
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": null
        },
        {
          "Name": "Warranty",
          "Value": null
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-DD10K",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-DD10K",
      "Manufacturer": "Yealink",
      "ProductName": "Yealink DECT Dongle DD10K",
      "UnitPrice": 26.55,
      "MSRP": 29,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 105,
      "UPC": "6938818302105"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 158,
      "PriceChangeDate": "2023-10-02T16:35:06.14",
      "ShipmentRecievedDate": "2018-05-07T00:00:00",
      "StandardPrice": 127,
      "EnergyStartCompliant": false,
      "ProductDescription": "- Compatible with DECT CAT-iq 2.0<br />- Compatible with Yealink W60B DECT IP Base Station<br />- Up to 6 repeaters per base station<br />- Star connection<br />- Up to 2 repeaters can be arranged in cascade<br />- Auto association<br />- Support HD voice calls<br />- Plug & play setup<br />- Clear status LED display<br />- Elegant Design<br />- Wall Mountable<br/>- Compatible with W52P, W56P, W73P, W76P, W77P, W78P, W79P, W60P, W60B and W70B",
      "SKU": "Yealink DECT repeater RT30",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/a4b8b028-b220-4d33-9ee9-9f25bf64777c.jpg"
        },
        {
          "Description": "YEA-RT30",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/f6a2c9b5-cbdf-4a4b-834a-8cf6b330dcd1.jpg"
        }
      ],
      "Documents": [
        {
          "Description": "Datasheet",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/230049f5-0d9e-4e1d-8ef7-48716e2a2fc7.pdf"
        },
        {
          "Description": "User Guide",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/05e8aea8-de52-45b8-9928-b4be1018c510.pdf"
        }
      ],
      "Relatedproducts": [
        "YEA-W60B",
        "YEA-W73P",
        "YEA-W76P",
        "YEA-W77P",
        "YEA-W78P",
        "YEA-W79P",
        "YEA-W60P",
        "YEA-W70B"
      ],
      "Accessories": [
        "YEA-W56H",
        "YEA-W52H",
        "YEA-SIP-T41S"
      ],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 7,
      "Length": 7,
      "Width": 2.5,
      "Weight": 1,
      "DimensionalAirWeigth": 0.88,
      "DimensionalGroundWeight": 0.74,
      "Features": [
        {
          "Name": "Range",
          "Value": null
        },
        {
          "Name": "Color",
          "Value": "Silver"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": "No"
        },
        {
          "Name": "Recycled Packaging",
          "Value": "No"
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": "No"
        },
        {
          "Name": "Type of Packaging",
          "Value": "Retail Box"
        },
        {
          "Name": "Warranty",
          "Value": "1 Year"
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "IP Phone System Accessories"
            }
          ]
        }
      ],
      "PartNumber": "YEA-RT30",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-RT30",
      "Manufacturer": "Yealink",
      "ProductName": "Yealink DECT repeater RT30",
      "UnitPrice": 127,
      "MSRP": 175,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 240,
      "UPC": "841885104236"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 0,
      "PriceChangeDate": "2018-07-26T15:55:05.28",
      "ShipmentRecievedDate": "2018-08-31T00:00:00",
      "StandardPrice": 15,
      "EnergyStartCompliant": false,
      "ProductDescription": "Handset for T53/T53W/T54W/T54S/T52S",
      "SKU": "220108100002 T53 / T53W / T54W MP54",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-HNDST-T52-T54",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/99f3cd8d-45a6-4f24-9068-ce7f2465d0b8.jpg"
        }
      ],
      "Documents": [],
      "Relatedproducts": [
        "YEA-SIP-T52S",
        "YEA-SIP-T54S",
        "YEA-SIP-T54W"
      ],
      "Accessories": [],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 8,
      "Length": 3,
      "Width": 2,
      "Weight": 0.7,
      "DimensionalAirWeigth": 0.35,
      "DimensionalGroundWeight": 0.29,
      "Features": [
        {
          "Name": "Replacement Handsets",
          "Value": "Yes"
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": null
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": null
        },
        {
          "Name": "Warranty",
          "Value": "1 Year"
        },
        {
          "Name": "Website Link",
          "Value": "http://www.yealink.com/"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-HNDST-T53-T54",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-HNDST-T53-T54",
      "Manufacturer": "Yealink",
      "ProductName": "220108100002 T53 / T53W / T54W MP54",
      "UnitPrice": 15,
      "MSRP": 0,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 31,
      "UPC": "841885111937"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 26,
      "PriceChangeDate": "2021-09-30T19:55:03.3",
      "ShipmentRecievedDate": "2018-09-19T00:00:00",
      "StandardPrice": 26,
      "EnergyStartCompliant": false,
      "ProductDescription": "- Compatible with Yealink SIP-T42U/T43U/T46U//T48U (108.86.0.70 or later) T53 (96.86.0.70 or Later) IP Phone (Version 86)<br/>- Dual-Band Connectivity<br/>- High Transmission Rate<br/>- Interference Free<br/>- Reliable Connection<br/>- Easy to Use<br/>- Plug and Play",
      "SKU": "Dual Band WiFi USB Dongle",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-WF50",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/f94d6ab4-1e38-4c10-a04e-a11844121d14.jpg"
        }
      ],
      "Documents": [
        {
          "Description": "User Guide",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/b0449ac6-965c-4248-a8ce-f35dc2d2bfb9.pdf"
        }
      ],
      "Relatedproducts": [
        "YEA-SIP-T27G",
        "YEA-SIP-T41S",
        "YEA-SIP-T42S",
        "YEA-SIP-T46S",
        "YEA-SIP-T48S"
      ],
      "Accessories": [],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 2.75,
      "Length": 5.5,
      "Width": 1.75,
      "Weight": 0.1,
      "DimensionalAirWeigth": 0.19,
      "DimensionalGroundWeight": 0.16,
      "Features": [
        {
          "Name": "Accessories",
          "Value": "Yes"
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": "Retail Box"
        },
        {
          "Name": "Warranty",
          "Value": "1 Year"
        },
        {
          "Name": "Website Link",
          "Value": "http://www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-WF50",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-WF50",
      "Manufacturer": "Yealink",
      "ProductName": "Dual Band WiFi USB Dongle",
      "UnitPrice": 26,
      "MSRP": 29,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 117,
      "UPC": "841885103857"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 0,
      "PriceChangeDate": "2018-10-16T08:55:03.463",
      "ShipmentRecievedDate": "2018-12-20T00:00:00",
      "StandardPrice": 5,
      "EnergyStartCompliant": false,
      "ProductDescription": "Yealink stand for T56A",
      "SKU": "330100000135 Stand for T56 models",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-STAND-T56",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/5501f216-00aa-41a6-af62-8657d02afc42.jpg"
        }
      ],
      "Documents": [],
      "Relatedproducts": [
        "YEA-100-056-003",
        "YEA-SIP-T56A"
      ],
      "Accessories": [],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 1,
      "Length": 8,
      "Width": 5.5,
      "Weight": 0.1,
      "DimensionalAirWeigth": 0.32,
      "DimensionalGroundWeight": 0.27,
      "Features": [
        {
          "Name": "Accessories",
          "Value": "Yes"
        },
        {
          "Name": "Stands, Mounting Equipment, and Cases",
          "Value": "Yes"
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": null
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": null
        },
        {
          "Name": "Warranty",
          "Value": "China"
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-STAND-T56",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-STAND-T56",
      "Manufacturer": "Yealink",
      "ProductName": "330100000135 Stand for T56 models",
      "UnitPrice": 5,
      "MSRP": 0,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 22,
      "UPC": "YEASTANDT56"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 0,
      "PriceChangeDate": "2018-10-16T09:15:06.697",
      "ShipmentRecievedDate": "2018-12-20T00:00:00",
      "StandardPrice": 5,
      "EnergyStartCompliant": false,
      "ProductDescription": "- Yealink stand for T57W, T58A, T58V, T58-CAM, T58W, T58WX",
      "SKU": "330100000133 Stand for T58A/T58-CAM/T57W",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-STAND-T58",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/712ba699-3ac0-414b-a3d3-9febba7e06b5.jpg"
        }
      ],
      "Documents": [],
      "Relatedproducts": [
        "YEA-100-058-003",
        "YEA-SIP-T58",
        "YEA-SIP-T58V"
      ],
      "Accessories": [],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 1,
      "Length": 9,
      "Width": 5.5,
      "Weight": 0.1,
      "DimensionalAirWeigth": 0.36,
      "DimensionalGroundWeight": 0.3,
      "Features": [
        {
          "Name": "Accessories",
          "Value": "Yes"
        },
        {
          "Name": "Stands, Mounting Equipment, and Cases",
          "Value": "Yes"
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": null
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": null
        },
        {
          "Name": "Warranty",
          "Value": "China"
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-STAND-T58",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-STAND-T58",
      "Manufacturer": "Yealink",
      "ProductName": "330100000133 Stand for T58A/T58-CAM/T57W",
      "UnitPrice": 5,
      "MSRP": 0,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 99,
      "UPC": "YEASTANDT58"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 199,
      "PriceChangeDate": "2024-01-31T17:15:04.46",
      "ShipmentRecievedDate": "2019-01-31T00:00:00",
      "StandardPrice": 105,
      "EnergyStartCompliant": false,
      "ProductDescription": "- Entry-level phone, well suited for common workspace<br/>- 3.7\" 360x160-pixel graphical display, fully adjustable<br/>- HD Voice with Yealink Acoustic Shield technology<br/>- 8 line keys, 12 SIP accounts, 21 memory keys<br/>- Built-in Bluetooth, Wi-Fi<br/>- Dual-port Gigabit Ethernet<br/>- 1xUSB port for call recording and wireless USB headset<br/>- YEA-CP930W can be connected to the phones withthe YEA-DD10K dect dongle<br/>- Power supply not included",
      "SKU": "SIP-T53W Prime Business Phone",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-SIP-T53W",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/3718098e-a879-4218-a11e-0ff3aee69a36.jpg"
        },
        {
          "Description": "YEA-SIP-T53W",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/8ed98391-152d-42cc-9cd1-2c3fb766a824.jpg"
        },
        {
          "Description": "YEA-SIP-T53W",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/57eb511c-a26b-4b61-84d7-046b24372346.jpg"
        }
      ],
      "Documents": [
        {
          "Description": "Datasheet",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/8e9378f6-a072-4feb-ad34-33f70d0a5e22.pdf"
        }
      ],
      "Relatedproducts": [
        "YEA-SIP-T53",
        "YEA-SIP-T54S",
        "YEA-SIP-T54W",
        "YEA-SIP-T56A",
        "YEA-SIP-T57W",
        "YEA-SIP-T58",
        "YEA-SIP-T58A"
      ],
      "Accessories": [
        "YEA-WMB-T5W",
        "YEA-EXP50",
        "YEA-STAND-T53",
        "YEA-CP700-TEAMS",
        "YEA-CP700-BT-TEAMS",
        "YEA-CP900-TEAMS",
        "YEA-CP900-BT-TEAMS",
        "YEA-PS5V1200US",
        "YEA-WH62-DUAL-TEAMS",
        "YEA-WH62-DUAL-UC",
        "YEA-WH62-MONO-TEAMS",
        "YEA-WH62-MONO-UC",
        "YEA-WH63-TEAMS",
        "YEA-WH63-UC",
        "YEA-WH66-DUAL-TEAMS",
        "YEA-WH66-DUAL-UC",
        "YEA-WH67-TEAMS",
        "YEA-WH67-UC",
        "YEA-UH36-DUAL-TEAMS",
        "YEA-UH36-DUAL-UC",
        "YEA-UH36-MONO-TEAMS",
        "YEA-UH36-MONO-UC",
        "YEA-EHS40",
        "YEA-HC-T58",
        "YEA-HNDST-T53-T54",
        "YEA-WARR-B"
      ],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": true,
      "Height": 9.5,
      "Length": 9.5,
      "Width": 4.5,
      "Weight": 2.6,
      "DimensionalAirWeigth": 2.92,
      "DimensionalGroundWeight": 2.45,
      "Features": [
        {
          "Name": "Bluetooth",
          "Value": "Yes"
        },
        {
          "Name": "Call Waiting",
          "Value": "Yes"
        },
        {
          "Name": "Caller ID (CID)",
          "Value": "Yes"
        },
        {
          "Name": "Conference Calling",
          "Value": "Yes"
        },
        {
          "Name": "Corded or Cordless",
          "Value": "Corded"
        },
        {
          "Name": "Ethernet Ports",
          "Value": "2"
        },
        {
          "Name": "Headset Port",
          "Value": "Yes"
        },
        {
          "Name": "LCD Backlit Display",
          "Value": "Yes"
        },
        {
          "Name": "Number SIP Accounts/Identities",
          "Value": "10+"
        },
        {
          "Name": "Power Source",
          "Value": "PoE and AC Adapter"
        },
        {
          "Name": "SIP or Proprietary IP",
          "Value": "SIP Phones"
        },
        {
          "Name": "Speakerphone",
          "Value": "Yes"
        },
        {
          "Name": "Voicemail",
          "Value": "Yes"
        },
        {
          "Name": "Wall Mountable",
          "Value": "Yes"
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": "Retail Box"
        },
        {
          "Name": "Warranty",
          "Value": "1 Year"
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-SIP-T53W",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-SIP-T53W",
      "Manufacturer": "Yealink",
      "ProductName": "SIP-T53W Prime Business Phone",
      "UnitPrice": 105,
      "MSRP": 219,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 1000,
      "UPC": "841885104311"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 259,
      "PriceChangeDate": "2024-01-31T17:15:04.46",
      "ShipmentRecievedDate": "2019-01-31T00:00:00",
      "StandardPrice": 130,
      "EnergyStartCompliant": false,
      "ProductDescription": "- Mid-level phone, ideal for professionals and managers with moderate call load<br/>- 4.3\" 480x272-pixel color display, fully adjustable<br/>- HD Voice with Yealink Acoustic Shield technology<br/>- 10 line keys, 16 SIP accounts, 27 memory keys<br/>- Built-in Bluetooth, Wi-Fi<br/>- Dual-port Gigabit Ethernet<br/>- 1xUSB port for call recording and wireless USB headset<br/>- YEA-CP930W can be connected to the phones with the YEA-DD10K dect dongle<br/>- Power supply not included<br/>- Phone can work in dect mode with the addition of YEA-DD10K and YEA-W60B base and you will have 10 blf keys",
      "SKU": "SIP-T54W Prime Business Phone",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-SIP-T54W",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/dca73e08-68f4-4dfb-bc6c-cd5b469bc634.jpg"
        },
        {
          "Description": "YEA-SIP-T54W",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/caae1f24-9251-4b87-a750-df348893edb5.jpg"
        },
        {
          "Description": "YEA-SIP-T54W",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/3c63dcc4-4f8a-41f9-8440-ba6c5e97313a.jpg"
        }
      ],
      "Documents": [
        {
          "Description": "Datasheet",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/439ca8dc-09f1-426a-a457-991ccf7e12e0.pdf"
        }
      ],
      "Relatedproducts": [
        "YEA-SIP-T52S",
        "YEA-SIP-T53",
        "YEA-SIP-T53W",
        "YEA-SIP-T54S",
        "YEA-SIP-T56A",
        "YEA-SIP-T57W",
        "YEA-SIP-T58",
        "YEA-SIP-T58A"
      ],
      "Accessories": [
        "YEA-PS5V2000US",
        "YEA-WMB-T5W",
        "YEA-EHS40",
        "YEA-EXP50",
        "YEA-HNDST-T53-T54",
        "YEA-CP700-TEAMS",
        "YEA-UH36-DUAL-UC",
        "YEA-UH36-MONO-TEAMS",
        "YEA-UH36-MONO-UC",
        "YEA-HC-T58",
        "YEA-WARR-B"
      ],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": true,
      "Height": 10,
      "Length": 10.5,
      "Width": 4.5,
      "Weight": 2.75,
      "DimensionalAirWeigth": 3.4,
      "DimensionalGroundWeight": 2.85,
      "Features": [
        {
          "Name": "Bluetooth",
          "Value": "Yes"
        },
        {
          "Name": "Call Waiting",
          "Value": "Yes"
        },
        {
          "Name": "Caller ID (CID)",
          "Value": "Yes"
        },
        {
          "Name": "Conference Calling",
          "Value": "Yes"
        },
        {
          "Name": "Corded or Cordless",
          "Value": "Corded"
        },
        {
          "Name": "Ethernet Ports",
          "Value": "2"
        },
        {
          "Name": "Headset Port",
          "Value": "Yes"
        },
        {
          "Name": "LCD Backlit Display",
          "Value": "Yes"
        },
        {
          "Name": "Number SIP Accounts/Identities",
          "Value": "10+"
        },
        {
          "Name": "Power Source",
          "Value": "PoE and AC Adapter"
        },
        {
          "Name": "SIP or Proprietary IP",
          "Value": "SIP Phones"
        },
        {
          "Name": "Speakerphone",
          "Value": "Yes"
        },
        {
          "Name": "Voicemail",
          "Value": "Yes"
        },
        {
          "Name": "Wall Mountable",
          "Value": "Yes"
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": "Retail Box"
        },
        {
          "Name": "Warranty",
          "Value": "1 Year"
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-SIP-T54W",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-SIP-T54W",
      "Manufacturer": "Yealink",
      "ProductName": "SIP-T54W Prime Business Phone",
      "UnitPrice": 130,
      "MSRP": 279,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 1000,
      "UPC": "841885103765"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 169,
      "PriceChangeDate": "2024-01-31T17:15:04.46",
      "ShipmentRecievedDate": "2019-03-05T00:00:00",
      "StandardPrice": 89,
      "EnergyStartCompliant": false,
      "ProductDescription": "- Entry-level phone, well suited for common workspace<br/>- 3.7\" 360x160-pixel graphical display, fully adjustable<br/>- HD Voice with Yealink Acoustic Shield technology<br/>- 8 line keys, 12 SIP accounts, 21 memory keys<br/>- Bluetooth (YEA-BT41 required) and Wi-Fi(YEA-WF40 or YEA-WF50 required)<br/>- Dual-port Gigabit Ethernet<br/>- 1xUSB port for call recording and wireless USB headset<br/>- YEA-CP930W can be connected to the phones withthe YEA-DD10K dect dongle<br/>- Power supply not included",
      "SKU": "SIP-T53 Prime Business Phone",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-SIP-T53",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/414daf33-1c23-48fe-93b2-537b7e159a19.jpg"
        },
        {
          "Description": "YEA-SIP-T53",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/6aabd4fd-3b7c-48fa-9972-162724eafe19.jpg"
        },
        {
          "Description": "YEA-SIP-T53",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/9b9a93be-bfa8-47cb-9027-c64f06be6096.jpg"
        }
      ],
      "Documents": [
        {
          "Description": "Datasheet",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/54043c3b-46a7-4890-ba36-476a162a788e.pdf"
        }
      ],
      "Relatedproducts": [
        "YEA-SIP-T53W",
        "YEA-SIP-T54W",
        "YEA-SIP-T57W",
        "YEA-SIP-T58"
      ],
      "Accessories": [
        "YEA-BT41",
        "YEA-EHS40",
        "YEA-WF40",
        "YEA-WF50",
        "YEA-EXP50",
        "YEA-STAND-T53",
        "YEA-CP700-TEAMS",
        "YEA-CP700-BT-TEAMS",
        "YEA-CP900-TEAMS",
        "YEA-CP900-BT-TEAMS",
        "YEA-PS5V1200US",
        "YEA-WH62-DUAL-TEAMS",
        "YEA-WH62-DUAL-UC",
        "YEA-WH62-MONO-TEAMS",
        "YEA-WH62-MONO-UC",
        "YEA-WH63-TEAMS",
        "YEA-WH63-UC",
        "YEA-WH66-DUAL-TEAMS",
        "YEA-WH66-DUAL-UC",
        "YEA-WH67-TEAMS",
        "YEA-WH67-UC",
        "YEA-UH36-DUAL-TEAMS",
        "YEA-UH36-DUAL-UC",
        "YEA-UH36-MONO-TEAMS",
        "YEA-UH36-MONO-UC",
        "YEA-WMB-T5W",
        "YEA-HC-T58",
        "YEA-HNDST-T53-T54",
        "YEA-WARR-B"
      ],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": true,
      "Height": 4.2,
      "Length": 9.5,
      "Width": 9.5,
      "Weight": 2.6,
      "DimensionalAirWeigth": 2.73,
      "DimensionalGroundWeight": 2.28,
      "Features": [
        {
          "Name": "Bluetooth",
          "Value": "Yes"
        },
        {
          "Name": "Call Waiting",
          "Value": "Yes"
        },
        {
          "Name": "Caller ID (CID)",
          "Value": "Yes"
        },
        {
          "Name": "Conference Calling",
          "Value": "Yes"
        },
        {
          "Name": "Corded or Cordless",
          "Value": "Corded"
        },
        {
          "Name": "Ethernet Ports",
          "Value": "2"
        },
        {
          "Name": "Headset Port",
          "Value": "Yes"
        },
        {
          "Name": "LCD Backlit Display",
          "Value": "Yes"
        },
        {
          "Name": "Number SIP Accounts/Identities",
          "Value": "10+"
        },
        {
          "Name": "Power Source",
          "Value": "PoE and AC Adapter"
        },
        {
          "Name": "SIP or Proprietary IP",
          "Value": "SIP Phones"
        },
        {
          "Name": "Speakerphone",
          "Value": "Yes"
        },
        {
          "Name": "Voicemail",
          "Value": "Yes"
        },
        {
          "Name": "Wall Mountable",
          "Value": "Yes"
        },
        {
          "Name": "Wifi",
          "Value": "Yes"
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": "Retail Box"
        },
        {
          "Name": "Warranty",
          "Value": "1 Year"
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-SIP-T53",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-SIP-T53",
      "Manufacturer": "Yealink",
      "ProductName": "SIP-T53 Prime Business Phone",
      "UnitPrice": 89,
      "MSRP": 189,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 1000,
      "UPC": "841885104304"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 319,
      "PriceChangeDate": "2024-01-31T17:15:04.46",
      "ShipmentRecievedDate": "2019-04-18T00:00:00",
      "StandardPrice": 183,
      "EnergyStartCompliant": false,
      "ProductDescription": "- 7” 800 x 480 capacitive adjustable touch screen<br/>- Adjustable LCD screen<br/>- Built-in Bluetooth 4.2<br/>- Built-in dual band 2.4G/5G Wi-Fi (802.11a/b/g/n/ac)<br/>- USB 2.0 port for USB recording, wired/wireless USB headsets and EXP50<br/>- Up to 16 VoIP accounts<br/>- Dual-port Gigabit Ethernet<br/>- PoE support<br/>- HAC Handset<br/>- Paperless label design<br/>- Wall mountable",
      "SKU": "SIP-T57W Prime Business Phone",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-SIP-T57W",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/fba6610b-3db1-441e-a945-23d9f2ea08ca.jpg"
        },
        {
          "Description": "YEA-SIP-T57W",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/5b1f71bc-3609-4d88-ba1f-36a8ad2effe8.jpg"
        }
      ],
      "Documents": [
        {
          "Description": "Datasheet",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/a9de3df3-d947-4f64-9f5a-e9f04e109a8e.pdf"
        }
      ],
      "Relatedproducts": [
        "YEA-SIP-T52S",
        "YEA-SIP-T53",
        "YEA-SIP-T53W",
        "YEA-SIP-T54S",
        "YEA-SIP-T54W",
        "YEA-SIP-T56A",
        "YEA-SIP-T58",
        "YEA-SIP-T58A"
      ],
      "Accessories": [
        "YEA-PS5V2000US",
        "PL-211076-01",
        "YEA-EHS40",
        "YEA-CP700-TEAMS",
        "YEA-CP700-BT-TEAMS",
        "YEA-CP900-TEAMS",
        "YEA-CP900-BT-TEAMS",
        "YEA-WMB-T5S",
        "YEA-STAND-T58",
        "YEA-WH62-DUAL-TEAMS",
        "YEA-WH62-DUAL-UC",
        "YEA-WH62-MONO-TEAMS",
        "YEA-WH62-MONO-UC",
        "YEA-WH63-TEAMS",
        "YEA-WH63-UC",
        "YEA-WH66-DUAL-TEAMS",
        "YEA-WH66-DUAL-UC",
        "YEA-WH67-TEAMS",
        "YEA-WH67-UC",
        "YEA-UH36-DUAL-TEAMS",
        "YEA-UH36-DUAL-UC",
        "YEA-UH36-MONO-TEAMS",
        "YEA-UH36-MONO-UC",
        "YEA-HNDST-T5X",
        "YEA-HC-T58",
        "YEA-WARR-B"
      ],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": true,
      "Height": 5,
      "Length": 9,
      "Width": 7,
      "Weight": 3.95,
      "DimensionalAirWeigth": 2.27,
      "DimensionalGroundWeight": 1.9,
      "Features": [
        {
          "Name": "Bluetooth",
          "Value": "Yes"
        },
        {
          "Name": "Call Waiting",
          "Value": "Yes"
        },
        {
          "Name": "Caller ID (CID)",
          "Value": "Yes"
        },
        {
          "Name": "Conference Calling",
          "Value": "Yes"
        },
        {
          "Name": "Corded or Cordless",
          "Value": "Corded"
        },
        {
          "Name": "Ethernet Ports",
          "Value": "2"
        },
        {
          "Name": "Headset Port",
          "Value": "Yes"
        },
        {
          "Name": "Number SIP Accounts/Identities",
          "Value": "10+"
        },
        {
          "Name": "Power Source",
          "Value": "PoE and AC Adapter"
        },
        {
          "Name": "SIP or Proprietary IP",
          "Value": "SIP Phones"
        },
        {
          "Name": "Speakerphone",
          "Value": "Yes"
        },
        {
          "Name": "Wall Mountable",
          "Value": "Yes"
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": "Retail Box"
        },
        {
          "Name": "Warranty",
          "Value": "1 Year"
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-SIP-T57W",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-SIP-T57W",
      "Manufacturer": "Yealink",
      "ProductName": "SIP-T57W Prime Business Phone",
      "UnitPrice": 183,
      "MSRP": 359,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 1000,
      "UPC": "841885103772"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 709,
      "PriceChangeDate": "2023-03-31T18:15:04.67",
      "ShipmentRecievedDate": "2019-03-26T00:00:00",
      "StandardPrice": 453,
      "EnergyStartCompliant": false,
      "ProductDescription": "- 8 inch (1280 x 800) capacitive adjustable touch screen<br/>- 1080p@30 full HD video<br/>- Runs Android 7.1<br/>- Built-in Bluetooth 4.2<br/>- Built-in dual band 2.4G/5G Wi-Fi (802.11a/b/g/n/ac)<br/>- USB 2.0 port for USB headset, media and storage applications<br/>- Standard HDMI output for monitor connection<br/>- Up to 16 VoIP accounts<br/>- Up to 3-party video conferencing<br/>- Up to 5-party video/audio mixed conferencing<br/>- PoE support<br/>- Power supply not included",
      "SKU": "1303050 VP59 Flagship Smart Video Phone",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-VP-T59G",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/2aeced91-25c6-46be-b4ba-077da79c9984.jpg"
        },
        {
          "Description": "YEA-VP-T59G",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/7fd991a1-2899-44bd-b82a-40e8a04aadd6.jpg"
        },
        {
          "Description": "YEA-VP-T59G",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/abca1e59-7ce7-424b-8936-00b6336ede68.jpg"
        }
      ],
      "Documents": [
        {
          "Description": "Specifications",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/b31979b8-539a-4f18-aae0-64f2dbf1c8de.pdf"
        }
      ],
      "Relatedproducts": [
        "YEA-SIP-T53",
        "YEA-SIP-T53W",
        "YEA-SIP-T54S",
        "YEA-SIP-T54W",
        "YEA-SIP-T56A",
        "YEA-SIP-T57W",
        "YEA-SIP-T58",
        "YEA-SIP-T58A"
      ],
      "Accessories": [
        "YEA-PSU12V1AMP",
        "YEA-EXP50",
        "YEA-WH62-DUAL-TEAMS",
        "YEA-WH62-DUAL-UC",
        "YEA-WH62-MONO-TEAMS",
        "YEA-WH62-MONO-UC",
        "YEA-WH63-TEAMS",
        "YEA-WH63-UC",
        "YEA-WH66-DUAL-TEAMS",
        "YEA-WH66-DUAL-UC",
        "YEA-WH67-TEAMS",
        "YEA-WH67-UC",
        "YEA-UH36-DUAL-TEAMS",
        "YEA-UH36-DUAL-UC",
        "YEA-UH36-MONO-TEAMS",
        "YEA-UH36-MONO-UC",
        "YEA-WARR-E_OLD",
        "YEA-CAM-VP59",
        "YEA-HNDST-T46"
      ],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": true,
      "Height": 14,
      "Length": 15,
      "Width": 5,
      "Weight": 5.5,
      "DimensionalAirWeigth": 7.55,
      "DimensionalGroundWeight": 6.33,
      "Features": [
        {
          "Name": "Bluetooth",
          "Value": "Yes"
        },
        {
          "Name": "Call Waiting",
          "Value": "Yes"
        },
        {
          "Name": "Caller ID (CID)",
          "Value": "Yes"
        },
        {
          "Name": "Conference Calling",
          "Value": "Yes"
        },
        {
          "Name": "Corded or Cordless",
          "Value": "Corded"
        },
        {
          "Name": "Ethernet Ports",
          "Value": "2"
        },
        {
          "Name": "Headset Port",
          "Value": "Yes"
        },
        {
          "Name": "Number SIP Accounts/Identities",
          "Value": "10+"
        },
        {
          "Name": "Power Source",
          "Value": "PoE and AC Adapter"
        },
        {
          "Name": "Speakerphone",
          "Value": "Yes"
        },
        {
          "Name": "Wifi",
          "Value": "Yes"
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": "Retail Box"
        },
        {
          "Name": "Warranty",
          "Value": "1 Year"
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-VP59G",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-VP59G",
      "Manufacturer": "Yealink",
      "ProductName": "1303050 VP59 Flagship Smart Video Phone",
      "UnitPrice": 453,
      "MSRP": 799,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 82,
      "UPC": "841885103826"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 26,
      "PriceChangeDate": "2021-09-30T19:35:03.403",
      "ShipmentRecievedDate": "2019-05-02T00:00:00",
      "StandardPrice": 25,
      "EnergyStartCompliant": false,
      "ProductDescription": "- Supports Yealink SIP-T27G/T29G/T46G/T48G/T41S/T42S/T46S/T48S/T53<br/>- Bluetooth specification: V4.0+HS system<br/>- Enhanced Data Rata (edr) compliant for both 2Mbps and 3Mbps supported<br/>- A2DP technology<br/>- Support 8K NBS (apply to SIP-T27G/T29G/T46G/T48G/T41S/T42S/T46S/T48S)<br/>- Support 16K WBS (apply to SIP-T53)<br/>- Operating distance: 10 meters<br/>- Answer incoming calls through Bluetooth headset<br/>- Terminate calls through Bluetooth headset<br/>- Adjusts the volume of Bluetooth headset through Bluetooth headset or your phone<br/>- Bluetooth frequency range: 2.402GHz-2.480GHz<br/>- Built-in security<br/>- Low power consumption",
      "SKU": "1300001 Bluetooth USB Dongle for Yealink",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-BT41",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/bd59812e-9d28-4583-bbe8-c994598b4088.jpg"
        }
      ],
      "Documents": [],
      "Relatedproducts": [
        "YEA-SIP-T27G",
        "YEA-SIP-T29G",
        "YEA-SIP-T41S",
        "YEA-SIP-T42S",
        "YEA-SIP-T46G",
        "YEA-SIP-T48G",
        "YEA-SIP-T48S",
        "YEA-SIP-T53"
      ],
      "Accessories": [],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 1,
      "Length": 3.7,
      "Width": 2.25,
      "Weight": 0.11,
      "DimensionalAirWeigth": 0.06,
      "DimensionalGroundWeight": 0.05,
      "Features": [
        {
          "Name": "Accessories",
          "Value": "Yes"
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": null
        },
        {
          "Name": "Warranty",
          "Value": "1 Year"
        },
        {
          "Name": "Website Link",
          "Value": "http://www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-BT41",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-BT41",
      "Manufacturer": "Yealink",
      "ProductName": "1300001 Bluetooth USB Dongle for Yealink",
      "UnitPrice": 25,
      "MSRP": 29,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 903,
      "UPC": "841885103550"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 0,
      "PriceChangeDate": "2019-04-26T09:15:07.967",
      "ShipmentRecievedDate": "2019-05-24T00:00:00",
      "StandardPrice": 5.5,
      "EnergyStartCompliant": false,
      "ProductDescription": "- Yealink Wall Bracket for T53, T53W, T54W phones<br/>- Incompatible with T57W, T58A",
      "SKU": "330100000029 Wall Bracket for T53/T54",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-WMB-T5W",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/8a2a2faa-7f42-4e91-91ec-c929fd88120c.jpg"
        }
      ],
      "Documents": [],
      "Relatedproducts": [
        "YEA-100-056-003",
        "YEA-100-058-003",
        "YEA-SIP-T52S",
        "YEA-SIP-T53",
        "YEA-SIP-T53W",
        "YEA-SIP-T54S",
        "YEA-SIP-T54W",
        "YEA-SIP-T56A",
        "YEA-SIP-T57W",
        "YEA-SIP-T58",
        "YEA-SIP-T58A"
      ],
      "Accessories": [],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 6,
      "Length": 3,
      "Width": 1,
      "Weight": 0.5,
      "DimensionalAirWeigth": 0.13,
      "DimensionalGroundWeight": 0.11,
      "Features": [
        {
          "Name": "Accessories",
          "Value": "Yes"
        },
        {
          "Name": "Stands, Mounting Equipment, and Cases",
          "Value": "Yes"
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": "Retail Box"
        },
        {
          "Name": "Warranty",
          "Value": "1 Year"
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-WMB-T5W",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-WMB-T5W",
      "Manufacturer": "Yealink",
      "ProductName": "330100000029 Wall Bracket for T53/T54",
      "UnitPrice": 5.5,
      "MSRP": 0,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 1000,
      "UPC": "841885103161"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 70,
      "PriceChangeDate": "2023-03-10T11:35:03.703",
      "ShipmentRecievedDate": "2019-07-05T00:00:00",
      "StandardPrice": 50,
      "EnergyStartCompliant": false,
      "ProductDescription": "- Supports Yealink SIP-VP59/T58W/T58A/T57W/T54W/T53W/T53/T42U/T43U/T46U/T48U  IP Phones<br/>- T48S/T46S/T42S/T41S IP Phones (apply to firmware version 83 or later) and a compatible wireless headset.<br/>- NOTE: YEA-EHS40 is not needed when adding a YEA-WH6X headset to a Yealink SIP phone<br/>See Documents tab for information on WH6X headsets!<br/>- Compatible with Jabra, Plantronics wireless headsets<br/>- Compatible with Sennheiser wireless headsets (Note: The sennheiser wireless headset must be running the latest firmware of the DW-Office series, version 96 or later)<br/>- Plug and play<br/>- Answer incoming call through remote wireless headset<br/>- Terminate calls using remote wireless headset key<br/>- Incoming calls are signaled in the headset earpiece<br/>- Built-in a RJ12 (6P6C) input port connected to IP phone<br/>- RJ45 (8P8C) output port for GN/Jabra/Sennheiser headset<br/>- 3.5mm output port for Plantronics headset",
      "SKU": "Yealink Headset Adapter EHS40, USB",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": null,
          "ResourceUrl": "https://www.teledynamics.com/tdresources/9c867c83-4fae-44bc-b3aa-1661d707a0fd.jpg"
        },
        {
          "Description": "YEA-EHS40",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/39959fb4-26af-4692-9097-88d767b6d28c.jpg"
        }
      ],
      "Documents": [
        {
          "Description": "WH6X Flyer",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/1f0aeeb9-01ab-43e1-9b66-81bfe527cd39.pdf"
        }
      ],
      "Relatedproducts": [
        "YEA-EHS36"
      ],
      "Accessories": [],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 1.5,
      "Length": 6,
      "Width": 3.5,
      "Weight": 0.37,
      "DimensionalAirWeigth": 0.23,
      "DimensionalGroundWeight": 0.19,
      "Features": [
        {
          "Name": "Headset Adapters",
          "Value": "Yes"
        },
        {
          "Name": "Range - Feet",
          "Value": null
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": "Retail Box"
        },
        {
          "Name": "Warranty",
          "Value": "1 year"
        },
        {
          "Name": "Website Link",
          "Value": "http://www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "Business Equipment",
          "SubCategories": [
            {
              "Name": "Headsets"
            }
          ]
        }
      ],
      "PartNumber": "YEA-EHS40",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-EHS40",
      "Manufacturer": "Yealink",
      "ProductName": "Yealink Headset Adapter EHS40, USB",
      "UnitPrice": 50,
      "MSRP": 70,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 1000,
      "UPC": "841885103680"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 175,
      "PriceChangeDate": "2020-08-18T10:35:02.807",
      "ShipmentRecievedDate": "2019-06-27T00:00:00",
      "StandardPrice": 131,
      "EnergyStartCompliant": false,
      "ProductDescription": "- Premium HD Voice for calls and music<br/>- 6.5-foot (two-meter) 360-degree microphone pickup range<br/>- Six-microphone beamforming array for full-duplex experience<br/>- USB or Bluetooth connectivity for notebooks, smartphones and tablets<br/>- Portable design<br/>- Compatible with T53,T53W,T54W, T55 and T57W phones if running V85 firmware",
      "SKU": "300-900-001 CP900 Speakerphone with BT50",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-CP900",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/9aac2993-7297-44ae-88d9-f6f249c9949b.jpg"
        },
        {
          "Description": "YEA-CP900",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/b0ea3983-c51c-4e9d-8316-677257ac0fd7.jpg"
        },
        {
          "Description": "YEA-CP900",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/2cc96234-8f18-467a-bbc3-f350af5aa5ce.jpg"
        }
      ],
      "Documents": [
        {
          "Description": "Datasheet",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/aaa9be94-4af0-446c-ad63-0f03f1686f8f.pdf"
        },
        {
          "Description": "Flyer",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/4603b674-fff2-40bb-8c79-c18bd4c0c263.pdf"
        }
      ],
      "Relatedproducts": [
        "YEA-CP920",
        "YEA-CP930W",
        "YEA-CP930W-BASE",
        "YEA-CP960"
      ],
      "Accessories": [
        "YEA-BT50",
        "YEA-BT51-C"
      ],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 2.2,
      "Length": 7.2,
      "Width": 6.2,
      "Weight": 1.1,
      "DimensionalAirWeigth": 0.71,
      "DimensionalGroundWeight": 0.59,
      "Features": [
        {
          "Name": "Bluetooth",
          "Value": "Yes"
        },
        {
          "Name": "Echo Cancellation",
          "Value": "Yes"
        },
        {
          "Name": "Full Duplex Speakerphone",
          "Value": "Yes"
        },
        {
          "Name": "Mute",
          "Value": "Yes"
        },
        {
          "Name": "No. Accessory/Replacement Microphones",
          "Value": null
        },
        {
          "Name": "Teams Platform",
          "Value": "Yes"
        },
        {
          "Name": "Wired, Wireless, or IP",
          "Value": "Wireless"
        },
        {
          "Name": "Zoom Platform",
          "Value": null
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": null
        },
        {
          "Name": "Warranty",
          "Value": "1 Year"
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "Business Equipment",
          "SubCategories": [
            {
              "Name": "Conferencing Equipment"
            }
          ]
        }
      ],
      "PartNumber": "YEA-CP900-BT-TEAMS",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-CP900-BT-TEAMS",
      "Manufacturer": "Yealink",
      "ProductName": "300-900-001 CP900 Speakerphone with BT50",
      "UnitPrice": 131,
      "MSRP": 229,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 10,
      "UPC": "841885103505"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 709,
      "PriceChangeDate": "2023-03-31T18:15:04.67",
      "ShipmentRecievedDate": "2019-08-30T00:00:00",
      "StandardPrice": 453,
      "EnergyStartCompliant": false,
      "ProductDescription": "- Microsoft Teams certified edition<br/>- 8 inch (1280 x 800) capacitive adjustable touch screen<br/>- Optimal HD audio, support Yealink Noise Proof technology<br/>- Based on Android 7.1<br/>- HDMI for connection to monitor or TV<br/>- 2 mega-pixel HD camera with privacy shutter<br/>- Built-in Bluetooth 4.2<br/>- Built-in dual band 2.4G/5G Wi-Fi<br/>- USB 2.0 port<br/>- Dual-port Gigabit Ethernet, PoE support <br/>- Full-duplex hands-free speakerphone with AEC<br/>- Microsoft Teams-tailored user interface<br/>- Support Microsoft/Yealink/Unify Square device management platform<br/>- Power supply not included",
      "SKU": "1303053 Yealink VP59 -Teams Video Phone",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-100-059-003",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/08c45486-4529-47cf-bf08-ef2d14a47d68.jpg"
        },
        {
          "Description": "YEA-100-059-003",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/e57b0707-0928-4a8f-9185-1b6d1600108c.jpg"
        },
        {
          "Description": "YEA-100-059-003",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/376089af-5bc7-46a1-8e83-fc2da88a5390.jpg"
        }
      ],
      "Documents": [
        {
          "Description": "Datasheet",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/e0b07056-1b7e-4cfa-8aec-fa23d2967941.pdf"
        },
        {
          "Description": "Quick Start Guide",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/f148f291-f8d8-4df6-90bd-77391863a392.pdf"
        },
        {
          "Description": "User Guide",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/612b356b-d595-4362-a34b-cb8090d0b43c.pdf"
        }
      ],
      "Relatedproducts": [
        "YEA-100-055-008",
        "YEA-100-056-008",
        "YEA-100-058-008"
      ],
      "Accessories": [
        "YEA-PSU12V1AMP",
        "YEA-WH62-DUAL-TEAMS",
        "YEA-WH62-DUAL-UC",
        "YEA-WH62-MONO-TEAMS",
        "YEA-WH62-MONO-UC",
        "YEA-WH63-TEAMS",
        "YEA-WH63-UC",
        "YEA-WH66-DUAL-TEAMS",
        "YEA-WH66-DUAL-UC",
        "YEA-WH67-TEAMS",
        "YEA-WH67-UC",
        "YEA-UH36-DUAL-TEAMS",
        "YEA-UH36-DUAL-UC",
        "YEA-UH36-MONO-TEAMS",
        "YEA-UH36-MONO-UC"
      ],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": true,
      "Height": 14,
      "Length": 15,
      "Width": 5,
      "Weight": 5.5,
      "DimensionalAirWeigth": 7.55,
      "DimensionalGroundWeight": 6.33,
      "Features": [
        {
          "Name": "Bluetooth",
          "Value": "Yes"
        },
        {
          "Name": "Call Waiting",
          "Value": "Yes"
        },
        {
          "Name": "Caller ID (CID)",
          "Value": "Yes"
        },
        {
          "Name": "Conference Calling",
          "Value": "Yes"
        },
        {
          "Name": "Corded or Cordless",
          "Value": "Corded"
        },
        {
          "Name": "Ethernet Ports",
          "Value": "2"
        },
        {
          "Name": "Headset Port",
          "Value": "Yes"
        },
        {
          "Name": "LCD Backlit Display",
          "Value": "Yes"
        },
        {
          "Name": "Number SIP Accounts/Identities",
          "Value": "10+"
        },
        {
          "Name": "Power Source",
          "Value": "PoE and AC Adapter"
        },
        {
          "Name": "Speakerphone",
          "Value": "Yes"
        },
        {
          "Name": "Teams Platform",
          "Value": "Yes"
        },
        {
          "Name": "Wall Mountable",
          "Value": "Yes"
        },
        {
          "Name": "Wifi",
          "Value": "Yes"
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": "Retail Box"
        },
        {
          "Name": "Warranty",
          "Value": "1 Year"
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-VP59G-TEAMS",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-VP59G-TEAMS",
      "Manufacturer": "Yealink",
      "ProductName": "1303053 Yealink VP59 -Teams Video Phone",
      "UnitPrice": 453,
      "MSRP": 799,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 80,
      "UPC": "841885102409"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 0,
      "PriceChangeDate": "2019-09-10T17:15:07.93",
      "ShipmentRecievedDate": "2019-09-24T00:00:00",
      "StandardPrice": 5.5,
      "EnergyStartCompliant": false,
      "ProductDescription": "- Yealink Wall Bracket for T55 phones",
      "SKU": "330100000030 Wall Bracket for T55 phones",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-WMB-T55",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/4ebd87e8-a180-4b30-97ba-57a88254dd59.jpg"
        }
      ],
      "Documents": [],
      "Relatedproducts": [
        "YEA-100-055-003",
        "YEA-100-055-008"
      ],
      "Accessories": [],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 6,
      "Length": 3,
      "Width": 1,
      "Weight": 0.5,
      "DimensionalAirWeigth": 0.13,
      "DimensionalGroundWeight": 0.11,
      "Features": [
        {
          "Name": "Accessories",
          "Value": "Yes"
        },
        {
          "Name": "Stands, Mounting Equipment, and Cases",
          "Value": "Yes"
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": null
        },
        {
          "Name": "Warranty",
          "Value": "1 Year"
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-WMB-T55",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-WMB-T55",
      "Manufacturer": "Yealink",
      "ProductName": "330100000030 Wall Bracket for T55 phones",
      "UnitPrice": 5.5,
      "MSRP": 9.99,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 320,
      "UPC": "YEA-WMB-T55"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 399,
      "PriceChangeDate": "2024-01-31T17:15:04.46",
      "ShipmentRecievedDate": "2019-10-04T00:00:00",
      "StandardPrice": 209,
      "EnergyStartCompliant": false,
      "ProductDescription": "- Seamless Roaming & Stability<br/>-Up to 100 parallel calls<br/>-Up to 30 base stations<br/>-Up to 100 handsets<br/>-Up to 100 SIP accounts<br/>-Support LDAP/Remote Phonebook<br/>-Support Xsi Directory<br/>-DECT radio coverage up to 50m indoors and 300m outdoors<br/>-Support PoE<br/>-Compatible with Yealink W56H/W53H<br/>-Support Opus<br/>-Power Adapter AC 100-240V Input and DC 5v/1.2A (optional) ",
      "SKU": "YEA-W80 DECT IP Multi-Cell System",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-W80B",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/d628b2c8-9c91-4a60-a608-2652f97c0461.jpg"
        },
        {
          "Description": "YEA-W80B",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/45d7b28c-7732-4713-9e4e-337d64b229ee.jpg"
        },
        {
          "Description": "YEA-W80B",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/da24fbe3-2aed-45e7-b6ea-a6bf8d372f8e.jpg"
        },
        {
          "Description": "YEA-W80B",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/6defddd8-4b8e-4f71-9519-43e93493d8dd.jpg"
        }
      ],
      "Documents": [
        {
          "Description": "Flyer",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/4b6b595b-7b24-4cab-8505-50cad0f09298.pdf"
        },
        {
          "Description": "Datasheet",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/462d7b42-7228-4f4c-81a6-7e2e2521c95d.PDF"
        }
      ],
      "Relatedproducts": [
        "YEA-W60B",
        "YEA-W60P",
        "YEA-W53P"
      ],
      "Accessories": [
        "YEA-W53H",
        "YEA-W53H-PC",
        "YEA-W56H",
        "YEA-PS5V1200US",
        "YEA-WARR-C"
      ],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 7,
      "Length": 7,
      "Width": 3,
      "Weight": 1,
      "DimensionalAirWeigth": 1.06,
      "DimensionalGroundWeight": 0.89,
      "Features": [
        {
          "Name": "Call Waiting",
          "Value": "Yes"
        },
        {
          "Name": "Conference Calling",
          "Value": "Yes"
        },
        {
          "Name": "Corded or Cordless",
          "Value": "Cordless"
        },
        {
          "Name": "Ethernet Ports",
          "Value": "1"
        },
        {
          "Name": "Max Number of Expandable Handsets",
          "Value": "12+"
        },
        {
          "Name": "Number SIP Accounts/Identities",
          "Value": "10+"
        },
        {
          "Name": "Power Source",
          "Value": "PoE"
        },
        {
          "Name": "Power Supply Included",
          "Value": null
        },
        {
          "Name": "Wall Mountable",
          "Value": "Yes"
        },
        {
          "Name": "Wifi",
          "Value": null
        },
        {
          "Name": "Color",
          "Value": "White"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": "Retail Box"
        },
        {
          "Name": "Warranty",
          "Value": "1 Year"
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-W80B",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-W80B",
      "Manufacturer": "Yealink",
      "ProductName": "YEA-W80 DECT IP Multi-Cell System",
      "UnitPrice": 209,
      "MSRP": 399,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 27,
      "UPC": "841885104571"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 160,
      "PriceChangeDate": "2021-10-01T16:35:03.257",
      "ShipmentRecievedDate": "2019-10-25T00:00:00",
      "StandardPrice": 100,
      "EnergyStartCompliant": false,
      "ProductDescription": "- Optima HD voice, Full duplex technology Muting the microphone with touchpad, 10-foot (3-meter) 360 voice pickup<br/>- Distance between CP960 and CPW90: 20 meters, 800mAh battery capacity<br/>- 19-hour talking time, 11-day standby time<br/>- 1 x CP Wireless Expansion Microphone, Charger Cradle",
      "SKU": "1304025 Single CPW90-BT Wireless Mic",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-500-000-030",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/f85b26f9-5eae-4914-854f-05afdc2c6d41.jpg"
        }
      ],
      "Documents": [],
      "Relatedproducts": [],
      "Accessories": [],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 2,
      "Length": 6,
      "Width": 4,
      "Weight": 0.75,
      "DimensionalAirWeigth": 0.35,
      "DimensionalGroundWeight": 0.29,
      "Features": [
        {
          "Name": "Full Duplex Speakerphone",
          "Value": "Yes"
        },
        {
          "Name": "Microphone",
          "Value": "Yes"
        },
        {
          "Name": "No. Accessory/Replacement Microphones",
          "Value": null
        },
        {
          "Name": "Wired, Wireless, or IP",
          "Value": "Wireless"
        },
        {
          "Name": "Color",
          "Value": "Silver"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": "Retail Box"
        },
        {
          "Name": "Warranty",
          "Value": "1 Year"
        },
        {
          "Name": "Website Link",
          "Value": "http://www.yealink.com/"
        }
      ],
      "Categories": [
        {
          "Name": "Business Equipment",
          "SubCategories": [
            {
              "Name": "Conferencing Equipment"
            }
          ]
        }
      ],
      "PartNumber": "YEA-500-000-030",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-500-000-030",
      "Manufacturer": "Yealink",
      "ProductName": "1304025 Single CPW90-BT Wireless Mic",
      "UnitPrice": 100,
      "MSRP": 160,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 29,
      "UPC": "6938818304208"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 110,
      "PriceChangeDate": "2020-08-14T12:55:02.553",
      "ShipmentRecievedDate": "2019-12-18T00:00:00",
      "StandardPrice": 96,
      "EnergyStartCompliant": false,
      "ProductDescription": "- Portable Speakerphone<br/>- Ideal for personal use, private space and on-the-go<br/>- HD audio offers a clear and natural sound<br/>- Elegant and lightweight design<br/>- Able to pair the CP700 with 3 Bluetooth-enabled devices simultaneously<br/>- Multiple buttons with LED indicators provide users with easy-to-understand guidance<br/>- Compatible with T53,T53W,T54W and T57W phones if running V85 firmware<br/>- This includes a Yealink BT50 USB Bluetooth Dongle",
      "SKU": "300-700-001 CP700 Speakerphone with BT50",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-300-700-000",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/d8ca22c3-3615-4629-9299-bc81062b5d67.jpg"
        },
        {
          "Description": "YEA-300-700-000",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/6ee424ff-879b-446f-996b-941f18cdf2db.jpg"
        },
        {
          "Description": "YEA-300-700-000",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/01dc5422-4020-41fa-9aec-25040b7e6aeb.jpg"
        },
        {
          "Description": "YEA-300-700-000",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/7d4ae41e-6b37-4652-805b-a796eef8cf7d.jpg"
        },
        {
          "Description": "YEA-300-700-000",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/4e800e5e-74d1-4aec-a411-b3c190d1019f.jpg"
        }
      ],
      "Documents": [
        {
          "Description": "Quick Start Guide",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/05deca49-8d69-4ef2-82b5-2d0994ae5432.pdf"
        },
        {
          "Description": "Flyer",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/db0f4628-f320-48cf-b577-8f5715234914.pdf"
        }
      ],
      "Relatedproducts": [
        "YEA-CP900-BT-TEAMS"
      ],
      "Accessories": [
        "YEA-BT50",
        "YEA-BT51-C"
      ],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 2.2,
      "Length": 6.4,
      "Width": 5.7,
      "Weight": 1,
      "DimensionalAirWeigth": 0.58,
      "DimensionalGroundWeight": 0.48,
      "Features": [
        {
          "Name": "3-Way Calling",
          "Value": "Yes"
        },
        {
          "Name": "Bluetooth",
          "Value": "Yes"
        },
        {
          "Name": "Echo Cancellation",
          "Value": "Yes"
        },
        {
          "Name": "Full Duplex Speakerphone",
          "Value": "Yes"
        },
        {
          "Name": "Mute",
          "Value": "Yes"
        },
        {
          "Name": "No. Accessory/Replacement Microphones",
          "Value": null
        },
        {
          "Name": "Teams Platform",
          "Value": "Yes"
        },
        {
          "Name": "Zoom Platform",
          "Value": null
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": "No"
        },
        {
          "Name": "Type of Packaging",
          "Value": "Retail Box"
        },
        {
          "Name": "Warranty",
          "Value": "2 Year"
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "Business Equipment",
          "SubCategories": [
            {
              "Name": "Conferencing Equipment"
            }
          ]
        }
      ],
      "PartNumber": "YEA-CP700-BT-TEAMS",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-CP700-BT-TEAMS",
      "Manufacturer": "Yealink",
      "ProductName": "300-700-001 CP700 Speakerphone with BT50",
      "UnitPrice": 96,
      "MSRP": 158,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 0,
      "UPC": "841885103482"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 0,
      "PriceChangeDate": "2019-11-14T13:55:04.523",
      "ShipmentRecievedDate": null,
      "StandardPrice": 400,
      "EnergyStartCompliant": false,
      "ProductDescription": "Yealink Meeting Server Concurrent Call License, Perpetual. Minimum 10 license for first time<br/>- Including 1-year AMS",
      "SKU": "YMS Concurrent Call License 1-24",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-YMS-CC-1-24-License",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/4b74160f-94dd-4770-a259-9a296d8e3a77.jpg"
        }
      ],
      "Documents": [],
      "Relatedproducts": [],
      "Accessories": [],
      "Leasable": false,
      "Virtual": true,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 0,
      "Length": 0,
      "Width": 0,
      "Weight": 0,
      "DimensionalAirWeigth": 0,
      "DimensionalGroundWeight": 0,
      "Features": [
        {
          "Name": "Installation, Extended Warranties, and Support",
          "Value": "Yes"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": null
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": null
        },
        {
          "Name": "Warranty",
          "Value": null
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "Business Equipment",
          "SubCategories": [
            {
              "Name": "Licenses and Warranties"
            }
          ]
        }
      ],
      "PartNumber": "YEA-YMS-CC-1-24-License",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-YMS-CC-1-24-License",
      "Manufacturer": "Yealink",
      "ProductName": "YMS Concurrent Call License 1-24",
      "UnitPrice": 400,
      "MSRP": 0,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 0,
      "UPC": ""
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 0,
      "PriceChangeDate": "2019-11-14T13:55:04.523",
      "ShipmentRecievedDate": null,
      "StandardPrice": 360,
      "EnergyStartCompliant": false,
      "ProductDescription": "Yealink Meeting Server Concurrent Call License, Perpetual. Minimum 10 license for first time<br/>- Including 1-year AMS",
      "SKU": "YMS Concurrent Call License 25-49",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-YMS-CC-25-49-License",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/be7d67e1-5267-429b-a5e0-f9a2e8b02eb5.jpg"
        }
      ],
      "Documents": [],
      "Relatedproducts": [],
      "Accessories": [],
      "Leasable": false,
      "Virtual": true,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 0,
      "Length": 0,
      "Width": 0,
      "Weight": 0,
      "DimensionalAirWeigth": 0,
      "DimensionalGroundWeight": 0,
      "Features": [
        {
          "Name": "Installation, Extended Warranties, and Support",
          "Value": "Yes"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": null
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": null
        },
        {
          "Name": "Warranty",
          "Value": "www.yealink.com"
        },
        {
          "Name": "Website Link",
          "Value": null
        }
      ],
      "Categories": [
        {
          "Name": "Business Equipment",
          "SubCategories": [
            {
              "Name": "Licenses and Warranties"
            }
          ]
        }
      ],
      "PartNumber": "YEA-YMS-CC-25-49-License",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-YMS-CC-25-49-License",
      "Manufacturer": "Yealink",
      "ProductName": "YMS Concurrent Call License 25-49",
      "UnitPrice": 360,
      "MSRP": 0,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 0,
      "UPC": ""
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 0,
      "PriceChangeDate": "2019-11-14T13:55:04.523",
      "ShipmentRecievedDate": null,
      "StandardPrice": 3333,
      "EnergyStartCompliant": false,
      "ProductDescription": "Yealink Meeting Server Broadcasting License, Perpetual. 50 ports as 1 package<br/>- Including 1-year AMS",
      "SKU": "YMS Broadcasting License-50,Perpetual",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-YMS-BL50-License",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/2de104aa-3951-48c7-8b0e-a7565574c864.jpg"
        }
      ],
      "Documents": [],
      "Relatedproducts": [],
      "Accessories": [],
      "Leasable": false,
      "Virtual": true,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 0,
      "Length": 0,
      "Width": 0,
      "Weight": 0,
      "DimensionalAirWeigth": 0,
      "DimensionalGroundWeight": 0,
      "Features": [
        {
          "Name": "Installation, Extended Warranties, and Support",
          "Value": "Yes"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": null
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": null
        },
        {
          "Name": "Warranty",
          "Value": null
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "Business Equipment",
          "SubCategories": [
            {
              "Name": "Licenses and Warranties"
            }
          ]
        }
      ],
      "PartNumber": "YEA-YMS-BL50-License",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-YMS-BL50-License",
      "Manufacturer": "Yealink",
      "ProductName": "YMS Broadcasting License-50,Perpetual",
      "UnitPrice": 3333,
      "MSRP": 0,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 0,
      "UPC": ""
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 0,
      "PriceChangeDate": "2019-11-14T13:55:04.523",
      "ShipmentRecievedDate": null,
      "StandardPrice": 670,
      "EnergyStartCompliant": false,
      "ProductDescription": "1 way 1080P30 recording",
      "SKU": "YMS Recording License",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-YMS-RL-License",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/2bf2c4d7-325b-4073-ac8e-111cd6a5787b.jpg"
        }
      ],
      "Documents": [],
      "Relatedproducts": [],
      "Accessories": [],
      "Leasable": false,
      "Virtual": true,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 0,
      "Length": 0,
      "Width": 0,
      "Weight": 0,
      "DimensionalAirWeigth": 0,
      "DimensionalGroundWeight": 0,
      "Features": [
        {
          "Name": "Installation, Extended Warranties, and Support",
          "Value": "Yes"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": null
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": null
        },
        {
          "Name": "Warranty",
          "Value": null
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "Business Equipment",
          "SubCategories": [
            {
              "Name": "Licenses and Warranties"
            }
          ]
        }
      ],
      "PartNumber": "YEA-YMS-RL-License",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-YMS-RL-License",
      "Manufacturer": "Yealink",
      "ProductName": "YMS Recording License",
      "UnitPrice": 670,
      "MSRP": 0,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 0,
      "UPC": ""
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 0,
      "PriceChangeDate": "2019-11-14T14:16:33.463",
      "ShipmentRecievedDate": null,
      "StandardPrice": 320,
      "EnergyStartCompliant": false,
      "ProductDescription": "Yealink Meeting Server Concurrent Call License, Perpetual. Minimum 10 license for first time<br/>- Including 1-year AMS",
      "SKU": "YMS Concurrent Call License 50+",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-YMS-CC-50-License",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/f8654541-30f3-4e6f-846e-1a042c3e03e6.jpg"
        }
      ],
      "Documents": [],
      "Relatedproducts": [],
      "Accessories": [],
      "Leasable": false,
      "Virtual": true,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 0,
      "Length": 0,
      "Width": 0,
      "Weight": 0,
      "DimensionalAirWeigth": 0,
      "DimensionalGroundWeight": 0,
      "Features": [
        {
          "Name": "Installation, Extended Warranties, and Support",
          "Value": "Yes"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": null
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": null
        },
        {
          "Name": "Warranty",
          "Value": "www.yealink.com"
        },
        {
          "Name": "Website Link",
          "Value": null
        }
      ],
      "Categories": [
        {
          "Name": "Business Equipment",
          "SubCategories": [
            {
              "Name": "Licenses and Warranties"
            }
          ]
        }
      ],
      "PartNumber": "YEA-YMS-CC-50-License",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-YMS-CC-50-License",
      "Manufacturer": "Yealink",
      "ProductName": "YMS Concurrent Call License 50+",
      "UnitPrice": 320,
      "MSRP": 0,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 0,
      "UPC": ""
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 0,
      "PriceChangeDate": "2019-12-10T14:35:02.98",
      "ShipmentRecievedDate": "2019-12-26T00:00:00",
      "StandardPrice": 1,
      "EnergyStartCompliant": false,
      "ProductDescription": "Handset clip for T53/T53W/T54W/T57W",
      "SKU": "WMC-T58V Handset Clip for T5W",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-HC-T58",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/6fc5ae40-e349-46f6-88e2-30e4ee6f8dfd.jpg"
        }
      ],
      "Documents": [],
      "Relatedproducts": [],
      "Accessories": [],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 0.5,
      "Length": 0.5,
      "Width": 0.25,
      "Weight": 0.001,
      "DimensionalAirWeigth": 0,
      "DimensionalGroundWeight": 0,
      "Features": [
        {
          "Name": "Accessories",
          "Value": "Yes"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": null
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": "Plastic Bag"
        },
        {
          "Name": "Warranty",
          "Value": "China"
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-HC-T58",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-HC-T58",
      "Manufacturer": "Yealink",
      "ProductName": "WMC-T58V Handset Clip for T5W",
      "UnitPrice": 1,
      "MSRP": 0,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 344,
      "UPC": "YEA-HC-T58"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 629,
      "PriceChangeDate": "2019-12-16T15:15:10.833",
      "ShipmentRecievedDate": "2020-01-30T00:00:00",
      "StandardPrice": 490,
      "EnergyStartCompliant": false,
      "ProductDescription": "- The Yealink DECT IP multi-cell deployment toolkit helps you plan and install your DECT IP multi-cell system<br/>- Contains:<br/>- DTK (Measuring Base Station)<br/>- W56H Handset (2)<br/>- Battery Cover (2)<br/>- Rechargeable Battery (4)<br/>- USB Charging Cradle (2)<br/>- Power Adapter (2)<br/>- Stand<br/>- Base Station Clip<br/>- Mobile Power Clip<br/>- USB-DC Cable<br/>- UH33 Headset (2)<br/>- Notebook and Pen<br/>- Quick Start Guide",
      "SKU": "DECT IP MultiCell Deployment ToolKit",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-W80-DEPLOY-KIT",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/a6be4e46-39b8-4f0a-9917-a799fa9ad2ca.jpg"
        }
      ],
      "Documents": [
        {
          "Description": "Quick Start Guide",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/3173f286-bae3-4189-8abb-9edfe72ad44e.pdf"
        },
        {
          "Description": "Guide",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/a50148bc-b169-42ed-9e1d-2008eddf1454.pdf"
        }
      ],
      "Relatedproducts": [],
      "Accessories": [],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 17,
      "Length": 34,
      "Width": 8,
      "Weight": 18,
      "DimensionalAirWeigth": 33.27,
      "DimensionalGroundWeight": 27.86,
      "Features": [
        {
          "Name": "Accessories",
          "Value": "Yes"
        },
        {
          "Name": "Bundles",
          "Value": "Yes"
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": "Retail Box"
        },
        {
          "Name": "Warranty",
          "Value": "1 Year"
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-W80-DEPLOY-KIT",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-W80-DEPLOY-KIT",
      "Manufacturer": "Yealink",
      "ProductName": "DECT IP MultiCell Deployment ToolKit",
      "UnitPrice": 490,
      "MSRP": 699,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 0,
      "UPC": "841885113825"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 95,
      "PriceChangeDate": "2020-08-14T12:55:02.553",
      "ShipmentRecievedDate": "2020-02-15T00:00:00",
      "StandardPrice": 83,
      "EnergyStartCompliant": false,
      "ProductDescription": "- Speakerphone size: (Ø) 120 x (h) 28mm<br/>- Speakerphone weight: 220 g / 7.76 oz<br/>- Connectivity: USB 2.0 & Bluetooth<br/>- USB cable length: 2.6 feet / 0.8 meter<br/>- Touch Buttons: ower,Bluetooth, Call answer, Call hangup, Volume up, Volume down, Mute, Voice assistant/Teams<br/>- Compatible with T53,T53W,T54W and T57W phones if running V85 firmware",
      "SKU": "300-700-000 CP700 USB Speakerphone",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-CP700",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/dbf3524d-aaca-4623-92e0-e70c016c3441.jpg"
        },
        {
          "Description": "YEA-CP700",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/c25a6139-8160-4883-a9a0-c05f489547d5.jpg"
        },
        {
          "Description": "YEA-CP700",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/7625a5e6-e830-4ade-b1dd-49d5bd0dda59.jpg"
        },
        {
          "Description": "YEA-CP700",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/93fe1c28-1c27-4745-8269-0a1db83e0c16.jpg"
        }
      ],
      "Documents": [
        {
          "Description": "Datasheet",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/311cb42a-32fb-495b-a236-8142ed5efcfa.pdf"
        },
        {
          "Description": "Quick Start Guide",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/12d38c08-ce44-4def-be3c-4585e7ea016e.pdf"
        }
      ],
      "Relatedproducts": [
        "YEA-CP700-BT-TEAMS",
        "YEA-CP900-TEAMS",
        "YEA-CP900-BT-TEAMS",
        "YEA-CP920",
        "YEA-CP930W",
        "YEA-CP930W-BASE",
        "YEA-CP960",
        "YEA-CP960-WM",
        "YEA-CPE80",
        "YEA-CPE90",
        "YEA-CPN10",
        "YEA-CPW90"
      ],
      "Accessories": [
        "YEA-BT50",
        "YEA-BT51-C"
      ],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 2.1,
      "Length": 6.5,
      "Width": 5.7,
      "Weight": 0.8,
      "DimensionalAirWeigth": 0.56,
      "DimensionalGroundWeight": 0.47,
      "Features": [
        {
          "Name": "Accessories",
          "Value": "Yes"
        },
        {
          "Name": "No. Accessory/Replacement Microphones",
          "Value": null
        },
        {
          "Name": "Teams Platform",
          "Value": "Yes"
        },
        {
          "Name": "Zoom Platform",
          "Value": null
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": null
        },
        {
          "Name": "Warranty",
          "Value": "1 Year"
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "Business Equipment",
          "SubCategories": [
            {
              "Name": "Conferencing Equipment"
            }
          ]
        }
      ],
      "PartNumber": "YEA-CP700-TEAMS",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-CP700-TEAMS",
      "Manufacturer": "Yealink",
      "ProductName": "300-700-000 CP700 USB Speakerphone",
      "UnitPrice": 83,
      "MSRP": 129,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 2,
      "UPC": "841885103475"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 155,
      "PriceChangeDate": "2020-08-18T10:35:02.807",
      "ShipmentRecievedDate": "2020-02-15T00:00:00",
      "StandardPrice": 115,
      "EnergyStartCompliant": false,
      "ProductDescription": "- Speakerphone size: (Ø) 132.5 x (h) 35.5mm<br/>- Speakerphone weight: 320g / 11.28 oz<br/>- 8 touch buttons<br/>- Connectivity: USB 2.0 PnP & Bluetooth<br/>- USB cable length: 3 feet / 0.9 meters<br/>- Built-in Bluetooth 4.0<br/>- Wireless range: 100 feet / 30 meters<br/>- Compatible with T53,T53W,T54W and T57W phones if running V85 firmware",
      "SKU": "300-900-000 CP900 USB Speakerphone",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-CP900",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/3e5e9f1b-378d-460b-a487-200ae03ccdb7.jpg"
        },
        {
          "Description": "YEA-CP900",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/7de966dc-7d9f-484f-901f-ecec683fedb6.jpg"
        },
        {
          "Description": "YEA-CP900",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/f6be2ca8-39ef-4fbb-bae9-126afc6c9370.jpg"
        }
      ],
      "Documents": [
        {
          "Description": "Datasheet",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/5cce982f-3034-4c9b-af8e-e7f36c0efa25.pdf"
        }
      ],
      "Relatedproducts": [
        "YEA-CP700-TEAMS",
        "YEA-CP700-BT-TEAMS",
        "YEA-CP900-BT-TEAMS",
        "YEA-CP920",
        "YEA-CP930W",
        "YEA-CP930W-BASE",
        "YEA-CP960",
        "YEA-CP960-WM",
        "YEA-CPE80",
        "YEA-CPE90",
        "YEA-CPN10",
        "YEA-CPW90"
      ],
      "Accessories": [
        "YEA-BT50",
        "YEA-BT51-C"
      ],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 2.2,
      "Length": 7.2,
      "Width": 6.2,
      "Weight": 1.1,
      "DimensionalAirWeigth": 0.71,
      "DimensionalGroundWeight": 0.59,
      "Features": [
        {
          "Name": "Echo Cancellation",
          "Value": "Yes"
        },
        {
          "Name": "Full Duplex Speakerphone",
          "Value": "Yes"
        },
        {
          "Name": "No. Accessory/Replacement Microphones",
          "Value": null
        },
        {
          "Name": "Teams Platform",
          "Value": "Yes"
        },
        {
          "Name": "Zoom Platform",
          "Value": null
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": null
        },
        {
          "Name": "Warranty",
          "Value": "1 Year"
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "Business Equipment",
          "SubCategories": [
            {
              "Name": "Conferencing Equipment"
            }
          ]
        }
      ],
      "PartNumber": "YEA-CP900-TEAMS",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-CP900-TEAMS",
      "Manufacturer": "Yealink",
      "ProductName": "300-900-000 CP900 USB Speakerphone",
      "UnitPrice": 115,
      "MSRP": 199,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 0,
      "UPC": "6938818303287"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 0,
      "PriceChangeDate": "2020-01-17T12:55:02.93",
      "ShipmentRecievedDate": "2020-01-28T00:00:00",
      "StandardPrice": 12,
      "EnergyStartCompliant": false,
      "ProductDescription": "YEA-PSU12V1AMP for VP59, CP920 and CP930",
      "SKU": "600-000-007 12 Volt 1 Amp Power Supply",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-PSU12V1AMP",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/5224ed22-3075-4d27-ad60-09cf19e83969.jpg"
        }
      ],
      "Documents": [],
      "Relatedproducts": [
        "YEA-VP59G-TEAMS",
        "YEA-VP59G",
        "YEA-CP920",
        "YEA-CP930W",
        "YEA-CP930W-BASE"
      ],
      "Accessories": [],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 2,
      "Length": 4,
      "Width": 4,
      "Weight": 0.3,
      "DimensionalAirWeigth": 0.23,
      "DimensionalGroundWeight": 0.19,
      "Features": [
        {
          "Name": "Accessories",
          "Value": "Yes"
        },
        {
          "Name": "Power Supplies",
          "Value": "Yes"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": null
        },
        {
          "Name": "Warranty",
          "Value": "1 Year"
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-PSU12V1AMP",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-PSU12V1AMP",
      "Manufacturer": "Yealink",
      "ProductName": "600-000-007 12 Volt 1 Amp Power Supply",
      "UnitPrice": 12,
      "MSRP": 20,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 87,
      "UPC": "841885110244"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 0,
      "PriceChangeDate": "2020-02-05T14:35:03.34",
      "ShipmentRecievedDate": "2020-02-25T00:00:00",
      "StandardPrice": 5,
      "EnergyStartCompliant": false,
      "ProductDescription": "Stand for T53 and T53W Phone",
      "SKU": "330100000136 Stand for T53 an T53W Phone",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-STAND-T53",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/d5fa7fa5-9673-42ea-b879-8de4e4f03b0c.jpg"
        }
      ],
      "Documents": [],
      "Relatedproducts": [
        "YEA-SIP-T53",
        "YEA-SIP-T53W"
      ],
      "Accessories": [],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 1,
      "Length": 7,
      "Width": 4,
      "Weight": 1,
      "DimensionalAirWeigth": 0.2,
      "DimensionalGroundWeight": 0.17,
      "Features": [
        {
          "Name": "Accessories",
          "Value": "Yes"
        },
        {
          "Name": "Stands, Mounting Equipment, and Cases",
          "Value": "Yes"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": "Retail Box"
        },
        {
          "Name": "Warranty",
          "Value": "1 Year"
        },
        {
          "Name": "Website Link",
          "Value": "http://www.yealink.com/"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-STAND-T53",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-STAND-T53",
      "Manufacturer": "Yealink",
      "ProductName": "330100000136 Stand for T53 an T53W Phone",
      "UnitPrice": 5,
      "MSRP": 0,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 374,
      "UPC": "YEA-STAND-T53"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 0,
      "PriceChangeDate": "2020-02-05T14:35:03.34",
      "ShipmentRecievedDate": "2020-02-25T00:00:00",
      "StandardPrice": 5,
      "EnergyStartCompliant": false,
      "ProductDescription": "Stand for T54W Phone",
      "SKU": "330100000137 Stand for T54W Phone",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-STAND-T54W",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/36ffa319-5848-4c97-8c78-a487e4f166cf.jpg"
        }
      ],
      "Documents": [],
      "Relatedproducts": [
        "YEA-SIP-T54W"
      ],
      "Accessories": [],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 1,
      "Length": 8,
      "Width": 4,
      "Weight": 1,
      "DimensionalAirWeigth": 0.23,
      "DimensionalGroundWeight": 0.19,
      "Features": [
        {
          "Name": "Accessories",
          "Value": "Yes"
        },
        {
          "Name": "Stands, Mounting Equipment, and Cases",
          "Value": "Yes"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": null
        },
        {
          "Name": "Warranty",
          "Value": "1 Year"
        },
        {
          "Name": "Website Link",
          "Value": "http://www.yealink.com/"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-STAND-T54W",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-STAND-T54W",
      "Manufacturer": "Yealink",
      "ProductName": "330100000137 Stand for T54W Phone",
      "UnitPrice": 5,
      "MSRP": 0,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 1000,
      "UPC": "841885113993"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 0,
      "PriceChangeDate": "2020-02-07T08:55:03.11",
      "ShipmentRecievedDate": "2020-03-24T00:00:00",
      "StandardPrice": 12.75,
      "EnergyStartCompliant": false,
      "ProductDescription": "Yealink Battery for W73P W73H W73 W53P W53H W53",
      "SKU": "330000000001 Yealink Battery for W53, 73",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-W53-BATT",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/128087d7-a321-4bd6-ac2b-c489d3dd3284.jpg"
        }
      ],
      "Documents": [],
      "Relatedproducts": [
        "YEA-W53H",
        "YEA-W53H-PC",
        "YEA-W53P",
        "YEA-W73H"
      ],
      "Accessories": [],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 1,
      "Length": 1,
      "Width": 1,
      "Weight": 0.5,
      "DimensionalAirWeigth": 0.01,
      "DimensionalGroundWeight": 0.01,
      "Features": [
        {
          "Name": "Accessories",
          "Value": "Yes"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": "Retail Box"
        },
        {
          "Name": "Warranty",
          "Value": "1 Year"
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-W53-BATT",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-W53-BATT",
      "Manufacturer": "Yealink",
      "ProductName": "330000000001 Yealink Battery for W53, 73",
      "UnitPrice": 12.75,
      "MSRP": 0,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 76,
      "UPC": "YEA-W53-BATT"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 399,
      "PriceChangeDate": "2024-01-31T17:15:04.46",
      "ShipmentRecievedDate": "2020-09-11T00:00:00",
      "StandardPrice": 209,
      "EnergyStartCompliant": false,
      "ProductDescription": "- Seamless handover and roaming<br/>- Up to 100 parallel calls<br/>- Up to 30 base stations<br/>- Up to 100 handsets<br/>- Up to 100 SIP accounts<br/>- Support XML/LDAP/Remote Phonebook<br/>- Support Xsi Directory<br/>- DECT  radio  coverage  up  to  50m  indoors  and 300m outdoors<br/>- DECT technology:  Yealink DECT technology is based on CAT-iq2.0, which  focuses  on  high  quality  Audio  VoIP (wideband), as well as low bit - rate data applica-tions.  But  we  are  not  compatible  with  any third-party DECT devices (base station, handset, etc.).<br/>- Support Opus<br/>- Support PoE<br/>- Compatible  with  Yealink  W56H/W53H  (version x.83.0.90 or later), CP930W (version 87.83.0.60 or later) and DD Phone (version 66.84.0.115 or later)<br/>- W80DM is shipped as a DECT Manager (DM) and the W80B is shipped as a base station. If you want to change the device role of the device, contact your system administrator to upgrade the firmware.",
      "SKU": "W80DM DECT Manager",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-W80DM",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/5b563d4a-1831-4bae-8c0a-fb658f8cb2ed.jpg"
        },
        {
          "Description": "YEA-W80DM",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/88e22753-ec53-4177-b28d-ee9ba9db0da3.jpg"
        },
        {
          "Description": "YEA-W80DM",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/9b7eb115-567a-4233-a255-0047514ac8f1.jpg"
        },
        {
          "Description": "YEA-W80DM",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/43fb4002-7b4d-4d91-84ed-29d1aefe3152.jpg"
        }
      ],
      "Documents": [
        {
          "Description": "Datasheet",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/83c20c66-9354-4cfd-b01f-f3ada3fe9880.pdf"
        },
        {
          "Description": "YEA-W80DM",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/f5618b93-c2fc-41d8-b78a-52c1a225df07.pdf"
        }
      ],
      "Relatedproducts": [
        "YEA-W80B"
      ],
      "Accessories": [
        "YEA-WARR-C"
      ],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 3,
      "Length": 8,
      "Width": 8,
      "Weight": 0.55,
      "DimensionalAirWeigth": 1.38,
      "DimensionalGroundWeight": 1.16,
      "Features": [
        {
          "Name": "Corded or Cordless",
          "Value": "Cordless"
        },
        {
          "Name": "Color",
          "Value": "White"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": "Retail Box"
        },
        {
          "Name": "Warranty",
          "Value": "1 Year"
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-W80DM",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-W80DM",
      "Manufacturer": "Yealink",
      "ProductName": "W80DM DECT Manager",
      "UnitPrice": 209,
      "MSRP": 399,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 17,
      "UPC": "841885104595"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 242,
      "PriceChangeDate": "2024-01-31T17:15:04.46",
      "ShipmentRecievedDate": "2020-07-07T00:00:00",
      "StandardPrice": 114,
      "EnergyStartCompliant": false,
      "ProductDescription": "- 4.3\" 480 x 272-pixel color display with backlight<br/>- Opus codec support<br/>- Dual USB ports<br/>- Dual firmware images<br/>- T42U (pending)/T43U/T46U/T48U Auto-P template unified<br/>- T42U (pending)/T43U/T46U/T48U firmware unified<br/>- Up to 16 SIP accounts<br/>- Dual-port Gigabit Ethernet<br/>- PoE support<br/>- USB headset and EHS support<br/>- Wi-Fi via WF40/WF50<br/>- Bluetooth via BT40/BT41<br/>- USB recording<br/>- Supports color-screen expansion modules<br/>- Stand with two adjustable angles<br/>- Wall mountable<br/>- Expandable with YEA-EXP43<br/>- PSU (YEA-PS5V2000US) not included<br/>- Does not support EHS36 and EXP40",
      "SKU": "Unified Firmware Enhanced SIP Phone",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-SIP-T46U",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/a72fe7be-b108-4121-867d-7b75d09ff4be.jpg"
        },
        {
          "Description": "YEA-SIP-T46U",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/0bdd1613-3733-4ac7-a562-fdbd2cba1238.jpg"
        },
        {
          "Description": "YEA-SIP-T46U",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/d3d09583-10fe-467f-b42a-978a33b7bce6.jpg"
        }
      ],
      "Documents": [
        {
          "Description": "Datasheet",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/80d3adfe-a0ba-4ba2-adf8-f78e0a798781.pdf"
        }
      ],
      "Relatedproducts": [
        "YEA-SIP-T43U"
      ],
      "Accessories": [
        "YEA-EXP43",
        "YEA-PS5V2000US",
        "YEA-EHS40",
        "YEA-EXP43",
        "YEA-WF40",
        "YEA-WF50",
        "YEA-BT41",
        "YEA-WMB-T46",
        "YEA-WH62-DUAL-TEAMS",
        "YEA-WH62-DUAL-UC",
        "YEA-WH62-MONO-TEAMS",
        "YEA-WH62-MONO-UC",
        "YEA-WH63-TEAMS",
        "YEA-WH63-UC",
        "YEA-WH66-DUAL-TEAMS",
        "YEA-WH66-DUAL-UC",
        "YEA-WH67-TEAMS",
        "YEA-WH67-UC",
        "YEA-UH36-DUAL-TEAMS",
        "YEA-UH36-DUAL-UC",
        "YEA-UH36-MONO-TEAMS",
        "YEA-UH36-MONO-UC",
        "YEA-HNDST-T46",
        "YEA-WARR-B"
      ],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": true,
      "Height": 11,
      "Length": 12,
      "Width": 6,
      "Weight": 3.1,
      "DimensionalAirWeigth": 5.7,
      "DimensionalGroundWeight": 4.77,
      "Features": [
        {
          "Name": "Bluetooth",
          "Value": "Yes"
        },
        {
          "Name": "Call Waiting",
          "Value": "Yes"
        },
        {
          "Name": "Caller ID (CID)",
          "Value": "Yes"
        },
        {
          "Name": "Conference Calling",
          "Value": "Yes"
        },
        {
          "Name": "Corded or Cordless",
          "Value": "Corded"
        },
        {
          "Name": "EHS",
          "Value": "Yes"
        },
        {
          "Name": "Ethernet Ports",
          "Value": "2"
        },
        {
          "Name": "Headset Port",
          "Value": "Yes"
        },
        {
          "Name": "Number SIP Accounts/Identities",
          "Value": "10+"
        },
        {
          "Name": "Power Source",
          "Value": "PoE"
        },
        {
          "Name": "Speakerphone",
          "Value": "Yes"
        },
        {
          "Name": "Voicemail",
          "Value": "Yes"
        },
        {
          "Name": "Wall Mountable",
          "Value": "Yes"
        },
        {
          "Name": "Wifi",
          "Value": "Yes"
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": "Retail Box"
        },
        {
          "Name": "Warranty",
          "Value": "1 Year"
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-SIP-T46U",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-SIP-T46U",
      "Manufacturer": "Yealink",
      "ProductName": "Unified Firmware Enhanced SIP Phone",
      "UnitPrice": 114,
      "MSRP": 269,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 1000,
      "UPC": "841885102980"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 159,
      "PriceChangeDate": "2024-01-31T17:15:04.46",
      "ShipmentRecievedDate": "2020-07-07T00:00:00",
      "StandardPrice": 82,
      "EnergyStartCompliant": false,
      "ProductDescription": "- 3.7\" 360x160-pixel graphical LCD with backlight<br/>- Dual USB ports<br/>- Dual firmware images<br/>- Opus codec support<br/>- T42U (pending)/T43U/T46U/T48U Auto-P template unified<br/>- T42U (pending)/T43U/T46U/T48U firmware unified<br/>- Up to 12 SIP accounts<br/>- PoE support<br/>- USB headset and EHS support<br/>- Wi-Fi via WF40/WF50<br/>- Bluetooth via BT40/BT41<br/>- Supports color-screen expansion modules<br/>- Stand with 2 adjustable angles<br/>- Wall mountable<br/>- Expandable with YEA-EXP43<br/>- PSU not included<br/>- Does not support EHS36 and EXP40",
      "SKU": "Unified Firmware Enhanced SIP Phone T43U",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-SIP-T43U",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/4c29bfb5-13d8-4ff9-a3b5-b03a9a6d70cf.jpg"
        },
        {
          "Description": "YEA-SIP-T43U",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/78ff94af-4b31-402b-8755-f6b5eb45c4c5.jpg"
        },
        {
          "Description": "YEA-SIP-T43U",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/886e3834-d501-47f7-9ca4-e6994e80c689.jpg"
        }
      ],
      "Documents": [
        {
          "Description": "Datasheet",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/4e7a488a-2fe7-48f2-82c4-c46b0df5dc55.pdf"
        }
      ],
      "Relatedproducts": [
        "YEA-SIP-T46U"
      ],
      "Accessories": [
        "YEA-EXP43",
        "YEA-EHS40",
        "YEA-EXP43",
        "YEA-WF40",
        "YEA-WF50",
        "YEA-BT41",
        "YEA-WMB-T4S",
        "YEA-WH62-DUAL-TEAMS",
        "YEA-WH62-DUAL-UC",
        "YEA-WH62-MONO-TEAMS",
        "YEA-WH62-MONO-UC",
        "YEA-WH63-TEAMS",
        "YEA-WH63-UC",
        "YEA-WH66-DUAL-TEAMS",
        "YEA-WH66-DUAL-UC",
        "YEA-WH67-TEAMS",
        "YEA-WH67-UC",
        "YEA-UH36-DUAL-TEAMS",
        "YEA-UH36-DUAL-UC",
        "YEA-UH36-MONO-TEAMS",
        "YEA-UH36-MONO-UC",
        "YEA-HNDST-T4S",
        "YEA-PS5V1200US",
        "YEA-HC-T42",
        "YEA-WARR-A"
      ],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": true,
      "Height": 9,
      "Length": 11,
      "Width": 5,
      "Weight": 3.1,
      "DimensionalAirWeigth": 3.56,
      "DimensionalGroundWeight": 2.98,
      "Features": [
        {
          "Name": "Bluetooth",
          "Value": "Yes"
        },
        {
          "Name": "Call Waiting",
          "Value": "Yes"
        },
        {
          "Name": "Caller ID (CID)",
          "Value": "Yes"
        },
        {
          "Name": "Conference Calling",
          "Value": "Yes"
        },
        {
          "Name": "Corded or Cordless",
          "Value": "Corded"
        },
        {
          "Name": "EHS",
          "Value": "Yes"
        },
        {
          "Name": "Ethernet Ports",
          "Value": "2"
        },
        {
          "Name": "Headset Port",
          "Value": "Yes"
        },
        {
          "Name": "Microsoft Lync/Skype for Business",
          "Value": null
        },
        {
          "Name": "Number SIP Accounts/Identities",
          "Value": "10+"
        },
        {
          "Name": "Power Source",
          "Value": "PoE"
        },
        {
          "Name": "Speakerphone",
          "Value": "Yes"
        },
        {
          "Name": "Voicemail",
          "Value": "Yes"
        },
        {
          "Name": "Wall Mountable",
          "Value": "Yes"
        },
        {
          "Name": "Wifi",
          "Value": "Yes"
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "Retail Box"
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": "Retail Box"
        },
        {
          "Name": "Warranty",
          "Value": "1 Year"
        },
        {
          "Name": "Website Link",
          "Value": "YEA-SIP-T43U"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-SIP-T43U",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-SIP-T43U",
      "Manufacturer": "Yealink",
      "ProductName": "Unified Firmware Enhanced SIP Phone T43U",
      "UnitPrice": 82,
      "MSRP": 179,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 1000,
      "UPC": "841885102973"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 89,
      "PriceChangeDate": "2021-11-30T20:55:02.997",
      "ShipmentRecievedDate": "2020-07-07T00:00:00",
      "StandardPrice": 88,
      "EnergyStartCompliant": false,
      "ProductDescription": "- 4.3\" 272 x 480-pixel color screen<br/>- Color icons for rich visual experience<br/>- 20 physical keys on each page with dual-color LEDs<br/>- Three independent control keys with illuminated LED for fast switching pages<br/>- Supports up to 3 modules daisy-chain<br/>- Stand with 2 adjustable angles<br/>- Compatible only with T43U/T46U/T48U",
      "SKU": "Yealink T4U series Expansion Module",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": " YEA-EXP43",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/b3c68add-2280-4342-84ef-9090d641195c.jpg"
        }
      ],
      "Documents": [
        {
          "Description": "Quick Start Guide",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/e7d769b3-1bfb-4668-9491-0be19ec3ce70.pdf"
        },
        {
          "Description": "Datasheet",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/2f03a805-d99f-4b34-88a9-ff93b3c9705e.pdf"
        }
      ],
      "Relatedproducts": [
        "YEA-SIP-T43U",
        "YEA-SIP-T46U",
        "YEA-SIP-T48U"
      ],
      "Accessories": [
        "YEA-WMB-EXP43"
      ],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 9,
      "Length": 6,
      "Width": 4,
      "Weight": 1.3,
      "DimensionalAirWeigth": 1.55,
      "DimensionalGroundWeight": 1.3,
      "Features": [
        {
          "Name": "Expansion Modules",
          "Value": "Yes"
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": "Retail Box"
        },
        {
          "Name": "Warranty",
          "Value": "1 Year"
        },
        {
          "Name": "Website Link",
          "Value": "http://www.yealink.com/"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-EXP43",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-EXP43",
      "Manufacturer": "Yealink",
      "ProductName": "Yealink T4U series Expansion Module",
      "UnitPrice": 88,
      "MSRP": 99,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 526,
      "UPC": "841885103000"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 269,
      "PriceChangeDate": "2021-09-30T19:55:03.3",
      "ShipmentRecievedDate": "2020-08-19T00:00:00",
      "StandardPrice": 203,
      "EnergyStartCompliant": false,
      "ProductDescription": "- Android 9<br/>- 7-inch capacitive touch screen<br/>- Optimal HD audio with Yealink noise-proof technology<br/>- Magnet handset<br/>- Dedicated MS Teams button and interface<br/>- Built in Bluetooth and dual-brand 2.4G/ 5G Wi-Fi<br/>- 1x USB port for USB headset support<br/>- Dual-port Gigabit Ethernet<br/>- PoE support<br/>- Supports Microsoft/ Yealink/ U2 device management platforms",
      "SKU": "1301193 Microsoft Certified Teams Phone",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-MP56-Teams",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/8e014336-c67e-45e0-b6af-6c559b0c8bf5.jpg"
        }
      ],
      "Documents": [
        {
          "Description": "Datasheet",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/2fb103fd-d04f-4ab0-8cdf-e5346c875af9.pdf"
        }
      ],
      "Relatedproducts": [],
      "Accessories": [
        "YEA-PS5V2000US",
        "YEA-WMB-MP56",
        "YEA-EXP50",
        "YEA-PS5V2000US",
        "YEA-WH62-DUAL-TEAMS",
        "YEA-WH62-DUAL-UC",
        "YEA-WH62-MONO-TEAMS",
        "YEA-WH62-MONO-UC",
        "YEA-WH63-TEAMS",
        "YEA-WH63-UC",
        "YEA-WH66-DUAL-TEAMS",
        "YEA-WH66-DUAL-UC",
        "YEA-WH67-TEAMS",
        "YEA-WH67-UC",
        "YEA-UH36-DUAL-TEAMS",
        "YEA-UH36-DUAL-UC",
        "YEA-UH36-MONO-TEAMS",
        "YEA-UH36-MONO-UC",
        "YEA-HNDST-T5X",
        "YEA-HNDST-MP56",
        "YEA-WARR-C"
      ],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": true,
      "Height": 10,
      "Length": 12,
      "Width": 5,
      "Weight": 3.25,
      "DimensionalAirWeigth": 4.32,
      "DimensionalGroundWeight": 3.61,
      "Features": [
        {
          "Name": "Bluetooth",
          "Value": "Yes"
        },
        {
          "Name": "Call Waiting",
          "Value": "Yes"
        },
        {
          "Name": "Caller ID (CID)",
          "Value": "Yes"
        },
        {
          "Name": "Conference Calling",
          "Value": "Yes"
        },
        {
          "Name": "Corded or Cordless",
          "Value": "Corded"
        },
        {
          "Name": "Ethernet Ports",
          "Value": "1"
        },
        {
          "Name": "Headset Port",
          "Value": "Yes"
        },
        {
          "Name": "Microsoft Lync/Skype for Business",
          "Value": "Yes"
        },
        {
          "Name": "Power Source",
          "Value": "PoE"
        },
        {
          "Name": "Speakerphone",
          "Value": "Yes"
        },
        {
          "Name": "Teams Platform",
          "Value": "Yes"
        },
        {
          "Name": "Voicemail",
          "Value": "Yes"
        },
        {
          "Name": "Wifi",
          "Value": "Yes"
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": "Retail Box"
        },
        {
          "Name": "Warranty",
          "Value": "1 Year"
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-MP56-TEAMS",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-MP56-TEAMS",
      "Manufacturer": "Yealink",
      "ProductName": "1301193 Microsoft Certified Teams Phone",
      "UnitPrice": 203,
      "MSRP": 339,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 1000,
      "UPC": "841885102959"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 219,
      "PriceChangeDate": "2024-01-31T17:15:04.46",
      "ShipmentRecievedDate": "2020-07-22T00:00:00",
      "StandardPrice": 156,
      "EnergyStartCompliant": false,
      "ProductDescription": "- Seamless handover and roaming<br/>- Rugged DECT handset with IP67 protection rating<br/>- Scratch resistant, disinfectant resistant<br/>- 1.8’’ 128x160 TFT color screen with intuitive user interface<br/>- HD voice and FNR (Flexible Noise Reduction)<br/>- Built-in Bluetooth<br/>- Vibration alarm<br/>- Alarm functions for occupational safety: push-button alarm, no-movement alarm, mandown alarm and running alarm<br/>- Up to 28 hours of talk time (18 hours with Bluetooth headset)<br/>- Up to 360 hours of standby time (200 hours with Bluetooth headset)<br/>- Keypad backlight and keypad lock<br/>- LC3 (Low Complexity Communication Codec) Plus for high and stable audio quality<br/>- Fully compatible with Yealink W80 Multi-Cell System for seamless roaming and handover<br/>- *This unit requires either a YEA-W70B Base Station or a YEA-W80DM and YEA-W80B to work*",
      "SKU": "Yealink rugged DECT handset",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-W59R",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/dbe756a0-f8dc-4de4-ac1d-3a8b34245365.jpg"
        },
        {
          "Description": "YEA-W59R",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/f538d8e8-a094-4df9-b957-4a06565177bd.jpg"
        },
        {
          "Description": "YEA-W59R",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/c6ebd94e-ddc7-4e6e-ab6b-944140d520d4.jpg"
        },
        {
          "Description": "YEA-W59R",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/0a1d058a-0cb7-4c94-ae6e-732d30101efd.jpg"
        }
      ],
      "Documents": [
        {
          "Description": "Datasheet",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/85b4c2be-c742-4ee5-b8e4-6df938ca1099.pdf"
        }
      ],
      "Relatedproducts": [
        "YEA-W80-DEPLOY-KIT",
        "YEA-W80B",
        "YEA-W80DM",
        "YEA-W60B"
      ],
      "Accessories": [
        "YEA-BTC-W59R",
        "YEA-BCL-W59R",
        "YEA-CCD-W59R",
        "BATT-YLW56H",
        "YEA-WARR-B"
      ],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": true,
      "Height": 4,
      "Length": 8,
      "Width": 5,
      "Weight": 0.95,
      "DimensionalAirWeigth": 1.15,
      "DimensionalGroundWeight": 0.96,
      "Features": [
        {
          "Name": "Accessories",
          "Value": "Yes"
        },
        {
          "Name": "Accessory Handsets",
          "Value": "Yes"
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": "Retail Box"
        },
        {
          "Name": "Warranty",
          "Value": "1 Year"
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-W59R",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-W59R",
      "Manufacturer": "Yealink",
      "ProductName": "Yealink rugged DECT handset",
      "UnitPrice": 156,
      "MSRP": 219,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 782,
      "UPC": "841885104410"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 109,
      "PriceChangeDate": "2023-08-31T17:35:03.613",
      "ShipmentRecievedDate": "2020-07-21T00:00:00",
      "StandardPrice": 62,
      "EnergyStartCompliant": false,
      "ProductDescription": "- Yealink HD Voice<br/>- 2.4” 320 x 240-pixel color display with backlight<br/>- Dual-port Gigabit Ethernet<br/>- PoE support<br/>- Opus codec support<br/>- Up to 4 SIP accounts<br/>- Local 5-way conferencing<br/>- Support EHS Wireless Headset<br/>- Unified Firmware<br/>- Support YDMP/YMCS<br/>- Stand with 2 adjustable angles<br/>- Wall mountable (requires YEA-WMB-T33G)",
      "SKU": "Entry Level Gigabit POE Color LCD 4-Line",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-SIP-T33G",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/56717b53-40ac-495d-88fb-3ea417acf753.jpg"
        },
        {
          "Description": "YEA-SIP-T33G",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/3a466b27-8232-48b4-81d2-1bcd0fc38459.jpg"
        },
        {
          "Description": "YEA-SIP-T33G",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/24dd0164-49f9-4fbb-ac63-3491d6af2552.jpg"
        }
      ],
      "Documents": [
        {
          "Description": "Datasheet",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/d3574e53-cb4d-47e4-a77f-575585922afb.pdf"
        }
      ],
      "Relatedproducts": [
        "YEA-SIP-T23G",
        "YEA-SIP-T27G",
        "YEA-SIP-T29G",
        "YEA-SIP-T40G",
        "YEA-SIP-T42G",
        "YEA-SIP-T46G"
      ],
      "Accessories": [
        "YEA-PS5V600US",
        "YEA-WMB-T33G",
        "YEA-HC-T3X",
        "YEA-TSP-T33G",
        "YEA-HNDST-T3G",
        "YEA-STAND-T33G",
        "YEA-WARR-A"
      ],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": true,
      "Height": 9,
      "Length": 10,
      "Width": 5,
      "Weight": 2.15,
      "DimensionalAirWeigth": 3.24,
      "DimensionalGroundWeight": 2.71,
      "Features": [
        {
          "Name": "Call Waiting",
          "Value": "Yes"
        },
        {
          "Name": "Caller ID (CID)",
          "Value": "Yes"
        },
        {
          "Name": "Conference Calling",
          "Value": "Yes"
        },
        {
          "Name": "Corded or Cordless",
          "Value": "Corded"
        },
        {
          "Name": "EHS",
          "Value": "Yes"
        },
        {
          "Name": "Ethernet Ports",
          "Value": "2"
        },
        {
          "Name": "Headset Port",
          "Value": "Yes"
        },
        {
          "Name": "Number SIP Accounts/Identities",
          "Value": "4"
        },
        {
          "Name": "Power Source",
          "Value": "PoE"
        },
        {
          "Name": "Speakerphone",
          "Value": "Yes"
        },
        {
          "Name": "Voicemail",
          "Value": "Yes"
        },
        {
          "Name": "Wall Mountable",
          "Value": "Yes"
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": "Retail Box"
        },
        {
          "Name": "Warranty",
          "Value": "1 Year"
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-SIP-T33G",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-SIP-T33G",
      "Manufacturer": "Yealink",
      "ProductName": "Entry Level Gigabit POE Color LCD 4-Line",
      "UnitPrice": 62,
      "MSRP": 109,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 1000,
      "UPC": "841885104878"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 26,
      "PriceChangeDate": "2021-09-30T19:35:03.403",
      "ShipmentRecievedDate": "2020-07-27T00:00:00",
      "StandardPrice": 25,
      "EnergyStartCompliant": false,
      "ProductDescription": "- Compatible with only CP700/CP900<br/>- Reliable connection<br/>- Up to 100ft/30m wireless range<br/>- Easy to use<br/>- Plug and play<br/>- For computer use only",
      "SKU": "1300003 BT USB Dongle for CP700,900",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-BT50",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/c3856023-e660-46bd-963c-22c2eb137699.jpg"
        }
      ],
      "Documents": [
        {
          "Description": "Datasheet",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/d2db8523-3791-457d-9b1b-fbad211e81c8.pdf"
        }
      ],
      "Relatedproducts": [
        "YEA-CP700-TEAMS",
        "YEA-CP700-BT-TEAMS",
        "YEA-CP900-TEAMS",
        "YEA-CP900-BT-TEAMS"
      ],
      "Accessories": [],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 1,
      "Length": 3.7,
      "Width": 2.25,
      "Weight": 0.2,
      "DimensionalAirWeigth": 0.06,
      "DimensionalGroundWeight": 0.05,
      "Features": [
        {
          "Name": "Bluetooth",
          "Value": "Yes"
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": null
        },
        {
          "Name": "Warranty",
          "Value": "1 Year"
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "Computer and Networking",
          "SubCategories": [
            {
              "Name": "Computer Accessories"
            }
          ]
        }
      ],
      "PartNumber": "YEA-BT50",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-BT50",
      "Manufacturer": "Yealink",
      "ProductName": "1300003 BT USB Dongle for CP700,900",
      "UnitPrice": 25,
      "MSRP": 29,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 224,
      "UPC": "6938818304420"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 0,
      "PriceChangeDate": "2020-07-27T16:15:04.463",
      "ShipmentRecievedDate": "2020-08-11T00:00:00",
      "StandardPrice": 10,
      "EnergyStartCompliant": false,
      "ProductDescription": "- W53P and W53H Charging Dock<br/>- Needs a adapter for wall outlet 5v 600ma usb/ac adapter. Can be purchased online. ",
      "SKU": "230200400000 W53P and W53H Charging Dock",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-W53-CHARGEDOCK",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/5a2b57bf-2d7b-4349-bcb0-903a00c59f1e.jpg"
        }
      ],
      "Documents": [],
      "Relatedproducts": [
        "YEA-W53H",
        "YEA-W53P"
      ],
      "Accessories": [],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 1,
      "Length": 4,
      "Width": 3,
      "Weight": 0.1,
      "DimensionalAirWeigth": 0.09,
      "DimensionalGroundWeight": 0.07,
      "Features": [
        {
          "Name": "Accessories",
          "Value": "Yes"
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": "Retail Box"
        },
        {
          "Name": "Warranty",
          "Value": "1 Year"
        },
        {
          "Name": "Website Link",
          "Value": "http://www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-W53-CHARGEDOCK",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-W53-CHARGEDOCK",
      "Manufacturer": "Yealink",
      "ProductName": "230200400000 W53P and W53H Charging Dock",
      "UnitPrice": 10,
      "MSRP": 0,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 12,
      "UPC": "W53-CHARGEDOCK"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 68,
      "PriceChangeDate": "2024-01-31T17:15:04.46",
      "ShipmentRecievedDate": "2020-09-10T00:00:00",
      "StandardPrice": 36,
      "EnergyStartCompliant": false,
      "ProductDescription": "- Yealink HD Voice<br/>- 2.3” 132x64-pixel graphical LCD with backlight<br/>- Two-port 10/100M Ethernet Switch<br/>- PoE support<br/>- Opus codec support<br/>- Up to 2 SIP accounts<br/>- Local 5-way conferencing<br/>- Support EHS Wireless Headset<br/>- Unified Firmware<br/>- Support YDMP/YMCS<br/>- Stand with 2 adjustable angles<br/>- Wall mountable",
      "SKU": "Entry Level IP Phone 2 Lines HD Voice",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-SIP-T31P",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/9dac6973-156a-4860-b22c-2ede9ccc4a9c.jpg"
        },
        {
          "Description": "YEA-SIP-T31P",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/972f77c8-3443-4e01-941b-11749bd0f09c.jpg"
        }
      ],
      "Documents": [
        {
          "Description": "Datasheet",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/e75e6891-7b6c-4ba9-b216-26d996d77817.pdf"
        }
      ],
      "Relatedproducts": [
        "YEA-SIP-T31G",
        "YEA-SIP-T33G"
      ],
      "Accessories": [
        "YEA-PS5V600US",
        "YEA-HC-T3X",
        "YEA-WMB-T31G",
        "YEA-HNDST-T3G",
        "YEA-WARR-A"
      ],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": true,
      "Height": 9,
      "Length": 10,
      "Width": 5,
      "Weight": 2.15,
      "DimensionalAirWeigth": 3.24,
      "DimensionalGroundWeight": 2.71,
      "Features": [
        {
          "Name": "Call Waiting",
          "Value": "Yes"
        },
        {
          "Name": "Caller ID (CID)",
          "Value": "Yes"
        },
        {
          "Name": "Conference Calling",
          "Value": "Yes"
        },
        {
          "Name": "Corded or Cordless",
          "Value": "Corded"
        },
        {
          "Name": "EHS",
          "Value": "Yes"
        },
        {
          "Name": "Ethernet Ports",
          "Value": "2"
        },
        {
          "Name": "Headset Port",
          "Value": "Yes"
        },
        {
          "Name": "LCD Backlit Display",
          "Value": "Yes"
        },
        {
          "Name": "Number SIP Accounts/Identities",
          "Value": "2"
        },
        {
          "Name": "Power Source",
          "Value": "PoE"
        },
        {
          "Name": "SIP or Proprietary IP",
          "Value": "SIP Phones"
        },
        {
          "Name": "Speakerphone",
          "Value": "Yes"
        },
        {
          "Name": "Voicemail",
          "Value": "Yes"
        },
        {
          "Name": "Wall Mountable",
          "Value": "Yes"
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": "Retail Box"
        },
        {
          "Name": "Warranty",
          "Value": "1 Year"
        },
        {
          "Name": "Website Link",
          "Value": "http://www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-SIP-T31P",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-SIP-T31P",
      "Manufacturer": "Yealink",
      "ProductName": "Entry Level IP Phone 2 Lines HD Voice",
      "UnitPrice": 36,
      "MSRP": 75,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 1000,
      "UPC": "841885104816"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 89,
      "PriceChangeDate": "2024-01-25T12:35:03.213",
      "ShipmentRecievedDate": "2020-09-10T00:00:00",
      "StandardPrice": 47,
      "EnergyStartCompliant": false,
      "ProductDescription": "- Yealink HD Voice<br/>- 2.3” 132x64-pixel graphical LCD with backlight<br/>- Dual-port Gigabit Ethernet<br/>- PoE support<br/>- Opus codec support<br/>- Up to 2 SIP accounts<br/>- Local 5-way conferencing<br/>- Support EHS Wireless Headset<br/>- Unified Firmware<br/>- Support YDMP/YMCS<br/>- Stand with 2 adjustable angles<br/>- Wall mountable",
      "SKU": "Entry Level Gigabit POE 2-Line HD Voice",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-SIP-T31G",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/572c9948-f713-4ede-a479-962fd0244876.jpg"
        },
        {
          "Description": "YEA-SIP-T31G",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/ca1ade21-104e-447d-a7b6-7dcd12728762.jpg"
        }
      ],
      "Documents": [
        {
          "Description": "Datasheet",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/1a5107b7-acf3-44a8-9419-88b1e490dfe9.pdf"
        }
      ],
      "Relatedproducts": [
        "YEA-SIP-T31P",
        "YEA-SIP-T33G"
      ],
      "Accessories": [
        "YEA-PS5V600US",
        "YEA-YHS34-DUAL",
        "YEA-YHS34-LITE-DUAL",
        "YEA-YHS34-LITE-MONO",
        "YEA-YHS34-MONO",
        "YEA-STAND-T31G",
        "YEA-HC-T3X",
        "YEA-HNDST-T3G",
        "YEA-WMB-T31G",
        "YEA-WARR-A"
      ],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": true,
      "Height": 9,
      "Length": 10,
      "Width": 5,
      "Weight": 2.15,
      "DimensionalAirWeigth": 3.24,
      "DimensionalGroundWeight": 2.71,
      "Features": [
        {
          "Name": "Call Waiting",
          "Value": "Yes"
        },
        {
          "Name": "Caller ID (CID)",
          "Value": "Yes"
        },
        {
          "Name": "Conference Calling",
          "Value": "Yes"
        },
        {
          "Name": "Corded or Cordless",
          "Value": "Corded"
        },
        {
          "Name": "EHS",
          "Value": "Yes"
        },
        {
          "Name": "Ethernet Ports",
          "Value": "2"
        },
        {
          "Name": "Headset Port",
          "Value": "Yes"
        },
        {
          "Name": "LCD Backlit Display",
          "Value": "Yes"
        },
        {
          "Name": "Number SIP Accounts/Identities",
          "Value": "2"
        },
        {
          "Name": "Power Source",
          "Value": "PoE"
        },
        {
          "Name": "Speakerphone",
          "Value": "Yes"
        },
        {
          "Name": "Voicemail",
          "Value": "Yes"
        },
        {
          "Name": "Wall Mountable",
          "Value": "Yes"
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": "Retail Box"
        },
        {
          "Name": "Warranty",
          "Value": "1 Year"
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-SIP-T31G",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-SIP-T31G",
      "Manufacturer": "Yealink",
      "ProductName": "Entry Level Gigabit POE 2-Line HD Voice",
      "UnitPrice": 47,
      "MSRP": 99,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 429,
      "UPC": "841885104830"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 95,
      "PriceChangeDate": "2020-09-10T14:15:03.28",
      "ShipmentRecievedDate": "2020-09-11T00:00:00",
      "StandardPrice": 83,
      "EnergyStartCompliant": false,
      "ProductDescription": "- Connectivity: USB 2.0 & Bluetooth<br/>- USB cable length: 2.6 feet / 0.8 meter<br/>- Touch Buttons: ower, Bluetooth, Call answer, Call hangup, Volume up, Volume down, Mute, Voice assistant/Teams<br/>- Talk time: 10 hours<br/>- Standby time: 360 days (Power safe after 30min)<br/>- Optima HD voice<br/>- Wideband Audio<br/>- Audio duplex<br/>- Noise suppression (NS)<br/>- Digital Signal Processing (DSP)<br/>- Acoustic echo cancellation (AEC)",
      "SKU": "1304012 CP700 USB Speakerphone UC",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-CP700-UC",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/ef790dd5-ff29-4c68-8f88-5748cc006136.jpg"
        }
      ],
      "Documents": [
        {
          "Description": "Datasheet",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/1bec43cf-38e9-4bc1-9f7b-3e8301e187b6.pdf"
        }
      ],
      "Relatedproducts": [
        "YEA-CP700-BT-TEAMS",
        "YEA-CP700-BT-UC",
        "YEA-CP700-TEAMS",
        "YEA-CP900-BT-TEAMS",
        "YEA-CP900-BT-UC",
        "YEA-CP900-TEAMS",
        "YEA-CP900-UC"
      ],
      "Accessories": [
        "YEA-BT51-C"
      ],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 2.1,
      "Length": 6.5,
      "Width": 5.7,
      "Weight": 0.8,
      "DimensionalAirWeigth": 0.56,
      "DimensionalGroundWeight": 0.47,
      "Features": [
        {
          "Name": "Echo Cancellation",
          "Value": "Yes"
        },
        {
          "Name": "Full Duplex Speakerphone",
          "Value": "Yes"
        },
        {
          "Name": "No. Accessory/Replacement Microphones",
          "Value": null
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": "Retail Box"
        },
        {
          "Name": "Warranty",
          "Value": "2 Year"
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "Business Equipment",
          "SubCategories": [
            {
              "Name": "Conferencing Equipment"
            }
          ]
        }
      ],
      "PartNumber": "YEA-CP700-UC",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-CP700-UC",
      "Manufacturer": "Yealink",
      "ProductName": "1304012 CP700 USB Speakerphone UC",
      "UnitPrice": 83,
      "MSRP": 129,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 0,
      "UPC": "6938818305489"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 155,
      "PriceChangeDate": "2020-09-10T14:15:03.28",
      "ShipmentRecievedDate": "2020-09-11T00:00:00",
      "StandardPrice": 115,
      "EnergyStartCompliant": false,
      "ProductDescription": "- 8 touch buttons<br/>- Connectivity: USB 2.0 PNP & Bluetooth<br/>- USB cable length: 0.9 meter<br/>- Built-in Bluetooth 4.0<br/>- Wireless range: 30 m<br/>- Power: USB/Lithium Polymer Battery<br/>- Talk time: 12 hours<br/>- Optima HD voice<br/>- Microphone pickup 2 meters<br/>- Full-duplex technology<br/>- Noise suppression (NS)<br/>- Digital Signal Processing (DSP)<br/>- Acoustic echo cancellation (AEC)<br/>- Standby time: 450 days",
      "SKU": "1304013 CP900 USB Speakerphone UC",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-CP900-UC",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/22a49a0d-7fea-438e-add4-daa311d6285d.jpg"
        }
      ],
      "Documents": [],
      "Relatedproducts": [
        "YEA-CP900-BT-TEAMS",
        "YEA-CP900-BT-UC",
        "YEA-CP900-TEAMS"
      ],
      "Accessories": [
        "YEA-BT51-C"
      ],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 2.2,
      "Length": 7.2,
      "Width": 6.2,
      "Weight": 1.1,
      "DimensionalAirWeigth": 0.71,
      "DimensionalGroundWeight": 0.59,
      "Features": [
        {
          "Name": "Echo Cancellation",
          "Value": "Yes"
        },
        {
          "Name": "Full Duplex Speakerphone",
          "Value": "Yes"
        },
        {
          "Name": "No. Accessory/Replacement Microphones",
          "Value": null
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": null
        },
        {
          "Name": "Warranty",
          "Value": "1 Year"
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "Business Equipment",
          "SubCategories": [
            {
              "Name": "Conferencing Equipment"
            }
          ]
        }
      ],
      "PartNumber": "YEA-CP900-UC",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-CP900-UC",
      "Manufacturer": "Yealink",
      "ProductName": "1304013 CP900 USB Speakerphone UC",
      "UnitPrice": 115,
      "MSRP": 199,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 4,
      "UPC": "841885103567"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 110,
      "PriceChangeDate": "2020-09-10T14:55:02.6",
      "ShipmentRecievedDate": "2021-02-01T00:00:00",
      "StandardPrice": 96,
      "EnergyStartCompliant": false,
      "ProductDescription": "- 10-hour talk-time<br/>- 360-degree voice pick up <br/>- 2 omnidirectional microphones <br/>- Connectivity: USB 2.0 & Bluetooth <br/>- 100 feet / 30 meters wireless range <br/>- Acoustic echo cancellation <br/>- Touch Buttons: PowerBluetooth, Call answer, Call hangup, Volume up, Volume down, Mute, Voice assistant/Teams<br/>- Protective zipper bag<br/>- Immersive sound for calls or music<br/>- Intuitive indicators for simple use<br/>- Ultra-compact personal speakerphone<br/>- Supported by Microsoft Teams and Skype-for-Business<br/>- This includes a Yealink BT50 USB Bluetooth Dongle",
      "SKU": "1204610 CP700 Speakerphone with BT50 UC",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-CP700-BT-UC",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/c5acc3ed-37a2-453a-893a-8741db36565e.jpg"
        },
        {
          "Description": "YEA-CP700-BT-UC",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/060f0590-39ba-4dec-b35d-b241ffb19ee1.jpg"
        },
        {
          "Description": "YEA-CP700-BT-UC",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/4f566f1b-4f0e-460d-894a-a073260d4dc3.jpg"
        },
        {
          "Description": "YEA-CP700-BT-UC",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/5d21f650-f063-4420-9a22-e89436f58965.jpg"
        },
        {
          "Description": "YEA-CP700-BT-UC",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/d230b9b6-7b19-4266-af12-c7c020455626.jpg"
        }
      ],
      "Documents": [
        {
          "Description": "Datasheet",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/e19488d6-201f-49bb-bfbc-4e5dc80bbe71.pdf"
        }
      ],
      "Relatedproducts": [
        "YEA-CP700-BT-TEAMS",
        "YEA-CP700-TEAMS",
        "YEA-CP700-UC"
      ],
      "Accessories": [
        "YEA-USB2-2-5M",
        "YEA-USB2-7M",
        "YEA-USB2-EXT-10M",
        "YEA-USB2-EXT-20M",
        "YEA-USB2-EXT-5M",
        "YEA-USB2CAT5E-EXT",
        "YEA-USBC-HDMI",
        "YEA-BT51-C"
      ],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 2,
      "Length": 7,
      "Width": 6,
      "Weight": 0.75,
      "DimensionalAirWeigth": 0.6,
      "DimensionalGroundWeight": 0.51,
      "Features": [
        {
          "Name": "3-Way Calling",
          "Value": "Yes"
        },
        {
          "Name": "Bluetooth",
          "Value": "Yes"
        },
        {
          "Name": "Echo Cancellation",
          "Value": "Yes"
        },
        {
          "Name": "Mute",
          "Value": "Yes"
        },
        {
          "Name": "No. Accessory/Replacement Microphones",
          "Value": null
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": "Retail Box"
        },
        {
          "Name": "Warranty",
          "Value": "2 Year"
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "Business Equipment",
          "SubCategories": [
            {
              "Name": "Conferencing Equipment"
            }
          ]
        }
      ],
      "PartNumber": "YEA-CP700-BT-UC",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-CP700-BT-UC",
      "Manufacturer": "Yealink",
      "ProductName": "1204610 CP700 Speakerphone with BT50 UC",
      "UnitPrice": 96,
      "MSRP": 158,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 18,
      "UPC": "6938818305540"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 175,
      "PriceChangeDate": "2020-09-10T14:55:02.6",
      "ShipmentRecievedDate": "2021-02-01T00:00:00",
      "StandardPrice": 131,
      "EnergyStartCompliant": false,
      "ProductDescription": "- 8 touch buttons<br/>- Connectivity: USB 2.0 PNP & Bluetooth<br/>- USB cable length: 0.9 meter<br/>- Built-in Bluetooth 4.0<br/>- Wireless range: 30 m<br/>- Power: USB/Lithium Polymer Battery<br/>- Talk time: 12 hours<br/>- Optima HD voice<br/>- Microphone pickup 2 meters<br/>- Full-duplex technology<br/>- Noise suppression (NS)<br/>- Digital Signal Processing (DSP)<br/>- Acoustic echo cancellation (AEC)<br/>- Standby time: 450 days<br/>- This includes a Yealink BT50 USB Bluetooth Dongle",
      "SKU": "1204611 CP900 Speakerphone with BT50 UC",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-CP900-BT-UC",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/abe6d5a9-1008-4dd0-a93d-9e143f8d6a47.jpg"
        },
        {
          "Description": "YEA-CP900-BT-UC",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/4506a733-5950-4bdc-8c4f-27d0da7dc515.jpg"
        }
      ],
      "Documents": [
        {
          "Description": "Datasheet",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/339618db-161b-475b-808c-f97c002b86a1.pdf"
        }
      ],
      "Relatedproducts": [
        "YEA-CP900-BT-TEAMS",
        "YEA-CP900-TEAMS",
        "YEA-CP900-UC"
      ],
      "Accessories": [
        "YEA-USB2-2-5M",
        "YEA-USB2-7M",
        "YEA-USB2-EXT-10M",
        "YEA-USB2-EXT-20M",
        "YEA-USB2-EXT-5M",
        "YEA-USB2CAT5E-EXT",
        "YEA-USBC-HDMI",
        "YEA-BT51-C"
      ],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 3,
      "Length": 8,
      "Width": 7,
      "Weight": 2,
      "DimensionalAirWeigth": 1.21,
      "DimensionalGroundWeight": 1.01,
      "Features": [
        {
          "Name": "Bluetooth",
          "Value": "Yes"
        },
        {
          "Name": "Echo Cancellation",
          "Value": "Yes"
        },
        {
          "Name": "Mute",
          "Value": "Yes"
        },
        {
          "Name": "No. Accessory/Replacement Microphones",
          "Value": null
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": null
        },
        {
          "Name": "Warranty",
          "Value": "1 Year"
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "Business Equipment",
          "SubCategories": [
            {
              "Name": "Conferencing Equipment"
            }
          ]
        }
      ],
      "PartNumber": "YEA-CP900-BT-UC",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-CP900-BT-UC",
      "Manufacturer": "Yealink",
      "ProductName": "1204611 CP900 Speakerphone with BT50 UC",
      "UnitPrice": 131,
      "MSRP": 229,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 8,
      "UPC": "841885103574"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 8,
      "PriceChangeDate": "2020-10-14T16:15:04.847",
      "ShipmentRecievedDate": "2020-11-16T00:00:00",
      "StandardPrice": 5.5,
      "EnergyStartCompliant": false,
      "ProductDescription": "Wall Mount Bracket for MP56",
      "SKU": "330100000035 Wall Mount Bracket MP56",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-WMB-MP56",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/b722c3c7-06e6-4d60-bd0e-03295315c2e9.jpg"
        }
      ],
      "Documents": [],
      "Relatedproducts": [],
      "Accessories": [
        "YEA-EXP50"
      ],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 4,
      "Length": 7,
      "Width": 1,
      "Weight": 0.5,
      "DimensionalAirWeigth": 0.2,
      "DimensionalGroundWeight": 0.17,
      "Features": [
        {
          "Name": "Accessories",
          "Value": "Yes"
        },
        {
          "Name": "Wall Mountable",
          "Value": "Yes"
        }
      ],
      "EnvironmentalFeatures": [],
      "OtherFeatures": [],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-WMB-MP56",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-WMB-MP56",
      "Manufacturer": "Yealink",
      "ProductName": "330100000035 Wall Mount Bracket MP56",
      "UnitPrice": 5.5,
      "MSRP": 8,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 397,
      "UPC": "841885105325"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 0,
      "PriceChangeDate": "2020-11-16T10:35:04.64",
      "ShipmentRecievedDate": "2021-01-07T00:00:00",
      "StandardPrice": 1,
      "EnergyStartCompliant": false,
      "ProductDescription": "Yealink Handset Clip for T55",
      "SKU": "Yealink Handset Clip for T55",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-HC-T55",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/a7c0ae37-c579-4dac-b8e7-278e5d194b16.jpg"
        }
      ],
      "Documents": [],
      "Relatedproducts": [
        "YEA-100-055-003",
        "YEA-100-055-008"
      ],
      "Accessories": [],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 0.5,
      "Length": 0.5,
      "Width": 0.25,
      "Weight": 0.001,
      "DimensionalAirWeigth": 0,
      "DimensionalGroundWeight": 0,
      "Features": [
        {
          "Name": "Accessories",
          "Value": "Yes"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": null
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": null
        },
        {
          "Name": "Warranty",
          "Value": "1 Year"
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-HC-T55",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-HC-T55",
      "Manufacturer": "Yealink",
      "ProductName": "Yealink Handset Clip for T55",
      "UnitPrice": 1,
      "MSRP": 0,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 503,
      "UPC": "YEA-HC-T55"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 209,
      "PriceChangeDate": "2021-05-31T14:15:02.99",
      "ShipmentRecievedDate": "2021-01-05T00:00:00",
      "StandardPrice": 166,
      "EnergyStartCompliant": false,
      "ProductDescription": "- Android 9.0<br/>- 4 inch (800 x 480) Capacitive Touch Screen<br/>- Optimal HD audio, Yealink Noise Proof Technology<br/>- Magnet Handset<br/>- Dedicated Microsoft Teams button for MeetNow<br/>- Supports Upgradability of Firmware to Teams<br/>- 1x  USB 2.0 port for USB headsets, Bluetooth dongle and Wi-Fi dongle<br/>- Dual-port Gigabit Ethernet<br/>- Supports Microsoft/Yealink/Unify Square Device Management Platform<br/>- Wall mountable<br/>- IEEE 802.3af PoE support, without PSU",
      "SKU": "1301198 Cost-effective Phone for Teams",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-MP54-TEAMS",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/99a1af37-bfb5-4e35-9725-98cd80112392.jpg"
        },
        {
          "Description": "YEA-MP54-TEAMS",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/9a560684-f634-406f-a0aa-ee53fceb5c90.jpg"
        },
        {
          "Description": "YEA-MP54-TEAMS",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/83d6ba59-2b79-447c-8890-f57b6f44afec.jpg"
        }
      ],
      "Documents": [
        {
          "Description": "Datasheet",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/75c2f428-d0c5-4da0-a3b5-a84411417286.pdf"
        }
      ],
      "Relatedproducts": [
        "YEA-MP54-SFB",
        "YEA-MP56-SFB",
        "YEA-MP56-TEAMS"
      ],
      "Accessories": [
        "YEA-PS5V2000US",
        "YEA-UH36-DUAL-TEAMS",
        "YEA-UH36-DUAL-UC",
        "YEA-UH36-MONO-TEAMS",
        "YEA-UH36-MONO-UC",
        "YEA-WH62-DUAL-TEAMS",
        "YEA-WH62-DUAL-UC",
        "YEA-WH62-MONO-TEAMS",
        "YEA-WH62-MONO-UC",
        "YEA-WH63-TEAMS",
        "YEA-WH63-UC",
        "YEA-WH66-DUAL-TEAMS",
        "YEA-WH66-DUAL-UC",
        "YEA-WH67-TEAMS",
        "YEA-WH67-UC",
        "YEA-UH36-DUAL-TEAMS",
        "YEA-UH36-DUAL-UC",
        "YEA-UH36-MONO-TEAMS",
        "YEA-UH36-MONO-UC",
        "YEA-WMB-MP5",
        "YEA-HNDST-T53-T54",
        "YEA-WARR-B"
      ],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": true,
      "Height": 8,
      "Length": 11,
      "Width": 5,
      "Weight": 2.25,
      "DimensionalAirWeigth": 3.17,
      "DimensionalGroundWeight": 2.65,
      "Features": [
        {
          "Name": "Bluetooth",
          "Value": "Yes"
        },
        {
          "Name": "Call Waiting",
          "Value": "Yes"
        },
        {
          "Name": "Caller ID (CID)",
          "Value": "Yes"
        },
        {
          "Name": "Conference Calling",
          "Value": "Yes"
        },
        {
          "Name": "Corded or Cordless",
          "Value": "Corded"
        },
        {
          "Name": "Ethernet Ports",
          "Value": "2"
        },
        {
          "Name": "Headset Port",
          "Value": "Yes"
        },
        {
          "Name": "LCD Backlit Display",
          "Value": "Yes"
        },
        {
          "Name": "Microsoft Lync/Skype for Business",
          "Value": "Yes"
        },
        {
          "Name": "Power Source",
          "Value": "PoE"
        },
        {
          "Name": "Speakerphone",
          "Value": "Yes"
        },
        {
          "Name": "Teams Platform",
          "Value": "Yes"
        },
        {
          "Name": "Wall Mountable",
          "Value": "Yes"
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": "Retail Box"
        },
        {
          "Name": "Warranty",
          "Value": "1 Year"
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-MP54-TEAMS",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-MP54-TEAMS",
      "Manufacturer": "Yealink",
      "ProductName": "1301198 Cost-effective Phone for Teams",
      "UnitPrice": 166,
      "MSRP": 239,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 1000,
      "UPC": "841885103529"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 469,
      "PriceChangeDate": "2024-01-31T17:15:04.46",
      "ShipmentRecievedDate": "2021-01-11T00:00:00",
      "StandardPrice": 245,
      "EnergyStartCompliant": false,
      "ProductDescription": "- Support Air and LAN synchronization<br/>- Seamless handover and roaming<br/>- Up to 60 base stations<br/>- Up to 250 handsets<br/>- Up to 250 SIP accounts<br/>- Up to 250 parallel calls<br/>- Support XML/LDAP/Remote Phonebook<br/>- Support XSI Directory/XSI Call Log<br/>- External antenna, DECT radio coverage up to 50m indoors and 300m outdoors<br/>- Support Opus<br/>- Support SRTP / SIPS / TLS, LDAP(s) and<br/>- HTTPS<br/>- Support PoE<br/>- Compatible with Yealink W59R/W56H/W53H, CP930W and DD Phone",
      "SKU": "YEA-W90 DECT IP Multi-Cell System",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-W90B",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/62ac401c-a5bb-4a6b-8356-165232f6d877.jpg"
        },
        {
          "Description": "YEA-W90B",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/f21b03f3-2c5e-4b8e-8d3a-6997ae30fae9.jpg"
        }
      ],
      "Documents": [
        {
          "Description": "Datasheet",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/5e5e43bd-d50b-4db1-93f7-56d442757b67.pdf"
        },
        {
          "Description": "Quick Start Guide",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/1b8636b6-2cba-4135-aa5d-28b49eae0f5e.pdf"
        }
      ],
      "Relatedproducts": [
        "YEA-W90DM"
      ],
      "Accessories": [
        "YEA-WARR-C"
      ],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 3,
      "Length": 9,
      "Width": 7,
      "Weight": 1.4,
      "DimensionalAirWeigth": 1.36,
      "DimensionalGroundWeight": 1.14,
      "Features": [
        {
          "Name": "Accessories",
          "Value": "Yes"
        },
        {
          "Name": "Corded or Cordless",
          "Value": "Cordless"
        },
        {
          "Name": "Color",
          "Value": "White"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": "Retail Box"
        },
        {
          "Name": "Warranty",
          "Value": "1 Year"
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-W90B",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-W90B",
      "Manufacturer": "Yealink",
      "ProductName": "YEA-W90 DECT IP Multi-Cell System",
      "UnitPrice": 245,
      "MSRP": 469,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 89,
      "UPC": "841885105202"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 469,
      "PriceChangeDate": "2024-01-31T17:15:04.46",
      "ShipmentRecievedDate": "2021-01-11T00:00:00",
      "StandardPrice": 245,
      "EnergyStartCompliant": false,
      "ProductDescription": "- Seamless handover and roaming<br/>- Up to 250 parallel calls / 60 bases / 250 handsets / 250 SIP accounts<br/>- Support LDAP / Remote Phonebook / Xsi Directory<br/>- External antennas<br/>- Coverage up to 50m indoors and 300m outdoors<br/>- CAT-iq 2.0 DECT / Opus Codec<br/>- Compatible with Yealink W59R/W56H/W53H/CP930W/DD<br/>- PoE (no PSU included)<br/>- DECT Manger: for use with W90B",
      "SKU": "W90DM DECT Manager",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-W90DM",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/9d946806-871e-41e8-9e74-36984003d1d2.jpg"
        },
        {
          "Description": "YEA-W90DM",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/f8723f79-49d0-494a-ae33-feebbaa49b0b.jpg"
        }
      ],
      "Documents": [
        {
          "Description": "Datasheet",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/e96eb0be-96ad-4c7c-b301-f816e5d5f04b.pdf"
        },
        {
          "Description": "Quick Start Guide",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/7b1ba81c-f74d-44b1-9530-e50444b931b0.pdf"
        }
      ],
      "Relatedproducts": [
        "YEA-W90B"
      ],
      "Accessories": [
        "YEA-WARR-C"
      ],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 7.8,
      "Length": 17.1,
      "Width": 13.9,
      "Weight": 1.4,
      "DimensionalAirWeigth": 13.34,
      "DimensionalGroundWeight": 11.17,
      "Features": [
        {
          "Name": "Accessories",
          "Value": "Yes"
        },
        {
          "Name": "Corded or Cordless",
          "Value": "Cordless"
        },
        {
          "Name": "Color",
          "Value": "White"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": "Retail Box"
        },
        {
          "Name": "Warranty",
          "Value": "1 Year"
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-W90DM",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-W90DM",
      "Manufacturer": "Yealink",
      "ProductName": "W90DM DECT Manager",
      "UnitPrice": 245,
      "MSRP": 469,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 46,
      "UPC": "841885105219"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 229,
      "PriceChangeDate": "2023-06-09T16:15:05.127",
      "ShipmentRecievedDate": "2021-01-05T00:00:00",
      "StandardPrice": 61.11,
      "EnergyStartCompliant": false,
      "ProductDescription": "- Length adjustable wall mount bracket for camera<br/>- Apply to All Yealink MVC II Series Microsoft Teams Room System<br/>- Support 1.80-2.75m width whiteboard",
      "SKU": "330100052001 Content camera wall bracket",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-ContentCamMount-USB",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/64742782-d226-4379-8438-c99db2269629.jpg"
        },
        {
          "Description": "YEA-ContentCamMount-USB",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/8896449b-fc77-414c-a084-33fe91f08678.jpg"
        }
      ],
      "Documents": [],
      "Relatedproducts": [
        "YEA-MVC300ii-C2-600"
      ],
      "Accessories": [],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 7,
      "Length": 27,
      "Width": 4,
      "Weight": 3,
      "DimensionalAirWeigth": 5.44,
      "DimensionalGroundWeight": 4.55,
      "Features": [
        {
          "Name": "Accessories",
          "Value": "Yes"
        },
        {
          "Name": "Mounting Equipment",
          "Value": "Yes"
        },
        {
          "Name": "No. Accessory/Replacement Microphones",
          "Value": null
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": null
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": null
        },
        {
          "Name": "Warranty",
          "Value": null
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "Business Equipment",
          "SubCategories": [
            {
              "Name": "Conferencing Equipment"
            }
          ]
        }
      ],
      "PartNumber": "YEA-ContentCamMount-USB",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-ContentCamMount-USB",
      "Manufacturer": "Yealink",
      "ProductName": "330100052001 Content camera wall bracket",
      "UnitPrice": 61.11,
      "MSRP": 229,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 10,
      "UPC": "6938818305960"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 4500,
      "PriceChangeDate": "2020-12-22T16:55:03.32",
      "ShipmentRecievedDate": null,
      "StandardPrice": 3825,
      "EnergyStartCompliant": false,
      "ProductDescription": "- Full day, flat rate, on-site SKU for any MTR or ZR or Yealink Phone<br/>- Services options include but are not limited to: <br/>- Adoption/Training<br/>- Installation, Integration, Deployment<br/>- Troubleshooting, Technical Support & Maintenance",
      "SKU": "510108000041 Full day, on-site support",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-ON-SITE-SUPPORT",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/91b22f36-b3ae-4235-818d-9fc72feece6e.jpg"
        }
      ],
      "Documents": [],
      "Relatedproducts": [],
      "Accessories": [],
      "Leasable": false,
      "Virtual": true,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 0,
      "Length": 0,
      "Width": 0,
      "Weight": 0,
      "DimensionalAirWeigth": 0,
      "DimensionalGroundWeight": 0,
      "Features": [
        {
          "Name": "Installation, Extended Warranties, and Support",
          "Value": "Yes"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": null
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": null
        },
        {
          "Name": "Warranty",
          "Value": null
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "Business Equipment",
          "SubCategories": [
            {
              "Name": "Licenses and Warranties"
            }
          ]
        }
      ],
      "PartNumber": "YEA-ON-SITE-SUPPORT",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-ON-SITE-SUPPORT",
      "Manufacturer": "Yealink",
      "ProductName": "510108000041 Full day, on-site support",
      "UnitPrice": 3825,
      "MSRP": 4500,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 0,
      "UPC": ""
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 109,
      "PriceChangeDate": "2023-09-25T13:35:04.47",
      "ShipmentRecievedDate": "2021-02-11T00:00:00",
      "StandardPrice": 80,
      "EnergyStartCompliant": false,
      "ProductDescription": "- 4-inch capacitive touch screen<br/>- 3-ports USB 3.0 Hub<br/>- Supports Bluetooth Headset<br/>- Supports BT50 Dongle for PC<br/>- Supports Busylight<br/>- Optimal HD Audio<br/>- Yealink Noise Proof Technology<br/>- Full-duplex Hands-free Speakerphone with AEC<br/>- Dedicated Teams Button<br/>- Microsoft Teams-tailored User Interface<br/>- Teams and Skype for Business Compatible",
      "SKU": "1301110 USB Phone Compatible with Teams",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-MP50",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/88d8ea45-507e-438e-b507-cfa06afeb33e.jpg"
        },
        {
          "Description": "YEA-MP50",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/a6320b6e-2090-4085-b02e-aece7ff7eb6e.jpg"
        },
        {
          "Description": "YEA-MP50",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/85e37935-c58e-4b88-b52f-7d7a21b0c821.jpg"
        },
        {
          "Description": "YEA-MP50",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/c0e9801b-bcec-4c56-b8fc-13fe8b3d0840.jpg"
        }
      ],
      "Documents": [
        {
          "Description": "Datasheet",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/bc584c65-99ca-4567-8eda-f15441b6fc49.pdf"
        }
      ],
      "Relatedproducts": [
        "YEA-MP54-SFB",
        "YEA-MP54-TEAMS",
        "YEA-MP56-SFB",
        "YEA-MP56-TEAMS",
        "YEA-MP58-TEAMS"
      ],
      "Accessories": [
        "YEA-WMB-MP5",
        "YEA-HNDST-MP50"
      ],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": true,
      "Height": 8,
      "Length": 10,
      "Width": 5,
      "Weight": 2.45,
      "DimensionalAirWeigth": 2.88,
      "DimensionalGroundWeight": 2.41,
      "Features": [
        {
          "Name": "Bluetooth",
          "Value": "Yes"
        },
        {
          "Name": "Call Waiting",
          "Value": "Yes"
        },
        {
          "Name": "Conference Calling",
          "Value": "Yes"
        },
        {
          "Name": "Corded or Cordless",
          "Value": "Corded"
        },
        {
          "Name": "Headset Port",
          "Value": "Yes"
        },
        {
          "Name": "Microsoft Lync/Skype for Business",
          "Value": "Yes"
        },
        {
          "Name": "Power Source",
          "Value": "AC Adapter"
        },
        {
          "Name": "Power Supply Included",
          "Value": "Yes"
        },
        {
          "Name": "Wall Mountable",
          "Value": "Yes"
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": "Retail Box"
        },
        {
          "Name": "Warranty",
          "Value": "1 Year"
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-MP50",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-MP50",
      "Manufacturer": "Yealink",
      "ProductName": "1301110 USB Phone Compatible with Teams",
      "UnitPrice": 80,
      "MSRP": 119,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 144,
      "UPC": "841885105639"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 8,
      "PriceChangeDate": "2021-01-31T19:35:05.537",
      "ShipmentRecievedDate": "2021-02-22T00:00:00",
      "StandardPrice": 5.5,
      "EnergyStartCompliant": false,
      "ProductDescription": "Wall Mount Bracket for MP54 & MP50",
      "SKU": "3301000000 Wall Mount Bracket MP54, MP50",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-WMB-MP5",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/6d0ead6d-ed5c-4868-b3bd-95141e57da6a.jpg"
        }
      ],
      "Documents": [],
      "Relatedproducts": [],
      "Accessories": [],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 4,
      "Length": 7,
      "Width": 1,
      "Weight": 0.5,
      "DimensionalAirWeigth": 0.2,
      "DimensionalGroundWeight": 0.17,
      "Features": [
        {
          "Name": "Accessories",
          "Value": "Yes"
        },
        {
          "Name": "Stands, Mounting Equipment, and Cases",
          "Value": "Yes"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": null
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": null
        },
        {
          "Name": "Warranty",
          "Value": null
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-WMB-MP5",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-WMB-MP5",
      "Manufacturer": "Yealink",
      "ProductName": "3301000000 Wall Mount Bracket MP54, MP50",
      "UnitPrice": 5.5,
      "MSRP": 8,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 1000,
      "UPC": "841885106285"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 289,
      "PriceChangeDate": "2023-09-25T13:35:04.47",
      "ShipmentRecievedDate": "2021-02-22T00:00:00",
      "StandardPrice": 217,
      "EnergyStartCompliant": false,
      "ProductDescription": "- Android 12.0<br/>- 7 inch (1024 x 600) Capacitive Adjustable Touch Screen<br/>- Optimal HD audio, Yealink Noise Proof Technology<br/>- Dedicated Microsoft Teams Button<br/>- Supports Upgradability of Firmware to Teams or SFB Edition<br/>- Built-in Bluetooth 4.2 and Dual Band 2.4G/5G Wi-Fi<br/>- Supports Yealink Bluetooth Wireless Handset BTH58<br/>- Supports up to 3 Expansion Module EXP50<br/>- 2 x USB Type A ports<br/>- Dual-port Gigabit Ethernet, supports PoE<br/>- Supports Microsoft/Yealink/Unify Square Device Management Platform<br/>- Hybrid mode (Teams version only)",
      "SKU": "1301199 Premium Phone for Teams",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-MP58-TEAMS",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/1529f126-37f5-4356-a601-b9835fd902d6.jpg"
        },
        {
          "Description": "YEA-MP58-TEAMS",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/d03f2b68-103f-499c-8263-b4c05a2701d3.jpg"
        },
        {
          "Description": "YEA-MP58-TEAMS",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/f8099e89-e534-4918-8032-2d9d314049ed.jpg"
        },
        {
          "Description": "YEA-MP58-TEAMS",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/ffae0476-0e09-4557-ac97-c49c8697449d.jpg"
        }
      ],
      "Documents": [
        {
          "Description": "Datasheet",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/5598fdd1-7e78-49d8-938f-9d477a20da18.pdf"
        }
      ],
      "Relatedproducts": [
        "YEA-MP50",
        "YEA-MP54-SFB",
        "YEA-MP54-TEAMS",
        "YEA-MP56-SFB",
        "YEA-MP56-TEAMS"
      ],
      "Accessories": [
        "YEA-EXP50",
        "YEA-WH62-DUAL-TEAMS",
        "YEA-WH62-DUAL-UC",
        "YEA-WH62-MONO-TEAMS",
        "YEA-WH62-MONO-UC",
        "YEA-WH63-TEAMS",
        "YEA-WH63-UC",
        "YEA-WH66-DUAL-TEAMS",
        "YEA-WH66-DUAL-UC",
        "YEA-WH67-TEAMS",
        "YEA-WH67-UC",
        "YEA-UH36-DUAL-TEAMS",
        "YEA-UH36-DUAL-UC",
        "YEA-UH36-MONO-TEAMS",
        "YEA-UH36-MONO-UC",
        "YEA-HNDST-T5X",
        "YEA-BTH58",
        "YEA-WMB-T5S",
        "YEA-PS5V2000US",
        "YEA-HNDST-MP56",
        "YEA-WARR-C"
      ],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": true,
      "Height": 12,
      "Length": 14,
      "Width": 6,
      "Weight": 3.9,
      "DimensionalAirWeigth": 7.25,
      "DimensionalGroundWeight": 6.07,
      "Features": [
        {
          "Name": "Call Waiting",
          "Value": "Yes"
        },
        {
          "Name": "Caller ID (CID)",
          "Value": "Yes"
        },
        {
          "Name": "Corded or Cordless",
          "Value": "Corded"
        },
        {
          "Name": "Ethernet Ports",
          "Value": "2"
        },
        {
          "Name": "Headset Port",
          "Value": "Yes"
        },
        {
          "Name": "LCD Backlit Display",
          "Value": "Yes"
        },
        {
          "Name": "Microsoft Lync/Skype for Business",
          "Value": "Yes"
        },
        {
          "Name": "Power Source",
          "Value": "PoE"
        },
        {
          "Name": "Speakerphone",
          "Value": "Yes"
        },
        {
          "Name": "Teams Platform",
          "Value": "Yes"
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": "Retail Box"
        },
        {
          "Name": "Warranty",
          "Value": "1 Year"
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-MP58-TEAMS",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-MP58-TEAMS",
      "Manufacturer": "Yealink",
      "ProductName": "1301199 Premium Phone for Teams",
      "UnitPrice": 217,
      "MSRP": 429,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 47,
      "UPC": "841885103543"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 0,
      "PriceChangeDate": "2021-02-24T22:15:03.17",
      "ShipmentRecievedDate": "2021-04-09T00:00:00",
      "StandardPrice": 5.5,
      "EnergyStartCompliant": false,
      "ProductDescription": "Wall Mount Bracket for EXP43",
      "SKU": "330100000018 Wall Mount Bracket EXP43",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-WMB-EXP43",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/60edf593-2ba9-42e6-8ed5-ca5a0d4617f3.jpg"
        }
      ],
      "Documents": [],
      "Relatedproducts": [
        "YEA-EXP43"
      ],
      "Accessories": [],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 4,
      "Length": 2,
      "Width": 1.5,
      "Weight": 0.3,
      "DimensionalAirWeigth": 0.09,
      "DimensionalGroundWeight": 0.07,
      "Features": [
        {
          "Name": "Accessories",
          "Value": "Yes"
        },
        {
          "Name": "Bundles",
          "Value": null
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": "Retail Box"
        },
        {
          "Name": "Warranty",
          "Value": "1 Year"
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-WMB-EXP43",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-WMB-EXP43",
      "Manufacturer": "Yealink",
      "ProductName": "330100000018 Wall Mount Bracket EXP43",
      "UnitPrice": 5.5,
      "MSRP": 0,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 518,
      "UPC": "YEA-WMB-EXP43"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 309,
      "PriceChangeDate": "2023-09-25T13:35:04.47",
      "ShipmentRecievedDate": "2021-07-07T00:00:00",
      "StandardPrice": 232,
      "EnergyStartCompliant": false,
      "ProductDescription": "- Android 12.0<br/>- 7 inch (1024 x 600) Capacitive Adjustable TouchScreen<br/>- Optimal HD audio, Yealink Noise Proof Technology<br/>- Dedicated Microsoft Teams Button<br/>- Supports Upgradability of Firmware to Teams or SFBEdition<br/>- Built-in Bluetooth 4.2 and Dual Band 2.4G/5G Wi-Fi<br/>- Includes Yealink Bluetooth Wireless Handset BTH58<br/>- Supports up to 3 Expansion Module EXP50<br/>- 2 x USB Type A ports<br/>- Dual-port Gigabit Ethernet, supports PoE<br/>- Supports Microsoft/Yealink/Unify Square DeviceManagement Platform<br/>- Hybrid mode (Teams version only)<br/>- Compatible with wall mount bracket YEA-WMB-T5S",
      "SKU": "1301189 IP Phone MS Teams BT Handset",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-MP58-WH-TEAMS",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/31d7ecd1-5610-4ec4-bf79-857a0383dcb5.jpg"
        },
        {
          "Description": "YEA-MP58-WH-TEAMS",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/1f89a2fa-815f-4c82-ae8b-152c9ac25979.jpg"
        }
      ],
      "Documents": [
        {
          "Description": "Datasheet",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/80975154-129d-4d3a-838d-b935a0e66452.pdf"
        },
        {
          "Description": "User Guide",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/eaccd60e-7097-4df2-a49c-006a5c6e2a16.pdf"
        }
      ],
      "Relatedproducts": [
        "YEA-MP58-SFB",
        "YEA-MP58-TEAMS",
        "YEA-MP58-WH-SFB"
      ],
      "Accessories": [
        "YEA-EXP50",
        "YEA-WH62-DUAL-TEAMS",
        "YEA-WH62-DUAL-UC",
        "YEA-WH62-MONO-TEAMS",
        "YEA-WH62-MONO-UC",
        "YEA-WH63-TEAMS",
        "YEA-WH63-UC",
        "YEA-WH66-DUAL-TEAMS",
        "YEA-WH66-DUAL-UC",
        "YEA-WH67-TEAMS",
        "YEA-WH67-UC",
        "YEA-UH36-DUAL-TEAMS",
        "YEA-UH36-DUAL-UC",
        "YEA-UH36-MONO-TEAMS",
        "YEA-UH36-MONO-UC",
        "YEA-MP58-WH-TEAMS",
        "YEA-WARR-C_OLD",
        "YEA-WMB-T5S"
      ],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": true,
      "Height": 5.3,
      "Length": 13,
      "Width": 11.65,
      "Weight": 3.8,
      "DimensionalAirWeigth": 5.77,
      "DimensionalGroundWeight": 4.84,
      "Features": [
        {
          "Name": "Bluetooth",
          "Value": "Yes"
        },
        {
          "Name": "Call Waiting",
          "Value": "Yes"
        },
        {
          "Name": "Conference Calling",
          "Value": "Yes"
        },
        {
          "Name": "Corded or Cordless",
          "Value": "Cordless"
        },
        {
          "Name": "Ethernet Ports",
          "Value": "2"
        },
        {
          "Name": "Headset Port",
          "Value": "Yes"
        },
        {
          "Name": "LCD Backlit Display",
          "Value": "Yes"
        },
        {
          "Name": "Microsoft Lync/Skype for Business",
          "Value": "Yes"
        },
        {
          "Name": "Power Source",
          "Value": "PoE"
        },
        {
          "Name": "Teams Platform",
          "Value": "Yes"
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": "Retail Box"
        },
        {
          "Name": "Warranty",
          "Value": "1 Year"
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-MP58-WH-TEAMS",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-MP58-WH-TEAMS",
      "Manufacturer": "Yealink",
      "ProductName": "1301189 IP Phone MS Teams BT Handset",
      "UnitPrice": 232,
      "MSRP": 479,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 523,
      "UPC": "841885104458"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 30,
      "PriceChangeDate": "2021-04-14T15:55:02.937",
      "ShipmentRecievedDate": "2021-05-04T00:00:00",
      "StandardPrice": 21,
      "EnergyStartCompliant": false,
      "ProductDescription": "Support Yealink wireless headset (WH62/WH63) only  (It plugs into the back of the WH62 or WH63 and then the other end connects to the T3 series Yealink phone. ",
      "SKU": "Adapter for connecting T3 and WH62/63",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-EHS35",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/637f2682-6249-438b-ae48-af2aead53153.jpg"
        }
      ],
      "Documents": [],
      "Relatedproducts": [
        "YEA-T31G-YHS36-DUAL",
        "YEA-T31P-YHS36-DUAL",
        "YEA-T33G-YHS36-DUAL"
      ],
      "Accessories": [],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 4,
      "Length": 6,
      "Width": 1,
      "Weight": 0.25,
      "DimensionalAirWeigth": 0.17,
      "DimensionalGroundWeight": 0.14,
      "Features": [
        {
          "Name": "Accessories",
          "Value": "Yes"
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": null
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": "China"
        },
        {
          "Name": "Warranty",
          "Value": null
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-EHS35",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-EHS35",
      "Manufacturer": "Yealink",
      "ProductName": "Adapter for connecting T3 and WH62/63",
      "UnitPrice": 21,
      "MSRP": 30,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 455,
      "UPC": "841885105097"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 20,
      "PriceChangeDate": "2021-05-13T14:35:03.633",
      "ShipmentRecievedDate": "2021-05-25T00:00:00",
      "StandardPrice": 15,
      "EnergyStartCompliant": false,
      "ProductDescription": "Yealink Wall Mount for A30, A20 & UVC40",
      "SKU": "320100000011 RTH-M400 WMB A30 A20 UVC40",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-WMB-A30-A20-UVC40",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/1b5e36f2-cfec-4b36-9711-2ccd069cf321.jpg"
        }
      ],
      "Documents": [],
      "Relatedproducts": [
        "YEA-A20-010",
        "YEA-A20-020-TEAMS",
        "YEA-A20-020-ZOOM",
        "YEA-A20-021-TEAMS",
        "YEA-A30-010",
        "YEA-A30-020-TEAMS",
        "YEA-A30-020-ZOOM",
        "YEA-A30-021-TEAMS",
        "YEA-UVC40",
        "YEA-UVC40-BYOD"
      ],
      "Accessories": [],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 7,
      "Length": 8,
      "Width": 1,
      "Weight": 1.1,
      "DimensionalAirWeigth": 0.4,
      "DimensionalGroundWeight": 0.34,
      "Features": [
        {
          "Name": "Accessories",
          "Value": "Yes"
        },
        {
          "Name": "Stands, Mounting Equipment, and Cases",
          "Value": "Yes"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": null
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": null
        },
        {
          "Name": "Warranty",
          "Value": null
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-WMB-A30-A20-UVC40",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-WMB-A30-A20-UVC40",
      "Manufacturer": "Yealink",
      "ProductName": "320100000011 RTH-M400 WMB A30 A20 UVC40",
      "UnitPrice": 15,
      "MSRP": 20,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 3,
      "UPC": "841885109699"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 149,
      "PriceChangeDate": "2024-01-31T17:15:04.46",
      "ShipmentRecievedDate": "2021-06-15T00:00:00",
      "StandardPrice": 117,
      "EnergyStartCompliant": false,
      "ProductDescription": "- High-performance SIP cordless phone system<br/>- 1.8\" 128 x 160 TFT color screen with intuitive user interface<br/>- Up to 20 simultaneous calls<br/>- Up to 10 DECT cordless handsets<br/>- Up to 10 SIP accounts<br/>- Support Opus audio codec<br/>- Noise Reduction System<br/>- FNR (Flexible Noise Reduction)<br/>- Up to 35-hour talk time (in ideal conditions)<br/>- Up to 400-hour standby time (in ideal conditions)<br/>- Quick charging: 10-min charge time for 2-hour talk time<br/>- TLS and SRTP security encryption<br/>- Headset connection via 3.5 mm jack<br/>- Charger wall mountable",
      "SKU": "IP DECT Phone bundle W73H with W70 base",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-W73P",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/a3026b60-f86a-4e2b-9ccc-770f21b54c0d.jpg"
        }
      ],
      "Documents": [
        {
          "Description": "Datasheet",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/e5d95bce-817a-418d-8979-764c01648fec.pdf"
        }
      ],
      "Relatedproducts": [],
      "Accessories": [
        "YEA-W73H",
        "YEA-RT30",
        "YEA-W53-BATT",
        "YEA-W73-W78-BATT",
        "YEA-WARR-B"
      ],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": true,
      "Height": 0.99,
      "Length": 5.12,
      "Width": 3.94,
      "Weight": 1.66,
      "DimensionalAirWeigth": 0.14,
      "DimensionalGroundWeight": 0.12,
      "Features": [
        {
          "Name": "Bluetooth",
          "Value": null
        },
        {
          "Name": "Call Waiting",
          "Value": "Yes"
        },
        {
          "Name": "Caller ID (CID)",
          "Value": "Yes"
        },
        {
          "Name": "Conference Calling",
          "Value": "Yes"
        },
        {
          "Name": "Corded or Cordless",
          "Value": "Cordless"
        },
        {
          "Name": "Ethernet Ports",
          "Value": "1"
        },
        {
          "Name": "Headset Port",
          "Value": "Yes"
        },
        {
          "Name": "Max Number of Expandable Handsets",
          "Value": "10"
        },
        {
          "Name": "Number SIP Accounts/Identities",
          "Value": "10+"
        },
        {
          "Name": "Power Source",
          "Value": "AC Adapter"
        },
        {
          "Name": "Power Supply Included",
          "Value": "Yes"
        },
        {
          "Name": "SIP or Proprietary IP",
          "Value": "SIP Phones"
        },
        {
          "Name": "Speakerphone",
          "Value": "Yes"
        },
        {
          "Name": "Voicemail",
          "Value": "Yes"
        },
        {
          "Name": "Wall Mountable",
          "Value": "Yes"
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": "Retail Box"
        },
        {
          "Name": "Warranty",
          "Value": "1 Year"
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-W73P",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-W73P",
      "Manufacturer": "Yealink",
      "ProductName": "IP DECT Phone bundle W73H with W70 base",
      "UnitPrice": 117,
      "MSRP": 169,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 1000,
      "UPC": "841885107015"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 81,
      "PriceChangeDate": "2024-01-31T17:15:04.46",
      "ShipmentRecievedDate": "2021-11-26T00:00:00",
      "StandardPrice": 67,
      "EnergyStartCompliant": false,
      "ProductDescription": "- Up to 20 simultaneous calls<br/>- Up to 10 DECT cordless handsets<br/>- Up to 10 SIP accounts<br/>- Support Opus audio codec<br/>- Noise Reduction System<br/>- TLS and SRTP security encryption<br/>- No Perception Upgrade",
      "SKU": "1302017 Yealink DECT IP Base Station",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-W70B",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/18403091-8501-4575-875a-0b9e28e4ec24.jpg"
        }
      ],
      "Documents": [
        {
          "Description": "Datasheet",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/d7eef8ec-467a-4fbc-a1ad-5a3ee3ef833c.pdf"
        }
      ],
      "Relatedproducts": [],
      "Accessories": [
        "YEA-WARR-A_OLD",
        "YEA-W57R",
        "YEA-RT30",
        "YEA-W78H",
        "YEA-WARR-A"
      ],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": true,
      "Height": 2,
      "Length": 7.5,
      "Width": 7.5,
      "Weight": 1.1,
      "DimensionalAirWeigth": 0.81,
      "DimensionalGroundWeight": 0.68,
      "Features": [
        {
          "Name": "Maximum Concurrent Calls",
          "Value": "20"
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": "Retail Box"
        },
        {
          "Name": "Warranty",
          "Value": "1 Year"
        },
        {
          "Name": "Website Link",
          "Value": "http://www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "IP Phone Systems"
            }
          ]
        }
      ],
      "PartNumber": "YEA-W70B",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-W70B",
      "Manufacturer": "Yealink",
      "ProductName": "1302017 Yealink DECT IP Base Station",
      "UnitPrice": 67,
      "MSRP": 90,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 377,
      "UPC": "841885106049"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 79,
      "PriceChangeDate": "2024-01-31T17:15:04.46",
      "ShipmentRecievedDate": "2022-04-24T00:00:00",
      "StandardPrice": 67,
      "EnergyStartCompliant": false,
      "ProductDescription": "-1.8\" color screen with intuitive UI<br>- Notification Light: voice mail, missed call Hard keypad with backlight<br>- HD voice with Opus audio codec<br>- Full-duplex speakerphone<br>- FNR (Flexible Noise Reduction)/Noise Cancellation<br>- Hearing Aid Compatibility (HAC) compliant<br>- Up to 2 simultaneous calls per handset<br>- 3-way conference<br>- Headset jack (3.5 mm)<br>- Up to 35 hours of talk time (in ideal conditions)<br>- Up to 400 hours of standby time<br/>- optional battery BATT-YLW53H available",
      "SKU": "Yealink IP DECT Add-on Phone W73H",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "W73H",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/f36b3fb6-680f-4a45-be53-fa41f8c1b3ee.jpg"
        }
      ],
      "Documents": [
        {
          "Description": "Datasheet",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/5743347f-232c-46a7-8f57-4d56e710aa75.pdf"
        }
      ],
      "Relatedproducts": [],
      "Accessories": [
        "YEA-W73P",
        "YEA-BCL-W73H",
        "YEA-W53-BATT",
        "BATT-YLW53H",
        "YEA-W73-W78-BATT",
        "YEA-CCD-W73H",
        "YEA-WARR-A"
      ],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": true,
      "Height": 0.8,
      "Length": 5.7,
      "Width": 1.9,
      "Weight": 0.9,
      "DimensionalAirWeigth": 0.06,
      "DimensionalGroundWeight": 0.05,
      "Features": [
        {
          "Name": "Accessories",
          "Value": "Yes"
        },
        {
          "Name": "Accessory Handsets",
          "Value": "Yes"
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": "Retail Box"
        },
        {
          "Name": "Warranty",
          "Value": "1 Year"
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-W73H",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-W73H",
      "Manufacturer": "Yealink",
      "ProductName": "Yealink IP DECT Add-on Phone W73H",
      "UnitPrice": 67,
      "MSRP": 89,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 1000,
      "UPC": "841885106377"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 170,
      "PriceChangeDate": "2024-01-31T17:15:04.46",
      "ShipmentRecievedDate": "2022-03-08T00:00:00",
      "StandardPrice": 132,
      "EnergyStartCompliant": false,
      "ProductDescription": "- High-performance SIP cordless phone system<br/>- 2.4\" 240 x 320 color screen with intuitive user interface<br/>- Up to 20 simultaneous calls<br/>- Up to 10 DECT cordless handsets<br/>- Up to 10 VoIP accounts<br/>- Support Opus audio codec<br/>- Up to 30-hour talk time (in ideal conditions)<br/>- Up to 400-hour standby time (in ideal conditions)<br/>- Quick charging: 10-min charge time for 2-hour talk time<br/>- TLS and SRTP security encryption<br/>- Noise Reduction System<br/>- Headset connection via 3.5 mm jack<br/>- Charger wall mountable",
      "SKU": "IP DECT Phone bundle W56H with W70 base",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-W76P",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/c65d191c-ccd2-4eea-ab2d-62ba09e494c7.jpg"
        }
      ],
      "Documents": [
        {
          "Description": "Datasheet",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/ddfd0713-f3e2-4cfe-b5ba-4f105f5f6f64.pdf"
        }
      ],
      "Relatedproducts": [
        "YEA-W70B",
        "YEA-W73H",
        "YEA-W73P",
        "YEA-W79P"
      ],
      "Accessories": [
        "YEA-RT30",
        "YEA-WARR-B"
      ],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": true,
      "Height": 4,
      "Length": 9,
      "Width": 8,
      "Weight": 1.6,
      "DimensionalAirWeigth": 2.07,
      "DimensionalGroundWeight": 1.73,
      "Features": [
        {
          "Name": "Call Waiting",
          "Value": "Yes"
        },
        {
          "Name": "Caller ID (CID)",
          "Value": "Yes"
        },
        {
          "Name": "Conference Calling",
          "Value": "Yes"
        },
        {
          "Name": "Corded or Cordless",
          "Value": "Cordless"
        },
        {
          "Name": "Ethernet Ports",
          "Value": "1"
        },
        {
          "Name": "Headset Port",
          "Value": "Yes"
        },
        {
          "Name": "Power Source",
          "Value": "AC Adapter"
        },
        {
          "Name": "Power Supply Included",
          "Value": "Yes"
        },
        {
          "Name": "Speakerphone",
          "Value": "Yes"
        },
        {
          "Name": "Voicemail",
          "Value": "Yes"
        },
        {
          "Name": "Color",
          "Value": "Gray"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": "Retail Box"
        },
        {
          "Name": "Warranty",
          "Value": "1 Year"
        },
        {
          "Name": "Website Link",
          "Value": "http://www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-W76P",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-W76P",
      "Manufacturer": "Yealink",
      "ProductName": "IP DECT Phone bundle W56H with W70 base",
      "UnitPrice": 132,
      "MSRP": 189,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 1000,
      "UPC": "841885107480"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 309,
      "PriceChangeDate": "2024-01-31T17:15:04.46",
      "ShipmentRecievedDate": "2022-03-30T00:00:00",
      "StandardPrice": 210,
      "EnergyStartCompliant": false,
      "ProductDescription": "- High-performance SIP cordless phone system<br/>- 1.8\" 128 x 160 TFT color screen with intuitive user interface<br/>- Up to 20 simultaneous calls<br/>- Up to 10 DECT cordless handsets<br/>- Up to 10 SIP accounts<br/>- IP67 Ruggedized DECT Handset<br/>- Support Opus audio codec<br/>- Noise Reduction System<br/>- FNR (Flexible Noise Reduction)/Noise Cancellation<br/>- Up to 28-hour talk time (in ideal conditions)<br/>- Up to 360-hour standby time (in ideal conditions)<br/>- Quick charging: 10-min charge time for 2-hour talk time<br/>- TLS and SRTP security encryption<br/>- Headset connection via bluetooth<br/>- Alarm function<br/>- Vibration<br/>- Charger wall mountable",
      "SKU": "IP DECT Phone bundle W59R with W70 base",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-W79P",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/b8692de4-06c2-4921-ad31-a88be481b876.jpg"
        },
        {
          "Description": "YEA-W79P",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/22e51971-a673-4a8d-ab1c-9c230138e8c7.jpg"
        }
      ],
      "Documents": [
        {
          "Description": "Datasheet",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/a929a543-92da-4ab8-aec3-5cedb5846f01.pdf"
        }
      ],
      "Relatedproducts": [],
      "Accessories": [
        "YEA-W56-BATT",
        "BATT-YLW53H",
        "YEA-RT30",
        "YEA-WARR-B"
      ],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": true,
      "Height": 4,
      "Length": 8,
      "Width": 4,
      "Weight": 1.96,
      "DimensionalAirWeigth": 0.92,
      "DimensionalGroundWeight": 0.77,
      "Features": [
        {
          "Name": "Bluetooth",
          "Value": "Yes"
        },
        {
          "Name": "Call Waiting",
          "Value": "Yes"
        },
        {
          "Name": "Caller ID (CID)",
          "Value": "Yes"
        },
        {
          "Name": "Conference Calling",
          "Value": "Yes"
        },
        {
          "Name": "Corded or Cordless",
          "Value": "Cordless"
        },
        {
          "Name": "Ethernet Ports",
          "Value": "1"
        },
        {
          "Name": "LCD Backlit Display",
          "Value": "Yes"
        },
        {
          "Name": "Number SIP Accounts/Identities",
          "Value": "10+"
        },
        {
          "Name": "Power Source",
          "Value": "AC Adapter"
        },
        {
          "Name": "Power Supply Included",
          "Value": "Yes"
        },
        {
          "Name": "Speakerphone",
          "Value": "Yes"
        },
        {
          "Name": "Voicemail",
          "Value": "Yes"
        },
        {
          "Name": "Wall Mountable",
          "Value": "Yes"
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": "Retail Box"
        },
        {
          "Name": "Warranty",
          "Value": "1 Year"
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-W79P",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-W79P",
      "Manufacturer": "Yealink",
      "ProductName": "IP DECT Phone bundle W59R with W70 base",
      "UnitPrice": 210,
      "MSRP": 309,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 0,
      "UPC": "841885107305"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 329,
      "PriceChangeDate": "2024-01-31T17:15:04.46",
      "ShipmentRecievedDate": "2021-09-15T00:00:00",
      "StandardPrice": 169,
      "EnergyStartCompliant": false,
      "ProductDescription": "- 7\" 800 x 480-pixel color touch screen with backlight<br/>- Opus codec support<br/>- Dual USB ports<br/>- Dual firmware images<br/>- T4U Auto-P template unified<br/>- T4U firmware unified<br/>- Up to 16 SIP accounts<br/>- Dual-port Gigabit Ethernet<br/>- PoE support<br/>- Paperless label design<br/>- Headset, EHS support<br/>- Wi-Fi via WF40/WF50<br/>- Bluetooth via BT40/BT41<br/>- USB recording<br/>- Supports color-screen expansion modules<br/>- Stand with two adjustable angles<br/>- Wall mountable",
      "SKU": "Yealink Ultra-Elegant Touchscreen",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-SIP-T48U",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/dacb325d-6e12-4c02-99af-9b0bbb3190be.jpg"
        },
        {
          "Description": "YEA-SIP-T48U",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/a7df0ccb-fcb6-4910-8a94-5616c4289c9a.jpg"
        },
        {
          "Description": "YEA-SIP-T48U",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/0cf7fe2a-a889-4f12-9a8b-9dbe37b026af.jpg"
        }
      ],
      "Documents": [
        {
          "Description": "Datasheet",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/ae163e54-0c50-46dd-b172-c513b80bf7f0.pdf"
        }
      ],
      "Relatedproducts": [],
      "Accessories": [
        "YEA-HNDST-T46",
        "YEA-EHS40",
        "YEA-EXP43",
        "YEA-PS5V2000US",
        "YEA-WMB-T48",
        "YEA-HNDST-T46",
        "YEA-WARR-B"
      ],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": true,
      "Height": 5,
      "Length": 10,
      "Width": 13,
      "Weight": 3.75,
      "DimensionalAirWeigth": 4.68,
      "DimensionalGroundWeight": 3.92,
      "Features": [
        {
          "Name": "Bluetooth",
          "Value": "Yes"
        },
        {
          "Name": "Call Waiting",
          "Value": "Yes"
        },
        {
          "Name": "Caller ID (CID)",
          "Value": "Yes"
        },
        {
          "Name": "Conference Calling",
          "Value": "Yes"
        },
        {
          "Name": "Corded or Cordless",
          "Value": "Corded"
        },
        {
          "Name": "EHS",
          "Value": "Yes"
        },
        {
          "Name": "Ethernet Ports",
          "Value": "2"
        },
        {
          "Name": "Headset Port",
          "Value": "Yes"
        },
        {
          "Name": "LCD Backlit Display",
          "Value": "Yes"
        },
        {
          "Name": "Number SIP Accounts/Identities",
          "Value": "10+"
        },
        {
          "Name": "Power Source",
          "Value": "PoE"
        },
        {
          "Name": "Speakerphone",
          "Value": "Yes"
        },
        {
          "Name": "Voicemail",
          "Value": "Yes"
        },
        {
          "Name": "Wall Mountable",
          "Value": "Yes"
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": "Retail Box"
        },
        {
          "Name": "Warranty",
          "Value": "1 Year"
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-SIP-T48U",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-SIP-T48U",
      "Manufacturer": "Yealink",
      "ProductName": "Yealink Ultra-Elegant Touchscreen",
      "UnitPrice": 169,
      "MSRP": 349,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 447,
      "UPC": "841885102997"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 589,
      "PriceChangeDate": "2024-01-31T17:15:04.46",
      "ShipmentRecievedDate": "2021-08-31T00:00:00",
      "StandardPrice": 309,
      "EnergyStartCompliant": false,
      "ProductDescription": "- General Features<br/>- Android 9.0 OS<br/>- 7'' capacitive adjustable touch screen<br/>- Up to 16 SIP accounts<br/>- Supports Bluetooth handset BTH58<br/>- Optimal HD audio, Yealink Noise Proof Technology<br/>- Full-duplex hands-free speakerphone with AEC<br/>- 5 mega-pixel HD camera with privacy shutter<br/>- Supports 720p30 HD video conferencing<br/>- Built-in Bluetooth/Wi-Fi<br/>- Dual USB 2.0 ports for USB headset, media and storage applications<br/>- Dual-port Gigabit Ethernet, PoE support<br/>- Supports up to 3 Expansion Module EXP50<br/>- Supports Yealink/Unify Square Device Management Platform<br/> *T58W Pro with Camera is equipped with the Bluetooth handset BTH58 by default.",
      "SKU": "T58W PRO phone with camera",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-SIP-T58W-PRO-CAM",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/f933190d-30cb-412c-9f54-36aae3d5a69b.jpg"
        }
      ],
      "Documents": [
        {
          "Description": "Datasheet",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/77c26f11-586f-4b3a-9945-dd88912b4ce1.pdf"
        }
      ],
      "Relatedproducts": [],
      "Accessories": [
        "YEA-PS5V2000US",
        "YEA-WMB-T5S",
        "YEA-BTH58",
        "YEA-CAM50",
        "YEA-HNDST-MP56",
        "YEA-WARR-C"
      ],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": true,
      "Height": 12,
      "Length": 13,
      "Width": 6,
      "Weight": 4,
      "DimensionalAirWeigth": 6.73,
      "DimensionalGroundWeight": 5.64,
      "Features": [
        {
          "Name": "Bluetooth",
          "Value": "Yes"
        },
        {
          "Name": "Call Waiting",
          "Value": "Yes"
        },
        {
          "Name": "Conference Calling",
          "Value": "Yes"
        },
        {
          "Name": "Corded or Cordless",
          "Value": "Both"
        },
        {
          "Name": "Headset Port",
          "Value": "Yes"
        },
        {
          "Name": "Number SIP Accounts/Identities",
          "Value": "10+"
        },
        {
          "Name": "Power Source",
          "Value": "PoE and AC Adapter"
        },
        {
          "Name": "Wall Mountable",
          "Value": "Yes"
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": "Retail Box"
        },
        {
          "Name": "Warranty",
          "Value": "2 Year"
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-SIP-T58W-PRO-CAM",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-SIP-T58W-PRO-CAM",
      "Manufacturer": "Yealink",
      "ProductName": "T58W PRO phone with camera",
      "UnitPrice": 309,
      "MSRP": 619,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 165,
      "UPC": "841885106513"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 799,
      "PriceChangeDate": "2022-05-26T08:15:03.03",
      "ShipmentRecievedDate": "2021-11-05T00:00:00",
      "StandardPrice": 448,
      "EnergyStartCompliant": false,
      "ProductDescription": "- Red Dot[2021]<br/>- Android 9.0<br/>- 5-inch multi-touch screen with 720x1280 resolution<br/>- Optimal HD audio, full duplex technology<br/>- Yealink Noise Proof Technology<br/>- 20-foot (6-meter) and 360-degree voice pickup<br/>- Built-in 12-microphone array for voice pickup<br/>- Built-in 1-microphone array for noise cancellation<br/>- Power over Ethernet<br/>- 10-way conference call<br/>- Hybrid UC meeting<br/>- Built-in Wi-Fi (2.4GHz/5GHz, 802.11a/b/g/n)",
      "SKU": "CP965 Conference Phone",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-CP965",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/03b886c1-a33e-4048-be85-052fafd123e5.jpg"
        }
      ],
      "Documents": [
        {
          "Description": "Datasheet",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/454eb291-f54c-427f-bdc2-6820e00b6c84.pdf"
        }
      ],
      "Relatedproducts": [],
      "Accessories": [
        "YEA-YLPOE30",
        "YEA-WARR-E_OLD",
        "YEA-USB2-2-5M",
        "YEA-USB2-7M",
        "YEA-USB2-EXT-10M",
        "YEA-USB2-EXT-20M",
        "YEA-USB2-EXT-5M",
        "YEA-USB2CAT5E-EXT",
        "YEA-USBC-HDMI",
        "YEA-CPW65-DECT-DUO"
      ],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": true,
      "Height": 16,
      "Length": 15,
      "Width": 6,
      "Weight": 4.2,
      "DimensionalAirWeigth": 10.36,
      "DimensionalGroundWeight": 8.67,
      "Features": [
        {
          "Name": "3-Way Calling",
          "Value": "Yes"
        },
        {
          "Name": "Bluetooth",
          "Value": "Yes"
        },
        {
          "Name": "Call Hold",
          "Value": "Yes"
        },
        {
          "Name": "Call Recording",
          "Value": "Yes"
        },
        {
          "Name": "Echo Cancellation",
          "Value": "Yes"
        },
        {
          "Name": "Full Duplex Speakerphone",
          "Value": "Yes"
        },
        {
          "Name": "LCD Display",
          "Value": "Yes"
        },
        {
          "Name": "Mute",
          "Value": "Yes"
        },
        {
          "Name": "No. Accessory/Replacement Microphones",
          "Value": null
        },
        {
          "Name": "Touchscreen",
          "Value": "Yes"
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": "Retail Box"
        },
        {
          "Name": "Warranty",
          "Value": "1 Year"
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "Business Equipment",
          "SubCategories": [
            {
              "Name": "Conferencing Equipment"
            }
          ]
        }
      ],
      "PartNumber": "YEA-CP965",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-CP965",
      "Manufacturer": "Yealink",
      "ProductName": "CP965 Conference Phone",
      "UnitPrice": 448,
      "MSRP": 899,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 379,
      "UPC": "841885107312"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 549,
      "PriceChangeDate": "2022-05-25T17:15:05.233",
      "ShipmentRecievedDate": "2021-09-24T00:00:00",
      "StandardPrice": 314,
      "EnergyStartCompliant": false,
      "ProductDescription": "- 4-inch multi-touch screen with 480x800 resolution<br/>- Optimal HD audio, full duplex technology<br/>- Yealink Noise Proof Technology<br/>- 20-foot (6-meter) and 360-degree voice pickup<br/>- Built-in 6-microphone array for voice pickup<br/>- Built-in 1-microphone array for noise cancellation<br/>- Power over Ethernet<br/>- 5-way conference call<br/>- Hybrid UC meeting<br/>- Built-in Wi-Fi (2.4GHz/5GHz, 802.11a/b/g/n)<br/>- Built-in Bluetooth 4.2<br/>- Local 3-way PSTN conference via Yealink CPN10<br/>- Includes 12v 1.25amp power supply",
      "SKU": "1304015 CP925 Conference Phone",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-CP925",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/3234c696-3a56-447b-a5fa-bfbc914a8cd0.jpg"
        }
      ],
      "Documents": [
        {
          "Description": "Datasheet",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/0d832bf1-a353-4089-9b45-79627a9e362c.pdf"
        }
      ],
      "Relatedproducts": [
        "YEA-CP920",
        "YEA-CP930W",
        "YEA-CP930W-BASE",
        "YEA-CP935W",
        "YEA-CP935W-BASE",
        "YEA-CP960",
        "YEA-CP960-WM",
        "YEA-CPE80",
        "YEA-CPE90",
        "YEA-CPN10",
        "YEA-CPW90",
        "YEA-CPW90-PACKAGE"
      ],
      "Accessories": [
        "YEA-YLPOE30",
        "YEA-YLPOE30",
        "YEA-USB2-2-5M",
        "YEA-USB2-7M",
        "YEA-USB2-EXT-10M",
        "YEA-USB2-EXT-20M",
        "YEA-USB2-EXT-5M",
        "YEA-USB2CAT5E-EXT",
        "YEA-USBC-HDMI"
      ],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": true,
      "Height": 5,
      "Length": 13,
      "Width": 14,
      "Weight": 3.75,
      "DimensionalAirWeigth": 6.55,
      "DimensionalGroundWeight": 5.48,
      "Features": [
        {
          "Name": "3-Way Calling",
          "Value": "Yes"
        },
        {
          "Name": "Bluetooth",
          "Value": "Yes"
        },
        {
          "Name": "Call Hold",
          "Value": "Yes"
        },
        {
          "Name": "Call Recording",
          "Value": "Yes"
        },
        {
          "Name": "Echo Cancellation",
          "Value": "Yes"
        },
        {
          "Name": "Full Duplex Speakerphone",
          "Value": "Yes"
        },
        {
          "Name": "LCD Display",
          "Value": "Yes"
        },
        {
          "Name": "Mute",
          "Value": "Yes"
        },
        {
          "Name": "No. Accessory/Replacement Microphones",
          "Value": null
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": null
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": "Retail Box"
        },
        {
          "Name": "Warranty",
          "Value": "1 Year"
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "Business Equipment",
          "SubCategories": [
            {
              "Name": "Conferencing Equipment"
            }
          ]
        }
      ],
      "PartNumber": "YEA-CP925",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-CP925",
      "Manufacturer": "Yealink",
      "ProductName": "1304015 CP925 Conference Phone",
      "UnitPrice": 314,
      "MSRP": 599,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 0,
      "UPC": "841885106759"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 439,
      "PriceChangeDate": "2024-01-31T17:15:04.46",
      "ShipmentRecievedDate": "2021-08-31T00:00:00",
      "StandardPrice": 243,
      "EnergyStartCompliant": false,
      "ProductDescription": "- Runs Android 9.0<br/>- 7 inch (1024 x 600) capacitive adjustable touch screen<br/>- Supports Yealink Bluetooth Handset BTH58 (Optional)<br/>- 720p30 HD video (with CAM50)<br/>- Optimal HD audio, Yealink Noise Proof Technology<br/>- Yealink’s SDK (Software Development Kit)<br/>- DoorPhone Features (Preview, One-button Open, Monitoring)<br/>- Built-in Bluetooth 4.2 and Dual Band 2.4G/5G Wi-Fi<br/>- 2 x USB 2.0 ports for USB headset, media and storage applications<br/>- Opus Codec support<br/>- Up to 16 SIP accounts<br/>- Up to 10-party audio conferencing<br/>- Dual-port Gigabit Ethernet, supports PoE<br/>- Wall mountable<br/>- Supports up to 3 Expansion Module EXP50<br/>- Supports Yealink/Unify Square Device Management Platform",
      "SKU": "SIP-T58W Smart Media Android HD Phone",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-SIP-T58W",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/37b2f87f-afb5-4ff1-8f96-d62a8d8ae7ff.jpg"
        },
        {
          "Description": "YEA-SIP-T58W",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/3c69522d-da06-45c7-a21a-36354339d6e0.jpg"
        },
        {
          "Description": "YEA-SIP-T58W",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/9fa7085c-d6bc-4b04-bd35-711f51d077fa.jpg"
        }
      ],
      "Documents": [
        {
          "Description": "Datasheet",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/e54fb4e9-d76e-49e9-b3c6-a95d8192acaf.pdf"
        }
      ],
      "Relatedproducts": [
        "YEA-SIP-T53",
        "YEA-SIP-T53W",
        "YEA-SIP-T54W",
        "YEA-SIP-T57W",
        "YEA-SIP-T58W-CAM",
        "YEA-SIP-T58W-PRO",
        "YEA-SIP-T58W-PRO-CAM"
      ],
      "Accessories": [
        "YEA-PS5V2000US",
        "YEA-WMB-T5S",
        "YEA-HNDST-T5X",
        "YEA-BTH58",
        "YEA-EXP50",
        "YEA-HNDST-MP56",
        "YEA-STAND-T58",
        "YEA-WARR-C"
      ],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": true,
      "Height": 12,
      "Length": 13,
      "Width": 6,
      "Weight": 3.91,
      "DimensionalAirWeigth": 6.73,
      "DimensionalGroundWeight": 5.64,
      "Features": [
        {
          "Name": "Bluetooth",
          "Value": "Yes"
        },
        {
          "Name": "Call Waiting",
          "Value": "Yes"
        },
        {
          "Name": "Caller ID (CID)",
          "Value": "Yes"
        },
        {
          "Name": "Conference Calling",
          "Value": "Yes"
        },
        {
          "Name": "Corded or Cordless",
          "Value": "Corded"
        },
        {
          "Name": "EHS",
          "Value": "Yes"
        },
        {
          "Name": "Ethernet Ports",
          "Value": "2"
        },
        {
          "Name": "Headset Port",
          "Value": "Yes"
        },
        {
          "Name": "LCD Backlit Display",
          "Value": "Yes"
        },
        {
          "Name": "Number SIP Accounts/Identities",
          "Value": "10+"
        },
        {
          "Name": "Power Source",
          "Value": "PoE"
        },
        {
          "Name": "Speakerphone",
          "Value": "Yes"
        },
        {
          "Name": "Voicemail",
          "Value": "Yes"
        },
        {
          "Name": "Wall Mountable",
          "Value": "Yes"
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": "Retail Box"
        },
        {
          "Name": "Warranty",
          "Value": "1 Year"
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-SIP-T58W",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-SIP-T58W",
      "Manufacturer": "Yealink",
      "ProductName": "SIP-T58W Smart Media Android HD Phone",
      "UnitPrice": 243,
      "MSRP": 459,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 179,
      "UPC": "6938818307667"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 489,
      "PriceChangeDate": "2024-01-31T17:15:04.46",
      "ShipmentRecievedDate": "2021-11-24T00:00:00",
      "StandardPrice": 263,
      "EnergyStartCompliant": false,
      "ProductDescription": "- Runs Android 9.0<br/>- 7 inch (1024 x 600) capacitive adjustable touch screen<br/>- Supports Yealink Bluetooth Handset BTH58<br/>- 720p30 HD video (with CAM50)<br/>- Optimal HD audio, Yealink Noise Proof Technology<br/>- Yealink’s SDK (Software Development Kit)<br/>- DoorPhone Features (Preview, One-button Open, Monitoring)<br/>- Built-in Bluetooth 4.2 and Dual Band 2.4G/5G Wi-Fi<br/>- 2 x USB 2.0 ports for USB headset, media and storage applications<br/>- Opus Codec support<br/>- Up to 16 SIP accounts<br/>- Up to 10-party audio conferencing<br/>- Dual-port Gigabit Ethernet, supports PoE<br/>- Wall mountable<br/>- Supports up to 3 Expansion Module EXP50<br/>- Supports Yealink/Unify Square Device Management Platform",
      "SKU": "T58W PRO with Bluetooth handset",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-SIP-T58W-PRO",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/ba4c8628-ad97-40b7-87e1-f7cda4f78c33.jpg"
        },
        {
          "Description": "YEA-SIP-T58W-PRO",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/3e1b74b2-351c-4a33-95d9-96df3a48500f.jpg"
        },
        {
          "Description": "YEA-SIP-T58W-PRO",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/5cc41ca2-6bfd-4a05-b651-128201b604ee.jpg"
        },
        {
          "Description": "YEA-SIP-T58W-PRO",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/fe69bcf2-d2f0-426b-b82d-2ca9f691a7d3.jpg"
        }
      ],
      "Documents": [
        {
          "Description": "Datasheet",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/950fd4b2-c518-490e-8115-d3a9b6697366.pdf"
        }
      ],
      "Relatedproducts": [
        "YEA-SIP-T53",
        "YEA-SIP-T53W",
        "YEA-SIP-T54W",
        "YEA-SIP-T57W",
        "YEA-SIP-T58W",
        "YEA-SIP-T58W-CAM",
        "YEA-SIP-T58W-PRO-CAM"
      ],
      "Accessories": [
        "YEA-PS5V2000US",
        "YEA-WMB-T5S",
        "YEA-BTH58",
        "YEA-CAM50",
        "YEA-HNDST-MP56",
        "YEA-WARR-C"
      ],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": true,
      "Height": 12,
      "Length": 13,
      "Width": 6,
      "Weight": 4.6,
      "DimensionalAirWeigth": 6.73,
      "DimensionalGroundWeight": 5.64,
      "Features": [
        {
          "Name": "Bluetooth",
          "Value": "Yes"
        },
        {
          "Name": "Call Waiting",
          "Value": "Yes"
        },
        {
          "Name": "Caller ID (CID)",
          "Value": "Yes"
        },
        {
          "Name": "Conference Calling",
          "Value": "Yes"
        },
        {
          "Name": "Corded or Cordless",
          "Value": "Cordless"
        },
        {
          "Name": "EHS",
          "Value": "Yes"
        },
        {
          "Name": "Ethernet Ports",
          "Value": "2"
        },
        {
          "Name": "Headset Port",
          "Value": "Yes"
        },
        {
          "Name": "LCD Backlit Display",
          "Value": "Yes"
        },
        {
          "Name": "Number SIP Accounts/Identities",
          "Value": "10+"
        },
        {
          "Name": "Power Source",
          "Value": "PoE"
        },
        {
          "Name": "Speakerphone",
          "Value": "Yes"
        },
        {
          "Name": "Wall Mountable",
          "Value": "Yes"
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": null
        },
        {
          "Name": "Warranty",
          "Value": "1 Year"
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-SIP-T58W-PRO",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-SIP-T58W-PRO",
      "Manufacturer": "Yealink",
      "ProductName": "T58W PRO with Bluetooth handset",
      "UnitPrice": 263,
      "MSRP": 509,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 675,
      "UPC": "841885106506"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 539,
      "PriceChangeDate": "2024-01-31T17:15:04.46",
      "ShipmentRecievedDate": "2021-11-05T00:00:00",
      "StandardPrice": 292,
      "EnergyStartCompliant": false,
      "ProductDescription": "- Runs Android 9.0<br/>- 7 inch (1024 x 600) capacitive adjustable touch screen<br/>- Supports Yealink Bluetooth Handset BTH58 (Optional)<br/>- 720p30 HD video (with CAM50)<br/>- Optimal HD audio, Yealink Noise Proof Technology<br/>- Yealink’s SDK (Software Development Kit)<br/>- DoorPhone Features (Preview, One-button Open, Monitoring)<br/>- Built-in Bluetooth 4.2 and Dual Band 2.4G/5G Wi-Fi<br/>- 2 x USB 2.0 ports for USB headset, media and storage applications<br/>- Opus Codec support<br/>- Up to 16 SIP accounts<br/>- Up to 10-party audio conferencing<br/>- Dual-port Gigabit Ethernet, supports PoE<br/>- Wall mountable<br/>- Supports up to 3 Expansion Module EXP50<br/>- Supports Yealink/Unify Square Device Management Platform",
      "SKU": "T58W with CAM Smart Media HD Phone",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-SIP-T58W-CAM",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/ca780e9d-9c20-49bc-a583-e1a8584aa39a.jpg"
        }
      ],
      "Documents": [
        {
          "Description": "Datasheet",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/4f095152-b053-4724-a451-eeea90e581a0.pdf"
        }
      ],
      "Relatedproducts": [
        "YEA-SIP-T58W-CAM",
        "YEA-SIP-T58W-PRO"
      ],
      "Accessories": [
        "YEA-PS5V2000US",
        "YEA-WMB-T5S",
        "YEA-HNDST-T5X",
        "YEA-BTH58",
        "YEA-WARR-C"
      ],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": true,
      "Height": 12,
      "Length": 13,
      "Width": 6,
      "Weight": 4,
      "DimensionalAirWeigth": 6.73,
      "DimensionalGroundWeight": 5.64,
      "Features": [
        {
          "Name": "Bluetooth",
          "Value": "Yes"
        },
        {
          "Name": "Call Waiting",
          "Value": "Yes"
        },
        {
          "Name": "Caller ID (CID)",
          "Value": "Yes"
        },
        {
          "Name": "Conference Calling",
          "Value": "Yes"
        },
        {
          "Name": "Corded or Cordless",
          "Value": "Cordless"
        },
        {
          "Name": "EHS",
          "Value": "Yes"
        },
        {
          "Name": "Ethernet Ports",
          "Value": "2"
        },
        {
          "Name": "Headset Port",
          "Value": "Yes"
        },
        {
          "Name": "LCD Backlit Display",
          "Value": "Yes"
        },
        {
          "Name": "Number SIP Accounts/Identities",
          "Value": "10+"
        },
        {
          "Name": "Power Source",
          "Value": "PoE"
        },
        {
          "Name": "Speakerphone",
          "Value": "Yes"
        },
        {
          "Name": "Voicemail",
          "Value": "Yes"
        },
        {
          "Name": "Wall Mountable",
          "Value": "Yes"
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": "Retail Box"
        },
        {
          "Name": "Warranty",
          "Value": "1 Year"
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-SIP-T58W-CAM",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-SIP-T58W-CAM",
      "Manufacturer": "Yealink",
      "ProductName": "T58W with CAM Smart Media HD Phone",
      "UnitPrice": 292,
      "MSRP": 569,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 233,
      "UPC": "841885106490"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 0,
      "PriceChangeDate": "2021-08-09T14:15:03.907",
      "ShipmentRecievedDate": "2021-10-25T00:00:00",
      "StandardPrice": 5.5,
      "EnergyStartCompliant": false,
      "ProductDescription": "Wall Mount Bracket for T31G and T31P",
      "SKU": "3301000000 Wall Mount Bracke T31G & T31P",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-WMB-T31G",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/cc67c0ee-c72c-4371-b41c-7fbb9109c491.jpg"
        }
      ],
      "Documents": [],
      "Relatedproducts": [
        "YEA-SIP-T31G",
        "YEA-SIP-T31P"
      ],
      "Accessories": [],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 2,
      "Length": 5,
      "Width": 5,
      "Weight": 0.5,
      "DimensionalAirWeigth": 0.36,
      "DimensionalGroundWeight": 0.3,
      "Features": [
        {
          "Name": "Accessories",
          "Value": "Yes"
        },
        {
          "Name": "Stands, Mounting Equipment, and Cases",
          "Value": "Yes"
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": "Retail Box"
        },
        {
          "Name": "Warranty",
          "Value": "1 Year"
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-WMB-T31G",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-WMB-T31G",
      "Manufacturer": "Yealink",
      "ProductName": "3301000000 Wall Mount Bracke T31G & T31P",
      "UnitPrice": 5.5,
      "MSRP": 8,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 276,
      "UPC": "841885106469"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 0,
      "PriceChangeDate": "2021-08-09T14:15:03.907",
      "ShipmentRecievedDate": "2021-10-25T00:00:00",
      "StandardPrice": 5.5,
      "EnergyStartCompliant": false,
      "ProductDescription": "Wall Mount Bracket for T33G, T34W & MP52-TEAMS",
      "SKU": "Wall Mount Bracket for T33G, T34W, MP52",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-WMB-T33G",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/2385f4a2-08fa-40c2-a762-b53db7181eca.jpg"
        }
      ],
      "Documents": [],
      "Relatedproducts": [
        "YEA-SIP-T33G",
        "YEA-SIP-T34W"
      ],
      "Accessories": [],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 2,
      "Length": 6,
      "Width": 5,
      "Weight": 0.5,
      "DimensionalAirWeigth": 0.43,
      "DimensionalGroundWeight": 0.36,
      "Features": [
        {
          "Name": "Stands, Mounting Equipment, and Cases",
          "Value": "Yes"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": null
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": null
        },
        {
          "Name": "Warranty",
          "Value": null
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-WMB-T33G",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-WMB-T33G",
      "Manufacturer": "Yealink",
      "ProductName": "Wall Mount Bracket for T33G, T34W, MP52",
      "UnitPrice": 5.5,
      "MSRP": 8,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 1000,
      "UPC": "841885106476"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 0,
      "PriceChangeDate": "2021-08-09T14:15:03.907",
      "ShipmentRecievedDate": "2021-11-08T00:00:00",
      "StandardPrice": 5,
      "EnergyStartCompliant": false,
      "ProductDescription": "Stand for T31G",
      "SKU": "330100000114 Stand for T31G",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-STAND-T31G",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/84bd3687-3cd2-4d6c-ada4-082f77f818a0.jpg"
        }
      ],
      "Documents": [],
      "Relatedproducts": [
        "YEA-SIP-T31G"
      ],
      "Accessories": [],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 1,
      "Length": 6,
      "Width": 3,
      "Weight": 0.1,
      "DimensionalAirWeigth": 0.13,
      "DimensionalGroundWeight": 0.11,
      "Features": [
        {
          "Name": "Accessories",
          "Value": "Yes"
        },
        {
          "Name": "Accessory Handsets",
          "Value": null
        },
        {
          "Name": "Bluetooth",
          "Value": null
        },
        {
          "Name": "Bundles",
          "Value": null
        },
        {
          "Name": "Call Waiting",
          "Value": null
        },
        {
          "Name": "Caller ID (CID)",
          "Value": null
        },
        {
          "Name": "Conference Calling",
          "Value": null
        },
        {
          "Name": "EHS",
          "Value": null
        },
        {
          "Name": "Expansion Modules",
          "Value": null
        },
        {
          "Name": "Headset Port",
          "Value": null
        },
        {
          "Name": "LCD Backlit Display",
          "Value": null
        },
        {
          "Name": "Licenses and Upgrades",
          "Value": null
        },
        {
          "Name": "Microsoft Lync/Skype for Business",
          "Value": null
        },
        {
          "Name": "Power Supplies",
          "Value": null
        },
        {
          "Name": "Power Supply Included",
          "Value": null
        },
        {
          "Name": "Replacement Handsets",
          "Value": null
        },
        {
          "Name": "Speakerphone",
          "Value": null
        },
        {
          "Name": "Stands, Mounting Equipment, and Cases",
          "Value": "Yes"
        },
        {
          "Name": "Touchscreen",
          "Value": null
        },
        {
          "Name": "Voicemail",
          "Value": null
        },
        {
          "Name": "Wall Mountable",
          "Value": null
        },
        {
          "Name": "Wifi",
          "Value": null
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": null
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": null
        },
        {
          "Name": "Warranty",
          "Value": null
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-STAND-T31G",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-STAND-T31G",
      "Manufacturer": "Yealink",
      "ProductName": "330100000114 Stand for T31G",
      "UnitPrice": 5,
      "MSRP": 0,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 85,
      "UPC": "YEA-STAND-T31G"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 300,
      "PriceChangeDate": "2021-11-12T17:15:04.82",
      "ShipmentRecievedDate": "2021-12-15T00:00:00",
      "StandardPrice": 190,
      "EnergyStartCompliant": false,
      "ProductDescription": "Includes: 2x CPW90 wireless microphones<br/>- 1x charger cradle<br/>- 1x power adapter<br/>- 1x 1.8m USB cable<br/>- 1x DD10 USB DECT dongle<br/>-  Including 1-year hardware warranty",
      "SKU": "CPW90 Package 1204620",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-CPW90-PACKAGE",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/276adc27-5b37-4f10-933d-6f611f8337eb.jpg"
        },
        {
          "Description": "YEA-CPW90-PACKAGE",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/52d4ac12-8020-4cf9-9764-e5da48b83b73.jpg"
        }
      ],
      "Documents": [
        {
          "Description": "Datasheet",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/dc022a72-3356-4df3-993a-1a92861f3d86.pdf"
        }
      ],
      "Relatedproducts": [
        "YEA-CPW90"
      ],
      "Accessories": [
        "YEA-USB2-2-5M",
        "YEA-USB2-7M",
        "YEA-USB2-EXT-10M",
        "YEA-USB2-EXT-20M",
        "YEA-USB2-EXT-5M",
        "YEA-USB2CAT5E-EXT",
        "YEA-USBC-HDMI"
      ],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 3,
      "Length": 13,
      "Width": 4,
      "Weight": 1.3,
      "DimensionalAirWeigth": 1.12,
      "DimensionalGroundWeight": 0.94,
      "Features": [
        {
          "Name": "Accessories",
          "Value": "Yes"
        },
        {
          "Name": "No. Accessory/Replacement Microphones",
          "Value": "2"
        },
        {
          "Name": "Wired, Wireless, or IP",
          "Value": "Wireless"
        },
        {
          "Name": "Color",
          "Value": "Silver"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": "Retail Bo"
        },
        {
          "Name": "Warranty",
          "Value": "1 Year"
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "Business Equipment",
          "SubCategories": [
            {
              "Name": "Conferencing Equipment"
            }
          ]
        }
      ],
      "PartNumber": "YEA-CPW90-PACKAGE",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-CPW90-PACKAGE",
      "Manufacturer": "Yealink",
      "ProductName": "CPW90 Package 1204620",
      "UnitPrice": 190,
      "MSRP": 300,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 72,
      "UPC": "841885102850"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 0,
      "PriceChangeDate": "2021-10-18T16:15:05.033",
      "ShipmentRecievedDate": "2021-12-14T00:00:00",
      "StandardPrice": 20,
      "EnergyStartCompliant": false,
      "ProductDescription": "- Controller (UC button for UH36<br/>- USB-A 20",
      "SKU": "1300076 UC button for UH36",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-YHC20-UC",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/9122bde5-d7f1-4f6f-b037-237c453397c1.jpg"
        }
      ],
      "Documents": [],
      "Relatedproducts": [],
      "Accessories": [],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 1,
      "Length": 4,
      "Width": 2,
      "Weight": 0.05,
      "DimensionalAirWeigth": 0.06,
      "DimensionalGroundWeight": 0.05,
      "Features": [
        {
          "Name": "Range - Feet",
          "Value": null
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": null
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": null
        },
        {
          "Name": "Warranty",
          "Value": null
        },
        {
          "Name": "Website Link",
          "Value": "https://www.yealink.com/"
        }
      ],
      "Categories": [
        {
          "Name": "Business Equipment",
          "SubCategories": [
            {
              "Name": "Headsets"
            }
          ]
        }
      ],
      "PartNumber": "YEA-YHC20-UC",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-YHC20-UC",
      "Manufacturer": "Yealink",
      "ProductName": "1300076 UC button for UH36",
      "UnitPrice": 20,
      "MSRP": 0,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 87,
      "UPC": "YEA-YHC20-UC"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 0,
      "PriceChangeDate": "2021-10-20T17:35:07.173",
      "ShipmentRecievedDate": "2022-01-06T00:00:00",
      "StandardPrice": 1,
      "EnergyStartCompliant": false,
      "ProductDescription": "Yealink Handset Clip for T42",
      "SKU": "Yealink Handset Clip for T42/T43U",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-HC-T42",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/dde681e9-f4dd-4c0c-b8e8-313439ac5ff6.jpg"
        }
      ],
      "Documents": [],
      "Relatedproducts": [
        "YEA-SIP-T42S"
      ],
      "Accessories": [],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 0.5,
      "Length": 0.5,
      "Width": 0.25,
      "Weight": 0.001,
      "DimensionalAirWeigth": 0,
      "DimensionalGroundWeight": 0,
      "Features": [
        {
          "Name": "Accessories",
          "Value": "Yes"
        }
      ],
      "EnvironmentalFeatures": [],
      "OtherFeatures": [],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-HC-T42",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-HC-T42",
      "Manufacturer": "Yealink",
      "ProductName": "Yealink Handset Clip for T42/T43U",
      "UnitPrice": 1,
      "MSRP": 0,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 608,
      "UPC": "YEA-HC-T42"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 59.99,
      "PriceChangeDate": "2021-10-21T17:15:04.547",
      "ShipmentRecievedDate": "2022-01-06T00:00:00",
      "StandardPrice": 49,
      "EnergyStartCompliant": false,
      "ProductDescription": "Bluetooth handset for T58W, MP58W",
      "SKU": "1300005 Bluetooth handset for T58W",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-BTH58",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/f061b6c5-9197-4f18-a8f4-7408388178da.jpg"
        }
      ],
      "Documents": [],
      "Relatedproducts": [
        "YEA-SIP-T58W",
        "YEA-SIP-T58W-PRO"
      ],
      "Accessories": [],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 3,
      "Length": 9,
      "Width": 3,
      "Weight": 0.45,
      "DimensionalAirWeigth": 0.58,
      "DimensionalGroundWeight": 0.49,
      "Features": [
        {
          "Name": "Accessories",
          "Value": "Yes"
        },
        {
          "Name": "Replacement Handsets",
          "Value": "Yes"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": null
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": null
        },
        {
          "Name": "Warranty",
          "Value": null
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-BTH58",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-BTH58",
      "Manufacturer": "Yealink",
      "ProductName": "1300005 Bluetooth handset for T58W",
      "UnitPrice": 49,
      "MSRP": 59.99,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 66,
      "UPC": "841885104724"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 799,
      "PriceChangeDate": "2021-11-05T09:15:04.313",
      "ShipmentRecievedDate": "2021-12-06T00:00:00",
      "StandardPrice": 410,
      "EnergyStartCompliant": false,
      "ProductDescription": "- 4-inch multi-touch screen with 480x800 resolution<br/>- Optimal HD audio, full duplex technology<br/>- Yealink Noise Proof Technology<br/>- Built-in rechargeable lithium battery<br/>- Up to 20 hours talk time (in ideal conditions)<br/>- Up to 75 hours standby time in Wi-Fi mode (in ideal conditions)<br/>- 20-foot (6-meter) and 360° voice pickup<br/>- Built-in 6-microphone array for voice pickup<br/>- 5-way conference call<br/>- Hybrid UC meeting<br/>- Built-in Wi-Fi (2.4GHz/5GHz, 802.11a/b/g/n)<br/>- Built-in Bluetooth 4.2 ",
      "SKU": "1304016 Yealink DECT Conference Phone",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-CP935W",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/1dc76993-62ba-4fa4-a012-afbc992658a0.jpg"
        }
      ],
      "Documents": [
        {
          "Description": "Datasheet",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/0ec18954-bf3a-4e68-9c9b-cf66f3684e21.pdf"
        }
      ],
      "Relatedproducts": [
        "YEA-CP920",
        "YEA-CP925",
        "YEA-CP930W",
        "YEA-CP965"
      ],
      "Accessories": [
        "YEA-WARR-D_OLD",
        "YEA-USB2-2-5M",
        "YEA-USB2-7M",
        "YEA-USB2-EXT-10M",
        "YEA-USB2-EXT-20M",
        "YEA-USB2-EXT-5M",
        "YEA-USB2CAT5E-EXT",
        "YEA-USBC-HDMI"
      ],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": true,
      "Height": 14,
      "Length": 15,
      "Width": 5,
      "Weight": 1.72,
      "DimensionalAirWeigth": 7.55,
      "DimensionalGroundWeight": 6.33,
      "Features": [
        {
          "Name": "3-Way Calling",
          "Value": "Yes"
        },
        {
          "Name": "Bluetooth",
          "Value": "Yes"
        },
        {
          "Name": "Call Hold",
          "Value": "Yes"
        },
        {
          "Name": "LCD Display",
          "Value": "Yes"
        },
        {
          "Name": "Mute",
          "Value": "Yes"
        },
        {
          "Name": "No. Accessory/Replacement Microphones",
          "Value": null
        },
        {
          "Name": "Touchscreen",
          "Value": "Yes"
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": "Retail Box"
        },
        {
          "Name": "Warranty",
          "Value": "1 Year"
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "Business Equipment",
          "SubCategories": [
            {
              "Name": "Conferencing Equipment"
            }
          ]
        }
      ],
      "PartNumber": "YEA-CP935W",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-CP935W",
      "Manufacturer": "Yealink",
      "ProductName": "1304016 Yealink DECT Conference Phone",
      "UnitPrice": 410,
      "MSRP": 799,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 117,
      "UPC": "841885106995"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 799,
      "PriceChangeDate": "2021-12-01T09:15:05.303",
      "ShipmentRecievedDate": "2022-04-27T00:00:00",
      "StandardPrice": 450,
      "EnergyStartCompliant": false,
      "ProductDescription": "- CP935W is a Wi-Fi or DECT conference phone designed for small to medium rooms<br/>- Base station connects the conference phone to your IP phone system when using the phone in DECT Mode",
      "SKU": "1204613 Yealink DECT Conf Phone w/W70B",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-CP935W-BASE",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/3dc0783e-beeb-4da9-baf7-b241007f0259.jpg"
        }
      ],
      "Documents": [
        {
          "Description": "Datasheet",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/f29c8f73-ef22-483e-a23e-3f9cff1a505d.pdf"
        }
      ],
      "Relatedproducts": [
        "YEA-CP935W"
      ],
      "Accessories": [
        "YEA-WARR-D_OLD",
        "YEA-USB2-2-5M",
        "YEA-USB2-7M",
        "YEA-USB2-EXT-10M",
        "YEA-USB2-EXT-20M",
        "YEA-USB2-EXT-5M",
        "YEA-USB2CAT5E-EXT",
        "YEA-USBC-HDMI"
      ],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": true,
      "Height": 14,
      "Length": 15,
      "Width": 5,
      "Weight": 4.05,
      "DimensionalAirWeigth": 7.55,
      "DimensionalGroundWeight": 6.33,
      "Features": [
        {
          "Name": "3-Way Calling",
          "Value": "Yes"
        },
        {
          "Name": "Bluetooth",
          "Value": "Yes"
        },
        {
          "Name": "Call Hold",
          "Value": "Yes"
        },
        {
          "Name": "LCD Display",
          "Value": "Yes"
        },
        {
          "Name": "Mute",
          "Value": "Yes"
        },
        {
          "Name": "No. Accessory/Replacement Microphones",
          "Value": null
        },
        {
          "Name": "Touchscreen",
          "Value": "Yes"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": "Retail Box"
        },
        {
          "Name": "Warranty",
          "Value": "1 Year"
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "Business Equipment",
          "SubCategories": [
            {
              "Name": "Conferencing Equipment"
            }
          ]
        }
      ],
      "PartNumber": "YEA-CP935W-BASE",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-CP935W-BASE",
      "Manufacturer": "Yealink",
      "ProductName": "1204613 Yealink DECT Conf Phone w/W70B",
      "UnitPrice": 450,
      "MSRP": 899,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 206,
      "UPC": "841885108333"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 209,
      "PriceChangeDate": "2021-12-09T12:35:04.557",
      "ShipmentRecievedDate": "2022-01-18T00:00:00",
      "StandardPrice": 166,
      "EnergyStartCompliant": false,
      "ProductDescription": "- Android 9.0<br/>- Zoom User Interface<br/>- 4 inch (800 x 480) Capacitive Touch Screen<br/>- Magnet Handset<br/>- Optimal HD audio, Yealink Noise Proof Technology<br/>- Full-duplex hands-free speakerphone with AEC<br/>- Bluetooth Headset via BT41<br/>- Wi-Fi via WF50<br/>- USB 2.0 port, Support USB Headset<br/>- Dual-port Gigabit Ethernet, Support PoE<br/>- Wall mountable<br/>- Support Yealink/Zoom Device Management Platform",
      "SKU": "Cost-effective Phone for Zoom",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-MP54-ZOOM\n",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/faed4e96-ac17-4200-a105-b929c67e89fa.jpg"
        },
        {
          "Description": "YEA-MP54-ZOOM",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/a62bc7a4-bb78-461e-8e55-40c1facd352f.jpg"
        }
      ],
      "Documents": [
        {
          "Description": "Datasheet",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/06ef73eb-31cf-4102-b5b2-3e3a0242bbf8.pdf"
        }
      ],
      "Relatedproducts": [
        "YEA-MP54-SFB",
        "YEA-MP54-TEAMS"
      ],
      "Accessories": [
        "YEA-HNDST-T53-T54",
        "YEA-WARR-B"
      ],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 8,
      "Length": 11,
      "Width": 5,
      "Weight": 2.25,
      "DimensionalAirWeigth": 3.17,
      "DimensionalGroundWeight": 2.65,
      "Features": [
        {
          "Name": "Bluetooth",
          "Value": "Yes"
        },
        {
          "Name": "Call Waiting",
          "Value": "Yes"
        },
        {
          "Name": "Caller ID (CID)",
          "Value": "Yes"
        },
        {
          "Name": "Conference Calling",
          "Value": "Yes"
        },
        {
          "Name": "Corded or Cordless",
          "Value": "Corded"
        },
        {
          "Name": "Ethernet Ports",
          "Value": "2"
        },
        {
          "Name": "Headset Port",
          "Value": "Yes"
        },
        {
          "Name": "LCD Backlit Display",
          "Value": "Yes"
        },
        {
          "Name": "Power Source",
          "Value": "PoE"
        },
        {
          "Name": "Speakerphone",
          "Value": "Yes"
        },
        {
          "Name": "Voicemail",
          "Value": "Yes"
        },
        {
          "Name": "Wall Mountable",
          "Value": "Yes"
        },
        {
          "Name": "Wifi",
          "Value": "Yes"
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": "Retail Box"
        },
        {
          "Name": "Warranty",
          "Value": "1 Year"
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-MP54-ZOOM",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-MP54-ZOOM",
      "Manufacturer": "Yealink",
      "ProductName": "Cost-effective Phone for Zoom",
      "UnitPrice": 166,
      "MSRP": 239,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 84,
      "UPC": "841885108425"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 269,
      "PriceChangeDate": "2021-12-09T12:35:04.557",
      "ShipmentRecievedDate": "2022-01-18T00:00:00",
      "StandardPrice": 203,
      "EnergyStartCompliant": false,
      "ProductDescription": "- Android 9.0<br/>- Zoom User Interface<br/>- 7 inch (800x480) Capacitive Touch Screen<br/>- Magnet Handset<br/>- Optimal HD audio, Yealink Noise Proof Technology<br/>- Full-duplex hands-free speakerphone with AEC<br/>- Built-in Bluetooth 4.2 Module and 2.4G/5G Wi-Fi<br/>- USB 2.0 port, Support USB Headset, Media and Storage Applications<br/>- Dual-port Gigabit Ethernet, Support PoE<br/>- Wall mountable<br/>- Support Yealink/Zoom Device Management Platform",
      "SKU": "Zoom Certified Phone for Knowledge Worke",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-MP56-ZOOM",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/e3538260-7267-46ce-8213-3901eaf2b54d.jpg"
        },
        {
          "Description": "YEA-MP56-ZOOM",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/1225d8c7-dfe7-4942-823c-dd27804089d0.jpg"
        },
        {
          "Description": "YEA-MP56-ZOOM",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/7f07932d-2aca-477f-a8b1-0eab3ca35eac.jpg"
        }
      ],
      "Documents": [
        {
          "Description": "Datasheet",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/236bd91d-f523-4dd5-86ee-ce3e4941f967.pdf"
        }
      ],
      "Relatedproducts": [
        "YEA-MP50",
        "YEA-MP54-SFB",
        "YEA-MP54-TEAMS",
        "YEA-MP54-ZOOM",
        "YEA-MP56-SFB",
        "YEA-MP56-TEAMS"
      ],
      "Accessories": [
        "YEA-PS5V2000US",
        "YEA-HNDST-MP56",
        "YEA-WARR-C"
      ],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 10,
      "Length": 12,
      "Width": 5,
      "Weight": 3.25,
      "DimensionalAirWeigth": 4.32,
      "DimensionalGroundWeight": 3.61,
      "Features": [
        {
          "Name": "Bluetooth",
          "Value": "Yes"
        },
        {
          "Name": "Call Waiting",
          "Value": "Yes"
        },
        {
          "Name": "Caller ID (CID)",
          "Value": "Yes"
        },
        {
          "Name": "Conference Calling",
          "Value": "Yes"
        },
        {
          "Name": "Corded or Cordless",
          "Value": "Corded"
        },
        {
          "Name": "Ethernet Ports",
          "Value": "2"
        },
        {
          "Name": "Headset Port",
          "Value": "Yes"
        },
        {
          "Name": "LCD Backlit Display",
          "Value": "Yes"
        },
        {
          "Name": "Power Source",
          "Value": "PoE"
        },
        {
          "Name": "Speakerphone",
          "Value": "Yes"
        },
        {
          "Name": "Touchscreen",
          "Value": "Yes"
        },
        {
          "Name": "Voicemail",
          "Value": "Yes"
        },
        {
          "Name": "Wall Mountable",
          "Value": "Yes"
        },
        {
          "Name": "Wifi",
          "Value": "Yes"
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": "Retail Box"
        },
        {
          "Name": "Warranty",
          "Value": "1 Year"
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-MP56-ZOOM",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-MP56-ZOOM",
      "Manufacturer": "Yealink",
      "ProductName": "Zoom Certified Phone for Knowledge Worke",
      "UnitPrice": 203,
      "MSRP": 339,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 74,
      "UPC": "841885108432"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 289,
      "PriceChangeDate": "2023-10-06T11:15:03.447",
      "ShipmentRecievedDate": "2022-01-18T00:00:00",
      "StandardPrice": 217,
      "EnergyStartCompliant": false,
      "ProductDescription": "- Android 12.0<br/>- Zoom User Interface<br/>- 7 inch (1024 x 600) Capacitive Touch Screen<br/>- Bluetooth Handset BTH58 (Optional)<br/>- Optimal HD audio, Yealink Noise Proof Technology<br/>- Full-duplex hands-free speakerphone with AEC<br/>- Built-in Bluetooth 4.2 Module and 2.4G/5G Wi-Fi<br/>- 2 x USB 2.0 port, Support USB Headset, Media and Storage Applications<br/>- Dual-port Gigabit Ethernet, Support PoE<br/>- Compatible with wall mount bracket YEA-WMB-T5S<br/>- Support Yealink/Zoom Device Management Platform",
      "SKU": "Premium Smart Business Phone for Zoom",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-MP58-ZOOM",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/c326ff3d-d3e3-48ca-a661-306e95a510d5.jpg"
        },
        {
          "Description": "YEA-MP58-ZOOM",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/8cecafb0-01d7-4b48-9ec4-10e14352fca6.jpg"
        }
      ],
      "Documents": [
        {
          "Description": "Datasheet",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/82bc14bf-dd7b-4722-b547-346fe8cd50c2.pdf"
        }
      ],
      "Relatedproducts": [
        "YEA-MP50",
        "YEA-MP54-SFB",
        "YEA-MP54-TEAMS",
        "YEA-MP54-ZOOM",
        "YEA-MP56-SFB",
        "YEA-MP56-TEAMS",
        "YEA-MP56-ZOOM",
        "YEA-MP58-SFB",
        "YEA-MP58-TEAMS",
        "YEA-MP58-WH-SFB",
        "YEA-MP58-WH-TEAMS",
        "YEA-MP58-WH-ZOOM"
      ],
      "Accessories": [
        "YEA-MP58-WH-TEAMS",
        "YEA-WMB-T5S",
        "YEA-HNDST-MP56",
        "YEA-WARR-C"
      ],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 12,
      "Length": 14,
      "Width": 6,
      "Weight": 3.9,
      "DimensionalAirWeigth": 7.25,
      "DimensionalGroundWeight": 6.07,
      "Features": [
        {
          "Name": "Bluetooth",
          "Value": "Yes"
        },
        {
          "Name": "Call Waiting",
          "Value": "Yes"
        },
        {
          "Name": "Caller ID (CID)",
          "Value": "Yes"
        },
        {
          "Name": "Conference Calling",
          "Value": "Yes"
        },
        {
          "Name": "Corded or Cordless",
          "Value": "Corded"
        },
        {
          "Name": "EHS",
          "Value": "Yes"
        },
        {
          "Name": "Ethernet Ports",
          "Value": "2"
        },
        {
          "Name": "Headset Port",
          "Value": "Yes"
        },
        {
          "Name": "LCD Backlit Display",
          "Value": "Yes"
        },
        {
          "Name": "Microsoft Lync/Skype for Business",
          "Value": null
        },
        {
          "Name": "Power Source",
          "Value": "PoE"
        },
        {
          "Name": "Speakerphone",
          "Value": "Yes"
        },
        {
          "Name": "Voicemail",
          "Value": "Yes"
        },
        {
          "Name": "Wall Mountable",
          "Value": "Yes"
        },
        {
          "Name": "Wifi",
          "Value": "Yes"
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": "Retail Box"
        },
        {
          "Name": "Warranty",
          "Value": "1 Year"
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-MP58-ZOOM",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-MP58-ZOOM",
      "Manufacturer": "Yealink",
      "ProductName": "Premium Smart Business Phone for Zoom",
      "UnitPrice": 217,
      "MSRP": 429,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 1,
      "UPC": "841885108449"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 309,
      "PriceChangeDate": "2023-10-06T11:15:03.447",
      "ShipmentRecievedDate": "2022-03-09T00:00:00",
      "StandardPrice": 232,
      "EnergyStartCompliant": false,
      "ProductDescription": "- Android 12.0<br/>- Zoom User Interface<br/>- 7 inch (1024 x 600) Capacitive Touch Screen<br/>- Bluetooth Handset BTH58<br/>- Optimal HD audio, Yealink Noise Proof Technology<br/>- Full-duplex hands-free speakerphone with AEC<br/>- Built-in Bluetooth 4.2 Module and 2.4G/5G Wi-Fi<br/>- 2 x USB 2.0 port, Support USB Headset, Media and Storage Applications<br/>- Dual-port Gigabit Ethernet, Support PoE<br/>- Compatible with wall mount bracket YEA-WMB-T5S<br/>- Support Yealink/Zoom Device Management Platform",
      "SKU": "Premium Phone Zoom w/ Wireless Handset",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-MP58-WH-ZOOM",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/981e4786-eeb4-4e15-b5a2-4f0f8f99bf98.jpg"
        },
        {
          "Description": "YEA-MP58-WH-ZOOM",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/9d45fa40-ab3e-4a04-a292-333fe9b4079c.jpg"
        }
      ],
      "Documents": [
        {
          "Description": "Datasheet",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/d758ab29-31a1-4bb4-9ac1-a61f20262837.pdf"
        }
      ],
      "Relatedproducts": [
        "YEA-MP50",
        "YEA-MP54-SFB",
        "YEA-MP54-TEAMS",
        "YEA-MP54-ZOOM",
        "YEA-MP56-SFB",
        "YEA-MP56-TEAMS",
        "YEA-MP56-ZOOM",
        "YEA-MP58-SFB",
        "YEA-MP58-TEAMS",
        "YEA-MP58-WH-SFB",
        "YEA-MP58-WH-TEAMS"
      ],
      "Accessories": [
        "YEA-MP58-WH-TEAMS",
        "YEA-WMB-T5S",
        "YEA-HNDST-MP56"
      ],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 12,
      "Length": 13,
      "Width": 6,
      "Weight": 3.8,
      "DimensionalAirWeigth": 6.73,
      "DimensionalGroundWeight": 5.64,
      "Features": [
        {
          "Name": "Bluetooth",
          "Value": "Yes"
        },
        {
          "Name": "Call Waiting",
          "Value": "Yes"
        },
        {
          "Name": "Caller ID (CID)",
          "Value": "Yes"
        },
        {
          "Name": "Conference Calling",
          "Value": "Yes"
        },
        {
          "Name": "Corded or Cordless",
          "Value": "Cordless"
        },
        {
          "Name": "Ethernet Ports",
          "Value": "2"
        },
        {
          "Name": "Headset Port",
          "Value": "Yes"
        },
        {
          "Name": "LCD Backlit Display",
          "Value": "Yes"
        },
        {
          "Name": "Power Source",
          "Value": "PoE"
        },
        {
          "Name": "Speakerphone",
          "Value": "Yes"
        },
        {
          "Name": "Voicemail",
          "Value": "Yes"
        },
        {
          "Name": "Wall Mountable",
          "Value": "Yes"
        },
        {
          "Name": "Wifi",
          "Value": "Yes"
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": "Retail Box"
        },
        {
          "Name": "Warranty",
          "Value": "1 Year"
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-MP58-WH-ZOOM",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-MP58-WH-ZOOM",
      "Manufacturer": "Yealink",
      "ProductName": "Premium Phone Zoom w/ Wireless Handset",
      "UnitPrice": 232,
      "MSRP": 479,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 0,
      "UPC": "841885109040"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 189,
      "PriceChangeDate": "2023-09-20T12:35:03.437",
      "ShipmentRecievedDate": "2022-01-18T00:00:00",
      "StandardPrice": 151,
      "EnergyStartCompliant": false,
      "ProductDescription": "- Android 9.0 Operating Software<br/>- 2.4 inch (320 x 240p) Non-touch Colour Screen<br/>- Optimal HD audio, Yealink Noise Proof Technology<br/>- Magnet Handset<br/>- Bluetooth Headset via Dongle BT41<br/>- Wi-Fi via Dongle WF50<br/>- USB Type A port, Supports USB Headset<br/>- Microsoft Teams-tailored APP<br/>- Dual-port 10/100M Ethernet Switch, Supports PoE<br/>- Supports Microsoft/Yealink/Unify Square Device<br/>- Management Platform<br/>- Wall mountable",
      "SKU": "Microsoft Certified Teams Phone",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-MP52-TEAMS",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/14f513a0-7c11-4400-a771-397e6ceb1e52.jpg"
        },
        {
          "Description": "YEA-MP52-TEAMS",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/48f7eea2-a09c-4a84-a419-3f8e85c6b356.jpg"
        },
        {
          "Description": "YEA-MP52-TEAMS",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/339e22ae-d080-43c7-aa39-9f0afedea093.jpg"
        }
      ],
      "Documents": [],
      "Relatedproducts": [],
      "Accessories": [
        "YEA-PS5V600US",
        "YEA-WMB-T33G"
      ],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 9,
      "Length": 10,
      "Width": 5,
      "Weight": 2.25,
      "DimensionalAirWeigth": 3.24,
      "DimensionalGroundWeight": 2.71,
      "Features": [
        {
          "Name": "Bluetooth",
          "Value": "Yes"
        },
        {
          "Name": "Call Waiting",
          "Value": "Yes"
        },
        {
          "Name": "Caller ID (CID)",
          "Value": "Yes"
        },
        {
          "Name": "Conference Calling",
          "Value": "Yes"
        },
        {
          "Name": "Corded or Cordless",
          "Value": "Corded"
        },
        {
          "Name": "Ethernet Ports",
          "Value": "1"
        },
        {
          "Name": "Headset Port",
          "Value": "Yes"
        },
        {
          "Name": "Microsoft Lync/Skype for Business",
          "Value": "Yes"
        },
        {
          "Name": "Speakerphone",
          "Value": "Yes"
        },
        {
          "Name": "Teams Platform",
          "Value": "Yes"
        },
        {
          "Name": "Voicemail",
          "Value": "Yes"
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": "Retail Box"
        },
        {
          "Name": "Warranty",
          "Value": "1 Year"
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-MP52-TEAMS",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-MP52-TEAMS",
      "Manufacturer": "Yealink",
      "ProductName": "Microsoft Certified Teams Phone",
      "UnitPrice": 151,
      "MSRP": 189,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 94,
      "UPC": "841885106056"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 0,
      "PriceChangeDate": "2021-12-30T11:55:03.92",
      "ShipmentRecievedDate": "2022-06-07T00:00:00",
      "StandardPrice": 15,
      "EnergyStartCompliant": false,
      "ProductDescription": "Battery cap for W59R",
      "SKU": "330100001029 Battery cap for W59R",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-BTC-W59R",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/f2ceefaa-66e7-4083-98cf-8f74cd66756b.jpg"
        }
      ],
      "Documents": [],
      "Relatedproducts": [
        "YEA-W59R"
      ],
      "Accessories": [],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 1,
      "Length": 3,
      "Width": 2,
      "Weight": 0.05,
      "DimensionalAirWeigth": 0.04,
      "DimensionalGroundWeight": 0.04,
      "Features": [
        {
          "Name": "Accessories",
          "Value": "Yes"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": null
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": null
        },
        {
          "Name": "Warranty",
          "Value": null
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-BTC-W59R",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-BTC-W59R",
      "Manufacturer": "Yealink",
      "ProductName": "330100001029 Battery cap for W59R",
      "UnitPrice": 15,
      "MSRP": 0,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 176,
      "UPC": "YEA-BTC-W59R"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 0,
      "PriceChangeDate": "2021-12-30T11:55:03.92",
      "ShipmentRecievedDate": "2022-06-10T00:00:00",
      "StandardPrice": 7,
      "EnergyStartCompliant": false,
      "ProductDescription": "- Belt Clip for W59R<br/>- Screws not included",
      "SKU": "330100010031 Belt Clip for W59R",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-BCL-W59R",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/f321f57a-3dd7-40b7-9bc9-a6eeb5ef1389.jpg"
        }
      ],
      "Documents": [],
      "Relatedproducts": [
        "YEA-W59R"
      ],
      "Accessories": [],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 3,
      "Length": 7,
      "Width": 7,
      "Weight": 0.2,
      "DimensionalAirWeigth": 1.06,
      "DimensionalGroundWeight": 0.89,
      "Features": [],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": null
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": null
        },
        {
          "Name": "Warranty",
          "Value": null
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-BCL-W59R",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-BCL-W59R",
      "Manufacturer": "Yealink",
      "ProductName": "330100010031 Belt Clip for W59R",
      "UnitPrice": 7,
      "MSRP": 0,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 169,
      "UPC": "YEA-BCL-W59R"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 0,
      "PriceChangeDate": "2021-12-30T11:55:03.92",
      "ShipmentRecievedDate": "2022-06-10T00:00:00",
      "StandardPrice": 15,
      "EnergyStartCompliant": false,
      "ProductDescription": "Charging Cradle for W59R<br/>- Power cord not included",
      "SKU": "230200600001 Charging Cradle for W59R",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-CCD-W59R",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/534fe810-16f5-4da3-b3c7-eaa819d63428.jpg"
        }
      ],
      "Documents": [],
      "Relatedproducts": [
        "YEA-W59R"
      ],
      "Accessories": [],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 2,
      "Length": 4,
      "Width": 3,
      "Weight": 0.2,
      "DimensionalAirWeigth": 0.17,
      "DimensionalGroundWeight": 0.14,
      "Features": [
        {
          "Name": "Accessories",
          "Value": "Yes"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": null
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": null
        },
        {
          "Name": "Warranty",
          "Value": "www.yealink.com"
        },
        {
          "Name": "Website Link",
          "Value": null
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-CCD-W59R",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-CCD-W59R",
      "Manufacturer": "Yealink",
      "ProductName": "230200600001 Charging Cradle for W59R",
      "UnitPrice": 15,
      "MSRP": 0,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 78,
      "UPC": "841885112309"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 0,
      "PriceChangeDate": "2022-01-12T11:35:03.6",
      "ShipmentRecievedDate": "2023-06-20T00:00:00",
      "StandardPrice": 2.5,
      "EnergyStartCompliant": false,
      "ProductDescription": "Replacement battery cover for W56H",
      "SKU": "330200003006 Replace battery cover W56H",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-BTC-W56",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/88734a50-47d8-4405-8535-b077aa6e737b.jpg"
        }
      ],
      "Documents": [],
      "Relatedproducts": [
        "YEA-W56H"
      ],
      "Accessories": [],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 1,
      "Length": 1,
      "Width": 1,
      "Weight": 0.1,
      "DimensionalAirWeigth": 0.01,
      "DimensionalGroundWeight": 0.01,
      "Features": [
        {
          "Name": "Accessories",
          "Value": "Yes"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": null
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": null
        },
        {
          "Name": "Warranty",
          "Value": null
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-BTC-W56",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-BTC-W56",
      "Manufacturer": "Yealink",
      "ProductName": "330200003006 Replace battery cover W56H",
      "UnitPrice": 2.5,
      "MSRP": 0,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 19,
      "UPC": "YEA-BTC-W56"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 0,
      "PriceChangeDate": "2022-02-15T15:55:03.497",
      "ShipmentRecievedDate": "2022-04-21T00:00:00",
      "StandardPrice": 1,
      "EnergyStartCompliant": false,
      "ProductDescription": "WMC-T33G Handset clip for T31P/G & 33G/34W",
      "SKU": "WMC-T33G Handset clip T31P/G & 33G/34W",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-HC-T3X",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/91984e1b-53d1-4c37-95aa-39bb84cf3746.jpg"
        }
      ],
      "Documents": [],
      "Relatedproducts": [
        "YEA-SIP-T31G",
        "YEA-SIP-T31P",
        "YEA-SIP-T33G"
      ],
      "Accessories": [],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 0.5,
      "Length": 0.5,
      "Width": 0.25,
      "Weight": 0.001,
      "DimensionalAirWeigth": 0,
      "DimensionalGroundWeight": 0,
      "Features": [
        {
          "Name": "Accessories",
          "Value": "Yes"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": null
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": null
        },
        {
          "Name": "Warranty",
          "Value": null
        },
        {
          "Name": "Website Link",
          "Value": "http://www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-HC-T3X",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-HC-T3X",
      "Manufacturer": "Yealink",
      "ProductName": "WMC-T33G Handset clip T31P/G & 33G/34W",
      "UnitPrice": 1,
      "MSRP": 0,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 533,
      "UPC": "YEA-HC-T3X"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 0,
      "PriceChangeDate": "2023-03-31T18:15:04.67",
      "ShipmentRecievedDate": "2022-06-07T00:00:00",
      "StandardPrice": 453,
      "EnergyStartCompliant": false,
      "ProductDescription": "- Based on Android 9.0<br/>- Native Zoom user interface<br/>- 8 inch (1280 x 800) capacitive adjustable touch screen<br/>- 2 mega-pixel HD camera with privacy shutter<br/>- Yealink USB camera UVC30 Room (Coming soon)<br/>- Built-in Bluetooth 4.2<br/>- Built-in dual band 2.4G/5G Wi-Fi<br/>- Dual-port USB 2.0<br/>- Dual-port Gigabit Ethernet, PoE support<br/>- HDMI port for connection to monitor or TV<br/>- Full-duplex hands-free speakerphone with AEC<br/>- Support Zoom/Yealink device management platform",
      "SKU": "1303056 Yealink VP59 -ZOOM Video Phone",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-VP59G-ZOOM",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/fba2f24e-866d-4768-a01d-4a159553bc35.jpg"
        },
        {
          "Description": "YEA-VP59G-ZOOM",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/97d27368-702c-40af-8795-ba6ac5aa49a2.jpg"
        }
      ],
      "Documents": [
        {
          "Description": "Datasheet",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/b3cd66cb-5dd1-4e84-8915-03be3936fe98.pdf"
        }
      ],
      "Relatedproducts": [
        "YEA-VP59G"
      ],
      "Accessories": [
        "YEA-CAM-VP59"
      ],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 14,
      "Length": 15,
      "Width": 5,
      "Weight": 5.5,
      "DimensionalAirWeigth": 7.55,
      "DimensionalGroundWeight": 6.33,
      "Features": [
        {
          "Name": "Bluetooth",
          "Value": "Yes"
        },
        {
          "Name": "Call Waiting",
          "Value": "Yes"
        },
        {
          "Name": "Caller ID (CID)",
          "Value": "Yes"
        },
        {
          "Name": "Conference Calling",
          "Value": "Yes"
        },
        {
          "Name": "Corded or Cordless",
          "Value": "Corded"
        },
        {
          "Name": "Ethernet Ports",
          "Value": "2"
        },
        {
          "Name": "Headset Port",
          "Value": "Yes"
        },
        {
          "Name": "LCD Backlit Display",
          "Value": "Yes"
        },
        {
          "Name": "Number SIP Accounts/Identities",
          "Value": "10+"
        },
        {
          "Name": "Power Source",
          "Value": "PoE"
        },
        {
          "Name": "Speakerphone",
          "Value": "Yes"
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": "Retail Box"
        },
        {
          "Name": "Warranty",
          "Value": "1 Year"
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-VP59G-ZOOM",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-VP59G-ZOOM",
      "Manufacturer": "Yealink",
      "ProductName": "1303056 Yealink VP59 -ZOOM Video Phone",
      "UnitPrice": 453,
      "MSRP": 799,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 0,
      "UPC": "841885107381"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 300,
      "PriceChangeDate": "2022-05-05T09:35:03.677",
      "ShipmentRecievedDate": "2022-09-11T00:00:00",
      "StandardPrice": 173,
      "EnergyStartCompliant": false,
      "ProductDescription": "- Optimal HD voice with 3 built-in microphones<br/>- Full duplex technology<br/>- Echo cancellation<br/>- 10-foot (3-meter) 360° voice pickup<br/>- Up to 20-meter connection distance with CP965<br/>- 11-day standby time and 13-hour talk time<br/>- Intuitive capacitive mute buttons<br/>- 360° nondirectional charging on charger cradle<br/>- DECT Technology",
      "SKU": "2 Wireless Expansion Mics for CP965",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-CPW65-DECT-Duo",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/182645b6-9fe4-4444-8896-889f87606178.jpg"
        }
      ],
      "Documents": [
        {
          "Description": "Datasheet",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/7cdf93aa-6113-4311-bed9-6aa931860c23.pdf"
        }
      ],
      "Relatedproducts": [
        "YEA-CP965",
        "YEA-CP965-TEAMS"
      ],
      "Accessories": [],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 8.3,
      "Length": 16.1,
      "Width": 11.6,
      "Weight": 6,
      "DimensionalAirWeigth": 11.15,
      "DimensionalGroundWeight": 9.34,
      "Features": [
        {
          "Name": "Accessories",
          "Value": "Yes"
        },
        {
          "Name": "Microphone",
          "Value": "Yes"
        },
        {
          "Name": "No. Accessory/Replacement Microphones",
          "Value": null
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": "Retail Box"
        },
        {
          "Name": "Warranty",
          "Value": "1 Year"
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "Business Equipment",
          "SubCategories": [
            {
              "Name": "Conferencing Equipment"
            }
          ]
        }
      ],
      "PartNumber": "YEA-CPW65-DECT-DUO",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-CPW65-DECT-DUO",
      "Manufacturer": "Yealink",
      "ProductName": "2 Wireless Expansion Mics for CP965",
      "UnitPrice": 173,
      "MSRP": 300,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 85,
      "UPC": "6938818309890"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 1199,
      "PriceChangeDate": "2022-05-05T09:35:03.677",
      "ShipmentRecievedDate": "2022-07-20T00:00:00",
      "StandardPrice": 608,
      "EnergyStartCompliant": false,
      "ProductDescription": "- Red Dot[2021]<br/>- Android 9.0<br/>- 5-inch multi-touch screen with 720x1280 resolution<br/>- Optimal HD audio, full duplex technology<br/>- Yealink Noise Proof Technology<br/>- 20-foot (6-meter) and 360-degree voice pickup<br/>- Built-in 12-microphone array for voice pickup<br/>- Built-in 1-microphone array for noise cancellation<br/>- Power over Ethernet<br/>- 10-way conference call<br/>- Hybrid UC meeting<br/>- Built-in Wi-Fi (2.4GHz/5GHz, 802.11a/b/g/n)<br/>- Includes DECT wireless expansion microphone CPW65",
      "SKU": "1204612 CP965 + CPW65 EXPANSION MIC",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-CP965-WM",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/871681e3-bf36-4d7b-a86c-ab25c36ab5ff.jpg"
        }
      ],
      "Documents": [
        {
          "Description": "Datasheet",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/38d3f6dd-0584-429d-bf5b-06ec6d90dfe6.pdf"
        }
      ],
      "Relatedproducts": [
        "YEA-CP965",
        "YEA-CP965-TEAMS"
      ],
      "Accessories": [
        "YEA-YLPOE30",
        "YEA-WARR-E_OLD",
        "YEA-USB2-2-5M",
        "YEA-USB2-7M",
        "YEA-USB2-EXT-10M",
        "YEA-USB2-EXT-20M",
        "YEA-USB2-EXT-5M",
        "YEA-USB2CAT5E-EXT",
        "YEA-USBC-HDMI"
      ],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": true,
      "Height": 4,
      "Length": 16,
      "Width": 16,
      "Weight": 4.25,
      "DimensionalAirWeigth": 7.37,
      "DimensionalGroundWeight": 6.17,
      "Features": [
        {
          "Name": "3-Way Calling",
          "Value": "Yes"
        },
        {
          "Name": "Bluetooth",
          "Value": "Yes"
        },
        {
          "Name": "Call Hold",
          "Value": "Yes"
        },
        {
          "Name": "Call Recording",
          "Value": "Yes"
        },
        {
          "Name": "Echo Cancellation",
          "Value": "Yes"
        },
        {
          "Name": "Expandable",
          "Value": "Yes"
        },
        {
          "Name": "Full Duplex Speakerphone",
          "Value": "Yes"
        },
        {
          "Name": "LCD Display",
          "Value": "Yes"
        },
        {
          "Name": "Mute",
          "Value": "Yes"
        },
        {
          "Name": "No. Accessory/Replacement Microphones",
          "Value": null
        },
        {
          "Name": "Touchscreen",
          "Value": "Yes"
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": "Retail Box"
        },
        {
          "Name": "Warranty",
          "Value": "1 Year"
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "Business Equipment",
          "SubCategories": [
            {
              "Name": "Conferencing Equipment"
            }
          ]
        }
      ],
      "PartNumber": "YEA-CP965-WM",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-CP965-WM",
      "Manufacturer": "Yealink",
      "ProductName": "1204612 CP965 + CPW65 EXPANSION MIC",
      "UnitPrice": 608,
      "MSRP": 1199,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 103,
      "UPC": "841885108845"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 0,
      "PriceChangeDate": "2022-03-22T14:15:04.733",
      "ShipmentRecievedDate": "2022-06-10T00:00:00",
      "StandardPrice": 15,
      "EnergyStartCompliant": false,
      "ProductDescription": "Yealink Handset for T31G/T33G",
      "SKU": "Yealink Handset for T31G/T33G",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-HNDST-T3G",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/b1b66243-076f-4b54-a95b-e719f3b28ea8.jpg"
        }
      ],
      "Documents": [],
      "Relatedproducts": [],
      "Accessories": [],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 8,
      "Length": 2,
      "Width": 2,
      "Weight": 0.7,
      "DimensionalAirWeigth": 0.23,
      "DimensionalGroundWeight": 0.19,
      "Features": [
        {
          "Name": "Accessories",
          "Value": "Yes"
        },
        {
          "Name": "Replacement Handsets",
          "Value": "Yes"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": null
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": null
        },
        {
          "Name": "Warranty",
          "Value": null
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-HNDST-T3G",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-HNDST-T3G",
      "Manufacturer": "Yealink",
      "ProductName": "Yealink Handset for T31G/T33G",
      "UnitPrice": 15,
      "MSRP": 0,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 200,
      "UPC": "YEA-HNDST-T3G"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 0,
      "PriceChangeDate": "2022-03-24T17:15:05.827",
      "ShipmentRecievedDate": "2022-06-10T00:00:00",
      "StandardPrice": 29,
      "EnergyStartCompliant": false,
      "ProductDescription": "Wall mount bracket for UVC30",
      "SKU": "330100000056 WMB for UVC30",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-WMB-UVC30",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/d00618fe-79ea-49e3-9ccf-6faa7620a2b5.jpg"
        }
      ],
      "Documents": [],
      "Relatedproducts": [
        "YEA-UVC30-ContentCamKit",
        "YEA-UVC30-CP900-BYOD",
        "YEA-UVC30-DESKTOP",
        "YEA-UVC30-ROOM"
      ],
      "Accessories": [],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 2,
      "Length": 7,
      "Width": 4,
      "Weight": 0.35,
      "DimensionalAirWeigth": 0.4,
      "DimensionalGroundWeight": 0.34,
      "Features": [
        {
          "Name": "Accessories",
          "Value": "Yes"
        },
        {
          "Name": "Mounting Equipment",
          "Value": "Yes"
        },
        {
          "Name": "No. Accessory/Replacement Microphones",
          "Value": null
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": null
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": null
        },
        {
          "Name": "Warranty",
          "Value": null
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "Business Equipment",
          "SubCategories": [
            {
              "Name": "Conferencing Equipment"
            }
          ]
        }
      ],
      "PartNumber": "YEA-WMB-UVC30",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-WMB-UVC30",
      "Manufacturer": "Yealink",
      "ProductName": "330100000056 WMB for UVC30",
      "UnitPrice": 29,
      "MSRP": 0,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 8,
      "UPC": "841885111821"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 23,
      "PriceChangeDate": "2022-11-16T11:35:03.92",
      "ShipmentRecievedDate": "2022-06-24T00:00:00",
      "StandardPrice": 19,
      "EnergyStartCompliant": false,
      "ProductDescription": "- Compatible with BH71/BH72/BH76<br/>- Reliable connection<br/>- Up to 100ft/30m wireless range<br/>- Easy to use<br/>- Plug and play<br/>- PC connection: USB 2.0<br/>- Bluetooth profiles: HFP 1.6, DIP 1.3, A2DP 1.2<br/>- Bluetooth audio bandwidth: Narroband, Wideband, A2DP<br/>- Firmware update via Yealink Connect app<br/>- Visual indicator: One blue LED indicates pairing and connection",
      "SKU": "1300007 Bluetooth Dongle (USB-A  port)",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-BT51-A",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/0338f4a6-b54a-4a22-86a9-966940f30031.jpg"
        }
      ],
      "Documents": [],
      "Relatedproducts": [
        "YEA-BH72-BLK-LITE-TEAMS",
        "YEA-BH72-GY-LITE-TEAMS",
        "YEA-BH72-WCS-BLK-TEAMS",
        "YEA-BH72-WCS-BLK-UC",
        "YEA-BH72-WCS-GY-TEAMS",
        "YEA-BH72-WCS-GY-UC",
        "YEA-BH76-BLK-TEAMS",
        "YEA-BH76-BLK-UC",
        "YEA-BH76-GY-TEAMS",
        "YEA-BH76-GY-UC",
        "YEA-BH76-WCS-BLK-TEAMS",
        "YEA-BH76-WCS-BLK-UC",
        "YEA-BH76-WCS-GY-TEAMS",
        "YEA-BH76-WCS-GY-UC"
      ],
      "Accessories": [],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 1,
      "Length": 4,
      "Width": 3,
      "Weight": 0.05,
      "DimensionalAirWeigth": 0.09,
      "DimensionalGroundWeight": 0.07,
      "Features": [
        {
          "Name": "Bluetooth",
          "Value": "Yes"
        },
        {
          "Name": "Headset Adapters",
          "Value": "Yes"
        },
        {
          "Name": "Range - Feet",
          "Value": null
        },
        {
          "Name": "USB",
          "Value": "Yes"
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": null
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": null
        },
        {
          "Name": "Warranty",
          "Value": null
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "Business Equipment",
          "SubCategories": [
            {
              "Name": "Headsets"
            }
          ]
        }
      ],
      "PartNumber": "YEA-BT51-A",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-BT51-A",
      "Manufacturer": "Yealink",
      "ProductName": "1300007 Bluetooth Dongle (USB-A  port)",
      "UnitPrice": 19,
      "MSRP": 29,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 26,
      "UPC": "841885109804"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 29,
      "PriceChangeDate": "2022-11-16T11:35:03.92",
      "ShipmentRecievedDate": "2022-08-31T00:00:00",
      "StandardPrice": 19,
      "EnergyStartCompliant": false,
      "ProductDescription": "- Compatible with CP900/CP700<br/>- Reliable connection<br/>- Up to 100ft/30m wireless range<br/>- Easy to use<br/>- Plug and play",
      "SKU": "1300008 Bluetooth Dongle (USB-C  port)",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-BT51-C",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/32d33563-d872-4f8c-bb37-3642a5debf7c.jpg"
        }
      ],
      "Documents": [],
      "Relatedproducts": [
        "YEA-CP900-BT-TEAMS",
        "YEA-CP900-BT-UC",
        "YEA-CP900-TEAMS",
        "YEA-CP900-UC",
        "YEA-CP700-BT-TEAMS",
        "YEA-CP700-BT-UC",
        "YEA-CP700-TEAMS",
        "YEA-CP700-UC"
      ],
      "Accessories": [
        "YEA-BT51-C"
      ],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 3,
      "Length": 4,
      "Width": 1,
      "Weight": 0.5,
      "DimensionalAirWeigth": 0.09,
      "DimensionalGroundWeight": 0.07,
      "Features": [
        {
          "Name": "Accessories",
          "Value": "Yes"
        },
        {
          "Name": "No. Accessory/Replacement Microphones",
          "Value": null
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": null
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": null
        },
        {
          "Name": "Warranty",
          "Value": null
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "Business Equipment",
          "SubCategories": [
            {
              "Name": "Conferencing Equipment"
            }
          ]
        }
      ],
      "PartNumber": "YEA-BT51-C",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-BT51-C",
      "Manufacturer": "Yealink",
      "ProductName": "1300008 Bluetooth Dongle (USB-C  port)",
      "UnitPrice": 19,
      "MSRP": 29,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 75,
      "UPC": "841885109033"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 199,
      "PriceChangeDate": "2024-01-31T17:15:04.46",
      "ShipmentRecievedDate": "2022-09-11T00:00:00",
      "StandardPrice": 118,
      "EnergyStartCompliant": false,
      "ProductDescription": "- 1.8\" color screen with intuitive UI<br/>- HD voice with Opus audio codec and Noise Cancellation<br/>- Up to 40 hours of talk time <br/>- Up to 575 hours of standby time<br/>- Vibration alarm<br/>- No Perception Upgrade, not affecting any work<br/>- Withstand falls of up to 3.5 meters\r\n",
      "SKU": "1302007 Ruggedized DECT Handset",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-W57R",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/7e157108-9f6a-40ff-ae9b-11c8307ca373.jpg"
        }
      ],
      "Documents": [
        {
          "Description": "Datasheet",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/c88daa14-8ba2-4bdb-b68c-d10ce9b4dcdb.PDF"
        }
      ],
      "Relatedproducts": [
        "YEA-W90DM",
        "YEA-W80DM"
      ],
      "Accessories": [
        "YEA-W70B",
        "BATT-YLW56H",
        "YEA-CCD-W57R",
        "YEA-WARR-B"
      ],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 4,
      "Length": 8,
      "Width": 4,
      "Weight": 0.95,
      "DimensionalAirWeigth": 0.92,
      "DimensionalGroundWeight": 0.77,
      "Features": [
        {
          "Name": "Accessories",
          "Value": "Yes"
        },
        {
          "Name": "Accessory Handsets",
          "Value": "Yes"
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": "Retail Box"
        },
        {
          "Name": "Warranty",
          "Value": "1 Year"
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-W57R",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-W57R",
      "Manufacturer": "Yealink",
      "ProductName": "1302007 Ruggedized DECT Handset",
      "UnitPrice": 118,
      "MSRP": 199,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 200,
      "UPC": "841885109163"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 279,
      "PriceChangeDate": "2024-01-31T17:15:04.46",
      "ShipmentRecievedDate": "2022-06-14T00:00:00",
      "StandardPrice": 166,
      "EnergyStartCompliant": false,
      "ProductDescription": "- High-performance SIP cordless phone system<br>-1.8\" 128 x 160 TFT color screen with intuitive user interface<br>-Ruggedized DECT handset with IP54 protection rating<br>-Up to 20 simultaneous calls<br>-Up to 10 DECT cordless handsets<br>-Up to 10 SIP accounts<br>-Support Opus audio codec<br>-Noise Reduction System<br>-FNR (Flexible Noise Reduction)/Noise Cancellation<br>-Up to 40-hour talk time<br>-Up to 575-hour standby time<br>-Quick charge: 10-minute charging time for 2-hour talk time<br>-TLS and SRTP security encryption<br>-Vibration alarm guarantees you not to miss any call even in noisy situations<br>-Wall mountable charger<br/>- Bundle contains W70B base plus W57R ruggedized handset",
      "SKU": "1302027 Ruggedized DECT IP Phone System",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "Image",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/55636903-c2b3-4cf5-af4e-95e7361e1d34.jpg"
        }
      ],
      "Documents": [
        {
          "Description": "Brochure",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/9ac9e2ac-a1d9-44f9-b12b-03150c0cecd2.pdf"
        }
      ],
      "Relatedproducts": [],
      "Accessories": [
        "YEA-RT30",
        "YEA-W57R",
        "YEA-WARR-B"
      ],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": true,
      "Height": 4,
      "Length": 9,
      "Width": 8,
      "Weight": 1.65,
      "DimensionalAirWeigth": 2.07,
      "DimensionalGroundWeight": 1.73,
      "Features": [],
      "EnvironmentalFeatures": [],
      "OtherFeatures": [],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-W77P",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-W77P",
      "Manufacturer": "Yealink",
      "ProductName": "1302027 Ruggedized DECT IP Phone System",
      "UnitPrice": 166,
      "MSRP": 279,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 144,
      "UPC": "841885109217"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 239,
      "PriceChangeDate": "2024-01-31T17:15:04.46",
      "ShipmentRecievedDate": "2022-06-14T00:00:00",
      "StandardPrice": 141,
      "EnergyStartCompliant": false,
      "ProductDescription": "- High-performance SIP cordless phone system<br/>- 2.4\" 240 x 320 TFT color screen with intuitive user interface<br/>- Up to 20 simultaneous calls<br/>- Up to 10 DECT cordless handsets<br/>- Up to 10 SIP accounts<br/>- Support Opus audio codec<br/>- Noise Reduction System<br/>- FNR (Flexible Noise Reduction)/Noise Cancellation<br/>- Up to 21-hour talk time (in ideal conditions)<br/>- Up to 166-hour standby time (in ideal conditions)<br/>- Quick charging: 10-min charge time for 2-hour talk time<br/>- TLS and SRTP security encryption<br/>- Headset connection via Bluetooth or 3.5 mm jack<br/>- Vibration alarm gurantee you not to miss any call even in noisy situations<br/>- Charger wall mountable",
      "SKU": "1302026 DECT IP Phone System",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-W78P",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/09370fc5-0a42-4b21-b169-7cbed7db3100.jpg"
        }
      ],
      "Documents": [],
      "Relatedproducts": [],
      "Accessories": [
        "YEA-RT30",
        "YEA-W73-W78-BATT",
        "YEA-WARR-B"
      ],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": true,
      "Height": 4,
      "Length": 9,
      "Width": 8,
      "Weight": 1.5,
      "DimensionalAirWeigth": 2.07,
      "DimensionalGroundWeight": 1.73,
      "Features": [
        {
          "Name": "Bluetooth",
          "Value": "Yes"
        },
        {
          "Name": "Call Waiting",
          "Value": "Yes"
        },
        {
          "Name": "Caller ID (CID)",
          "Value": "Yes"
        },
        {
          "Name": "Conference Calling",
          "Value": "Yes"
        },
        {
          "Name": "Corded or Cordless",
          "Value": "Cordless"
        },
        {
          "Name": "Ethernet Ports",
          "Value": "1"
        },
        {
          "Name": "Headset Port",
          "Value": "Yes"
        },
        {
          "Name": "LCD Backlit Display",
          "Value": "Yes"
        },
        {
          "Name": "Number SIP Accounts/Identities",
          "Value": "10"
        },
        {
          "Name": "Power Source",
          "Value": "PoE"
        },
        {
          "Name": "Speakerphone",
          "Value": "Yes"
        },
        {
          "Name": "Voicemail",
          "Value": "Yes"
        },
        {
          "Name": "Wall Mountable",
          "Value": "Yes"
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": "Retail Box"
        },
        {
          "Name": "Warranty",
          "Value": "1 Year"
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-W78P",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-W78P",
      "Manufacturer": "Yealink",
      "ProductName": "1302026 DECT IP Phone System",
      "UnitPrice": 141,
      "MSRP": 239,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 129,
      "UPC": "841885109125"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 159,
      "PriceChangeDate": "2024-01-31T17:15:04.46",
      "ShipmentRecievedDate": "2022-07-22T00:00:00",
      "StandardPrice": 93,
      "EnergyStartCompliant": false,
      "ProductDescription": "- New modern commercial design, more compact and easy to carry<br/>- 2.4‘’ 240 x 320 TFT color screen with intuitive user interface<br/>- Up to 21 hours talk time (in ideal conditions)<br/>- Up to 166 hours standby time (in ideal conditions)<br/>- Quick charging: 10-min charge time for 2-hour talk time<br/>- HD voice and noise cancellation<br/>- Headset connection via Bluetooth or 3.5 mm jack<br/>- Vibration alarm gurantee you not to miss any call even in noisy situations<br/>- Sturdy and reliable belt clip to move freely<br/>- Flexibly meet demands in either single-cell or multi-cell solutions<br/>- Compatible with W60B, W70B, W80MC, W90MC, VIM",
      "SKU": "1302023  Yealink DECT Handset",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-W78H",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/d7be6ec8-2547-496a-b88d-f9e589c9462b.jpg"
        }
      ],
      "Documents": [
        {
          "Description": "Datasheet",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/ca2a9b0f-d669-4749-b692-49a4914ae3d8.pdf"
        }
      ],
      "Relatedproducts": [
        "YEA-W70B"
      ],
      "Accessories": [
        "YEA-W73-W78-BATT",
        "YEA-BCL-W78H",
        "YEA-BTC-W78H",
        "YEA-CCD-W78H",
        "YEA-WARR-A"
      ],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": true,
      "Height": 4,
      "Length": 8,
      "Width": 4,
      "Weight": 0.8,
      "DimensionalAirWeigth": 0.92,
      "DimensionalGroundWeight": 0.77,
      "Features": [
        {
          "Name": "Accessories",
          "Value": "Yes"
        },
        {
          "Name": "Replacement Handsets",
          "Value": "Yes"
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": null
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": null
        },
        {
          "Name": "Warranty",
          "Value": null
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-W78H",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-W78H",
      "Manufacturer": "Yealink",
      "ProductName": "1302023  Yealink DECT Handset",
      "UnitPrice": 93,
      "MSRP": 159,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 10,
      "UPC": "841885107510"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 799,
      "PriceChangeDate": "2022-05-26T08:15:03.03",
      "ShipmentRecievedDate": "2022-06-03T00:00:00",
      "StandardPrice": 448,
      "EnergyStartCompliant": false,
      "ProductDescription": "- Red Dot Winner [2021]<br/>- Android 9.0<br/>- 5-inch multi-touch screen with 720x1280 resolution<br/>- Optimal HD audio, full duplex technology<br/>- Yealink Noise Proof Technology<br/>- 20-foot (6-meter) and 360-degree voice pickup<br/>- Built-in 12-microphone array for voice pickup<br/>- Built-in 1-microphone array for noise cancellation<br/>- Power over Ethernet<br/>- 10-way conference call<br/>- Hybrid UC meeting<br/>- Built-in Wi-Fi (2.4GHz/5GHz, 802.11a/b/g/n)",
      "SKU": "1304017 CP965 Conference Phone Teams",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-CP965-TEAMS",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/f6b49563-945b-444b-b754-fb6c8acb09cd.jpg"
        }
      ],
      "Documents": [
        {
          "Description": "Datasheet",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/130d6212-3def-4523-8019-bb8d880a6c6b.pdf"
        }
      ],
      "Relatedproducts": [
        "YEA-CP965",
        "YEA-CP965-WM"
      ],
      "Accessories": [
        "YEA-YLPOE30",
        "YEA-WARR-E_OLD",
        "YEA-CPW65-DECT-DUO",
        "YEA-USB2-2-5M",
        "YEA-USB2-7M",
        "YEA-USB2-EXT-10M",
        "YEA-USB2-EXT-20M",
        "YEA-USB2-EXT-5M",
        "YEA-USB2CAT5E-EXT",
        "YEA-USBC-HDMI",
        "YEA-CPW65-Package"
      ],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": true,
      "Height": 16,
      "Length": 15,
      "Width": 6,
      "Weight": 4.2,
      "DimensionalAirWeigth": 10.36,
      "DimensionalGroundWeight": 8.67,
      "Features": [
        {
          "Name": "3-Way Calling",
          "Value": "Yes"
        },
        {
          "Name": "Bluetooth",
          "Value": "Yes"
        },
        {
          "Name": "Call Hold",
          "Value": "Yes"
        },
        {
          "Name": "Call Recording",
          "Value": "Yes"
        },
        {
          "Name": "Echo Cancellation",
          "Value": "Yes"
        },
        {
          "Name": "Expandable",
          "Value": "Yes"
        },
        {
          "Name": "Full Duplex Speakerphone",
          "Value": "Yes"
        },
        {
          "Name": "LCD Display",
          "Value": "Yes"
        },
        {
          "Name": "Mute",
          "Value": "Yes"
        },
        {
          "Name": "No. Accessory/Replacement Microphones",
          "Value": null
        },
        {
          "Name": "Teams Platform",
          "Value": "Yes"
        },
        {
          "Name": "Touchscreen",
          "Value": "Yes"
        },
        {
          "Name": "Zoom Platform",
          "Value": null
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": "Retail Box"
        },
        {
          "Name": "Warranty",
          "Value": "1 Year"
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "Business Equipment",
          "SubCategories": [
            {
              "Name": "Conferencing Equipment"
            }
          ]
        }
      ],
      "PartNumber": "YEA-CP965-TEAMS",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-CP965-TEAMS",
      "Manufacturer": "Yealink",
      "ProductName": "1304017 CP965 Conference Phone Teams",
      "UnitPrice": 448,
      "MSRP": 899,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 106,
      "UPC": "841885109743"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 0,
      "PriceChangeDate": "2022-05-03T10:55:03.073",
      "ShipmentRecievedDate": "2022-08-18T00:00:00",
      "StandardPrice": 5.5,
      "EnergyStartCompliant": false,
      "ProductDescription": "Stand for T33G",
      "SKU": "330100000115 Stand for T33G",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-STAND-T33G",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/00fa9137-993e-4231-93e1-ce9861375886.jpg"
        }
      ],
      "Documents": [],
      "Relatedproducts": [
        "YEA-SIP-T33G"
      ],
      "Accessories": [],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 1,
      "Length": 6,
      "Width": 3,
      "Weight": 0.1,
      "DimensionalAirWeigth": 0.13,
      "DimensionalGroundWeight": 0.11,
      "Features": [
        {
          "Name": "Accessories",
          "Value": "Yes"
        },
        {
          "Name": "Stands, Mounting Equipment, and Cases",
          "Value": "Yes"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": null
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": null
        },
        {
          "Name": "Warranty",
          "Value": null
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-STAND-T33G",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-STAND-T33G",
      "Manufacturer": "Yealink",
      "ProductName": "330100000115 Stand for T33G",
      "UnitPrice": 5.5,
      "MSRP": 0,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 223,
      "UPC": "YEA-STAND-T33G"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 0,
      "PriceChangeDate": "2022-08-03T16:55:04.723",
      "ShipmentRecievedDate": "2022-08-29T00:00:00",
      "StandardPrice": 15,
      "EnergyStartCompliant": false,
      "ProductDescription": "- Original Equipment Manufacture (OEM) replacement/spare<br/>- Handset cord not included<br/>- High Quality<br/>- COMPATIBILITY: Yealink MP50, MP54",
      "SKU": "2201110 Handset for MP50",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-HNDST-MP50",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/9e4f4c55-3328-4099-bbe9-aa195845a9e0.jpg"
        }
      ],
      "Documents": [],
      "Relatedproducts": [
        "YEA-MP50"
      ],
      "Accessories": [],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 3,
      "Length": 9,
      "Width": 3,
      "Weight": 0.4,
      "DimensionalAirWeigth": 0.58,
      "DimensionalGroundWeight": 0.49,
      "Features": [
        {
          "Name": "Accessories",
          "Value": "Yes"
        },
        {
          "Name": "Replacement Handsets",
          "Value": "Yes"
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": null
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": null
        },
        {
          "Name": "Warranty",
          "Value": null
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-HNDST-MP50",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-HNDST-MP50",
      "Manufacturer": "Yealink",
      "ProductName": "2201110 Handset for MP50",
      "UnitPrice": 15,
      "MSRP": 0,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 220,
      "UPC": "YEAHDSTMP50"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 0,
      "PriceChangeDate": "2022-08-10T09:55:03.327",
      "ShipmentRecievedDate": "2023-07-05T00:00:00",
      "StandardPrice": 45,
      "EnergyStartCompliant": false,
      "ProductDescription": "USB3.0 to GIGABIT Ethernet Converter",
      "SKU": "1300051 USB3.0 - GB Ether Converter",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-Y-3470",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/48f1f100-c0fd-48d3-98ef-7ec73b5cbc21.jpg"
        }
      ],
      "Documents": [],
      "Relatedproducts": [],
      "Accessories": [],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 2,
      "Length": 5,
      "Width": 5,
      "Weight": 0.2,
      "DimensionalAirWeigth": 0.36,
      "DimensionalGroundWeight": 0.3,
      "Features": [
        {
          "Name": "Accessories",
          "Value": "Yes"
        },
        {
          "Name": "Number of NIM Slots",
          "Value": null
        },
        {
          "Name": "Number of Ports",
          "Value": null
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": null
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": null
        },
        {
          "Name": "Warranty",
          "Value": null
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "Computer and Networking",
          "SubCategories": [
            {
              "Name": "Routers"
            }
          ]
        }
      ],
      "PartNumber": "YEA-Y-3470",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-Y-3470",
      "Manufacturer": "Yealink",
      "ProductName": "1300051 USB3.0 - GB Ether Converter",
      "UnitPrice": 45,
      "MSRP": 0,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 10,
      "UPC": "4894160034342"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 294,
      "PriceChangeDate": "2024-01-31T17:15:04.46",
      "ShipmentRecievedDate": "2022-10-04T00:00:00",
      "StandardPrice": 139,
      "EnergyStartCompliant": false,
      "ProductDescription": "- Mid-level phone with included power supply ideal for professionals and managers with moderate call load<br/>- 4.3\" 480x272-pixel color display, fully adjustable<br/>- HD Voice with Yealink Acoustic Shield technology<br/>- 10 line keys, 16 SIP accounts, 27 memory keys<br/>- Built-in Bluetooth, Wi-Fi<br/>- Dual-port Gigabit Ethernet<br/>- 1xUSB port for call recording and wireless USB headset<br/>- Phone can work in dect mode with the addition of YEA-DD10K and YEA-W70B base and you will have 10 blf keys",
      "SKU": "SIP-T54W With Power Supply",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-SIP-T54W-PWR",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/29dd953c-d8c4-4f4f-bb8f-b13ceba5d822.jpg"
        }
      ],
      "Documents": [
        {
          "Description": "Datasheet",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/48dd19c4-7fe5-4997-acd2-c1d22ef7b03d.pdf"
        }
      ],
      "Relatedproducts": [
        "YEA-SIP-T53",
        "YEA-SIP-T53W",
        "YEA-SIP-T57W",
        "YEA-SIP-T58W",
        "YEA-SIP-T58W-CAM",
        "YEA-SIP-T58W-PRO",
        "YEA-SIP-T58W-PRO-CAM"
      ],
      "Accessories": [],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": true,
      "Height": 10,
      "Length": 10.5,
      "Width": 4.5,
      "Weight": 2.75,
      "DimensionalAirWeigth": 3.4,
      "DimensionalGroundWeight": 2.85,
      "Features": [
        {
          "Name": "Bluetooth",
          "Value": "Yes"
        },
        {
          "Name": "Call Waiting",
          "Value": "Yes"
        },
        {
          "Name": "Caller ID (CID)",
          "Value": "Yes"
        },
        {
          "Name": "Conference Calling",
          "Value": "Yes"
        },
        {
          "Name": "Corded or Cordless",
          "Value": "Corded"
        },
        {
          "Name": "Ethernet Ports",
          "Value": "2"
        },
        {
          "Name": "Headset Port",
          "Value": "Yes"
        },
        {
          "Name": "LCD Backlit Display",
          "Value": "Yes"
        },
        {
          "Name": "Number SIP Accounts/Identities",
          "Value": "10+"
        },
        {
          "Name": "Power Source",
          "Value": "PoE and AC Adapter"
        },
        {
          "Name": "Power Supply Included",
          "Value": "Yes"
        },
        {
          "Name": "Speakerphone",
          "Value": "Yes"
        },
        {
          "Name": "Wall Mountable",
          "Value": "Yes"
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": "Retail Box"
        },
        {
          "Name": "Warranty",
          "Value": "1 Year"
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-SIP-T54W-PWR",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-SIP-T54W-PWR",
      "Manufacturer": "Yealink",
      "ProductName": "SIP-T54W With Power Supply",
      "UnitPrice": 139,
      "MSRP": 294,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 1000,
      "UPC": "SIPT54WPWR"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 0,
      "PriceChangeDate": "2022-10-11T17:15:03.697",
      "ShipmentRecievedDate": "2022-11-29T00:00:00",
      "StandardPrice": 7,
      "EnergyStartCompliant": false,
      "ProductDescription": "Belt Clip for W73H",
      "SKU": "330100010036 Belt Clip for W73H",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-BCL-W73H",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/b859b0ed-ffde-4afe-90da-fdeebf19d89c.jpg"
        }
      ],
      "Documents": [],
      "Relatedproducts": [
        "YEA-W73H"
      ],
      "Accessories": [],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 1,
      "Length": 3,
      "Width": 2,
      "Weight": 0.01,
      "DimensionalAirWeigth": 0.04,
      "DimensionalGroundWeight": 0.04,
      "Features": [
        {
          "Name": "Accessories",
          "Value": "Yes"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": null
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": null
        },
        {
          "Name": "Warranty",
          "Value": null
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-BCL-W73H",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-BCL-W73H",
      "Manufacturer": "Yealink",
      "ProductName": "330100010036 Belt Clip for W73H",
      "UnitPrice": 7,
      "MSRP": 0,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 341,
      "UPC": "841885112286"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 0,
      "PriceChangeDate": "2022-11-07T09:15:05.177",
      "ShipmentRecievedDate": "2022-11-29T00:00:00",
      "StandardPrice": 96.25,
      "EnergyStartCompliant": false,
      "ProductDescription": "- 5 mega-pixel HD Camera<br/>- 720p@30fps<br/>- Ease-of-use<br/>- Plug and Play<br/>- Adjustable with privacy shutter<br/>- Only works on the VP59 phone",
      "SKU": "1503050 Replacement camera for VP59",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-CAM-VP59",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/93a5d832-6f4b-46fc-b6d6-949c7e0e08e5.jpg"
        }
      ],
      "Documents": [],
      "Relatedproducts": [
        "YEA-VP59G",
        "YEA-VP59G-ZOOM"
      ],
      "Accessories": [],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 2,
      "Length": 4,
      "Width": 3,
      "Weight": 0.1,
      "DimensionalAirWeigth": 0.17,
      "DimensionalGroundWeight": 0.14,
      "Features": [
        {
          "Name": "Accessories",
          "Value": "Yes"
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": null
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": null
        },
        {
          "Name": "Warranty",
          "Value": null
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-CAM-VP59",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-CAM-VP59",
      "Manufacturer": "Yealink",
      "ProductName": "1503050 Replacement camera for VP59",
      "UnitPrice": 96.25,
      "MSRP": 0,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 13,
      "UPC": "841885113351"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 0,
      "PriceChangeDate": "2022-12-12T11:35:03.657",
      "ShipmentRecievedDate": "2023-01-23T00:00:00",
      "StandardPrice": 25,
      "EnergyStartCompliant": false,
      "ProductDescription": "- Support Yealink wireless headset only<br/>- Perfectly compatible with Mitel/Unify/Yealink T2X/T4XG desk phones<br/>- Control phone through wireless headset<br/>- Plug and play<br/>- Easy to use<br/>-Compatible only with WH62/WH63 headsets",
      "SKU": "1308113 EHS For T4XG and T2X phones",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-EHS61",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/d3e97670-a194-49a6-b6d4-92ff6bd4f9d5.jpg"
        }
      ],
      "Documents": [
        {
          "Description": "Datasheet",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/ad028b52-b828-41c9-9b61-88f6ef62f69a.pdf"
        }
      ],
      "Relatedproducts": [
        "YEA-WH62-DUAL-Portable-Teams",
        "YEA-WH62-DUAL-Portable-UC",
        "YEA-WH62-DUAL-TEAMS",
        "YEA-WH62-DUAL-UC",
        "YEA-WH62-MONO-PORTABLE-TEAMS",
        "YEA-WH62-MONO-Portable-UC",
        "YEA-WH62-MONO-TEAMS",
        "YEA-WH62-MONO-UC",
        "YEA-WH62-WH66-Kit",
        "YEA-WH63-Portable-Teams",
        "YEA-WH63-Portable-UC",
        "YEA-WH63-TEAMS",
        "YEA-WH63-UC",
        "YEA-WH63-WH67-Kit"
      ],
      "Accessories": [],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 9.06,
      "Length": 16.14,
      "Width": 11.22,
      "Weight": 4.4,
      "DimensionalAirWeigth": 11.8,
      "DimensionalGroundWeight": 9.88,
      "Features": [
        {
          "Name": "Accessories",
          "Value": "Yes"
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": null
        },
        {
          "Name": "Warranty",
          "Value": null
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-EHS61",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-EHS61",
      "Manufacturer": "Yealink",
      "ProductName": "1308113 EHS For T4XG and T2X phones",
      "UnitPrice": 25,
      "MSRP": 0,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 158,
      "UPC": "6938818315433"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 0,
      "PriceChangeDate": "2023-04-11T08:55:03.863",
      "ShipmentRecievedDate": "2023-12-27T00:00:00",
      "StandardPrice": 19.95,
      "EnergyStartCompliant": false,
      "ProductDescription": "W73H/W78H Replacement Battery",
      "SKU": "Replacement Battery W73H/W73P/W78H/W78P",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-W73-W78-BATT",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/5d10cd5b-6491-40aa-a573-01e06890610f.jpg"
        }
      ],
      "Documents": [],
      "Relatedproducts": [
        "YEA-W73H",
        "YEA-W73P",
        "YEA-W78H",
        "YEA-W78P"
      ],
      "Accessories": [],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 1,
      "Length": 2,
      "Width": 2,
      "Weight": 0.2,
      "DimensionalAirWeigth": 0.03,
      "DimensionalGroundWeight": 0.02,
      "Features": [],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": null
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": null
        },
        {
          "Name": "Warranty",
          "Value": null
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-W73-W78-BATT",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-W73-W78-BATT",
      "Manufacturer": "Yealink",
      "ProductName": "Replacement Battery W73H/W73P/W78H/W78P",
      "UnitPrice": 19.95,
      "MSRP": 0,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 176,
      "UPC": "841885111883"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 0,
      "PriceChangeDate": "2023-10-09T10:35:03.327",
      "ShipmentRecievedDate": "2023-12-06T00:00:00",
      "StandardPrice": 7,
      "EnergyStartCompliant": false,
      "ProductDescription": "330100010039 Yealink W78H Belt Clip",
      "SKU": "330100010039 Yealink W78H Belt Clip",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-BCL-W78H",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/aec9a6ea-e733-47bb-8fe5-1f831f7a6d38.jpg"
        }
      ],
      "Documents": [],
      "Relatedproducts": [
        "YEA-BTC-W78H",
        "YEA-CCD-W78H",
        "YEA-W78H"
      ],
      "Accessories": [],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 1,
      "Length": 2,
      "Width": 2,
      "Weight": 0.2,
      "DimensionalAirWeigth": 0.03,
      "DimensionalGroundWeight": 0.02,
      "Features": [],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": null
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": null
        },
        {
          "Name": "Warranty",
          "Value": null
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-BCL-W78H",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-BCL-W78H",
      "Manufacturer": "Yealink",
      "ProductName": "330100010039 Yealink W78H Belt Clip",
      "UnitPrice": 7,
      "MSRP": 0,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 95,
      "UPC": "330100010039"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 0,
      "PriceChangeDate": "2023-10-09T10:35:03.327",
      "ShipmentRecievedDate": "2024-01-18T00:00:00",
      "StandardPrice": 15.5,
      "EnergyStartCompliant": false,
      "ProductDescription": "Replace battery cover W78H\r\n",
      "SKU": "330000000004 Replace battery cover W78H",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-BTC-W78H",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/6680e61b-c6c8-4ef9-8285-d9fa1dab72dd.jpg"
        }
      ],
      "Documents": [],
      "Relatedproducts": [
        "YEA-BCL-W78H",
        "YEA-CCD-W78H",
        "YEA-W78H"
      ],
      "Accessories": [],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 1,
      "Length": 3,
      "Width": 2,
      "Weight": 0.1,
      "DimensionalAirWeigth": 0.04,
      "DimensionalGroundWeight": 0.04,
      "Features": [
        {
          "Name": "Accessories",
          "Value": "Yes"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": null
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": null
        },
        {
          "Name": "Warranty",
          "Value": null
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-BTC-W78H",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-BTC-W78H",
      "Manufacturer": "Yealink",
      "ProductName": "330000000004 Replace battery cover W78H",
      "UnitPrice": 15.5,
      "MSRP": 0,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 20,
      "UPC": "841885121073"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 0,
      "PriceChangeDate": "2023-10-09T10:35:03.327",
      "ShipmentRecievedDate": "2023-12-06T00:00:00",
      "StandardPrice": 10.5,
      "EnergyStartCompliant": false,
      "ProductDescription": "Yea W78H USB Charging Dock",
      "SKU": "230202300002 Yea W78H USB Charging Dock",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-CCD-W78H",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/b09b499b-fefb-4e75-89ec-5a09397f32b5.jpg"
        }
      ],
      "Documents": [],
      "Relatedproducts": [
        "YEA-W78H"
      ],
      "Accessories": [],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 4,
      "Length": 4,
      "Width": 3,
      "Weight": 0.7,
      "DimensionalAirWeigth": 0.35,
      "DimensionalGroundWeight": 0.29,
      "Features": [
        {
          "Name": "Accessories",
          "Value": "Yes"
        },
        {
          "Name": "Power Supplies",
          "Value": "Yes"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": null
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": null
        },
        {
          "Name": "Warranty",
          "Value": null
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-CCD-W78H",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-CCD-W78H",
      "Manufacturer": "Yealink",
      "ProductName": "230202300002 Yea W78H USB Charging Dock",
      "UnitPrice": 10.5,
      "MSRP": 0,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 30,
      "UPC": "841885118981"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 0,
      "PriceChangeDate": "2023-10-09T10:35:03.327",
      "ShipmentRecievedDate": "2024-01-18T00:00:00",
      "StandardPrice": 10.5,
      "EnergyStartCompliant": false,
      "ProductDescription": "Yealink W57R USB Charging d",
      "SKU": "230200700001 Yealink W57R USB Charging d",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-CCD-W57R",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/7821e8f0-103a-4582-b045-31fa66b3cb4e.jpg"
        }
      ],
      "Documents": [],
      "Relatedproducts": [
        "YEA-W57R"
      ],
      "Accessories": [],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 2,
      "Length": 4,
      "Width": 3,
      "Weight": 0.1,
      "DimensionalAirWeigth": 0.17,
      "DimensionalGroundWeight": 0.14,
      "Features": [
        {
          "Name": "Accessories",
          "Value": "Yes"
        },
        {
          "Name": "Power Supplies",
          "Value": "Yes"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": null
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": null
        },
        {
          "Name": "Warranty",
          "Value": null
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-CCD-W57R",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-CCD-W57R",
      "Manufacturer": "Yealink",
      "ProductName": "230200700001 Yealink W57R USB Charging d",
      "UnitPrice": 10.5,
      "MSRP": 0,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 27,
      "UPC": "230200700001"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 139,
      "PriceChangeDate": "2023-10-17T13:55:02.76",
      "ShipmentRecievedDate": "2023-12-27T00:00:00",
      "StandardPrice": 139,
      "EnergyStartCompliant": false,
      "ProductDescription": "- Optima HD voice<br/>- Full duplex technology<br/>- 10-foot (3-meter) 360° voice pickup<br/>- Echo cancellation<br/>- Capacitive mute touchpad with bicolor LED<br/>- Work with Yealink CP965 IP Conference",
      "SKU": "1304029 CP Wired Expansion Mic CPE95",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-CPE95",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/f0a3af61-966b-4457-aa92-8413839507c2.jpg"
        }
      ],
      "Documents": [],
      "Relatedproducts": [
        "YEA-CP965",
        "YEA-CP965-TEAMS"
      ],
      "Accessories": [],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 5,
      "Length": 7,
      "Width": 3,
      "Weight": 1,
      "DimensionalAirWeigth": 0.76,
      "DimensionalGroundWeight": 0.63,
      "Features": [
        {
          "Name": "Accessories",
          "Value": "Yes"
        },
        {
          "Name": "Microphone",
          "Value": "Yes"
        },
        {
          "Name": "No. Accessory/Replacement Microphones",
          "Value": "2"
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": null
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": null
        },
        {
          "Name": "Warranty",
          "Value": null
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "Business Equipment",
          "SubCategories": [
            {
              "Name": "Conferencing Equipment"
            }
          ]
        }
      ],
      "PartNumber": "YEA-CPE95",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-CPE95",
      "Manufacturer": "Yealink",
      "ProductName": "1304029 CP Wired Expansion Mic CPE95",
      "UnitPrice": 139,
      "MSRP": 139,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 193,
      "UPC": "841885117229"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 0,
      "PriceChangeDate": "2023-10-20T09:55:03.493",
      "ShipmentRecievedDate": "2024-01-03T00:00:00",
      "StandardPrice": 10,
      "EnergyStartCompliant": false,
      "ProductDescription": "W73H USB Charging Dock",
      "SKU": "230202100002 W73H USB Charging Dock",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-CCD-W73H",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/dbeb0bc6-4206-4033-9402-4aff425d8084.jpg"
        }
      ],
      "Documents": [],
      "Relatedproducts": [
        "YEA-BCL-W73H",
        "YEA-W73H"
      ],
      "Accessories": [],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 1,
      "Length": 3,
      "Width": 3,
      "Weight": 0.7,
      "DimensionalAirWeigth": 0.06,
      "DimensionalGroundWeight": 0.05,
      "Features": [
        {
          "Name": "Accessories",
          "Value": "Yes"
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": null
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": null
        },
        {
          "Name": "Warranty",
          "Value": null
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-CCD-W73H",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-CCD-W73H",
      "Manufacturer": "Yealink",
      "ProductName": "230202100002 W73H USB Charging Dock",
      "UnitPrice": 10,
      "MSRP": 0,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 45,
      "UPC": "230202100002"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 129,
      "PriceChangeDate": "2023-10-20T16:55:03.437",
      "ShipmentRecievedDate": "2023-11-17T00:00:00",
      "StandardPrice": 70,
      "EnergyStartCompliant": false,
      "ProductDescription": "- Built-in dual band 2.4G/5G Wi-Fi (802.11a/b/g/n/ac)<br/>- USB 2.0 port for wired USB headsets/Bluetooth headsets<br/>- Yealink HD Voice<br/>- 2.4” 320 x 240-pixel color display with backlight<br/>- Dual-port Gigabit Ethernet<br/>- PoE support<br/>- Up to 4 SIP accounts<br/>- Local 5-way conferencing<br/>- Support EHS Wireless Headset<br/>- Unified Firmware<br/>- Support YDMP/YMCS<br/>- Stand with 2 adjustable angles<br/>- Wall mountable<br/>- Handset with hall switch<br/>- Ethernet cable not included<br/>- Power supply not included",
      "SKU": "1301037 Entry-level IP Phone w/4 lines",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-SIP-T34W",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/e0e56812-751d-405d-a502-2fb926168f8c.jpg"
        }
      ],
      "Documents": [
        {
          "Description": "Datasheet",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/8837b386-1afe-4a7f-81b7-ee2e1be59d9b.pdf"
        }
      ],
      "Relatedproducts": [
        "YEA-SIP-T31G",
        "YEA-SIP-T31P",
        "YEA-SIP-T33G"
      ],
      "Accessories": [
        "YEA-PS5V1200US",
        "YEA-WMB-T33G",
        "YEA-HNDST-T3G",
        "YEA-HC-T3X",
        "ICC-ICPCSP05BK",
        "YEA-WARR-A"
      ],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": true,
      "Height": 8.2,
      "Length": 9.3,
      "Width": 4,
      "Weight": 2.2,
      "DimensionalAirWeigth": 2.19,
      "DimensionalGroundWeight": 1.84,
      "Features": [
        {
          "Name": "Bluetooth",
          "Value": "Yes"
        },
        {
          "Name": "Call Waiting",
          "Value": "Yes"
        },
        {
          "Name": "Caller ID (CID)",
          "Value": "Yes"
        },
        {
          "Name": "Conference Calling",
          "Value": "Yes"
        },
        {
          "Name": "Corded or Cordless",
          "Value": "Cordless"
        },
        {
          "Name": "EHS",
          "Value": "Yes"
        },
        {
          "Name": "Ethernet Ports",
          "Value": "2"
        },
        {
          "Name": "Headset Port",
          "Value": "Yes"
        },
        {
          "Name": "LCD Backlit Display",
          "Value": "Yes"
        },
        {
          "Name": "Number SIP Accounts/Identities",
          "Value": "4"
        },
        {
          "Name": "Power Source",
          "Value": "PoE"
        },
        {
          "Name": "SIP or Proprietary IP",
          "Value": "SIP Phones"
        },
        {
          "Name": "Speakerphone",
          "Value": "Yes"
        },
        {
          "Name": "Wall Mountable",
          "Value": "Yes"
        },
        {
          "Name": "Wifi",
          "Value": "Yes"
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": "Retail Box"
        },
        {
          "Name": "Warranty",
          "Value": "1 Year"
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-SIP-T34W",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-SIP-T34W",
      "Manufacturer": "Yealink",
      "ProductName": "1301037 Entry-level IP Phone w/4 lines",
      "UnitPrice": 70,
      "MSRP": 139,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 1000,
      "UPC": "841885119780"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 159,
      "PriceChangeDate": "2023-10-31T11:15:04.873",
      "ShipmentRecievedDate": "2024-01-02T00:00:00",
      "StandardPrice": 83,
      "EnergyStartCompliant": false,
      "ProductDescription": "- 2.8” 320x240-pixel color LCD with backlight<br/>- Dual USB ports<br/>- Dual firmware images<br/>- T4U Auto-P template unified<br/>- T4U firmware unified<br/>- Up to 12 SIP accounts<br/>- PoE support<br/>- USB headset and EHS support<br/>- Wi-Fi via WF40/WF50<br/>- Bluetooth via BT40/BT41/BT51<br/>- Supports color-screen expansion modules<br/>- Stand with 2 adjustable angles<br/>- Wall mountable<br/>- Handset with hall switch",
      "SKU": "1301214 Feature-rich SIP Phone",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-SIP-T44U",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/f7ba2310-7b60-4f61-96f0-aaac5595b760.jpg"
        },
        {
          "Description": "YEA-SIP-T44U",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/b335737a-d5c1-4d14-8a88-d2a0f389284d.jpg"
        }
      ],
      "Documents": [
        {
          "Description": "Datasheet",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/d7d9bb91-231a-4ee0-a766-a85fbe1c7077.pdf"
        }
      ],
      "Relatedproducts": [
        "YEA-SIP-T43U",
        "YEA-SIP-T44W",
        "YEA-SIP-T46U",
        "YEA-SIP-T48U"
      ],
      "Accessories": [
        "YEA-WMB-T4S",
        "YEA-PS5V1200US",
        "YEA-WARR-A"
      ],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": true,
      "Height": 9,
      "Length": 11,
      "Width": 5,
      "Weight": 3.1,
      "DimensionalAirWeigth": 3.56,
      "DimensionalGroundWeight": 2.98,
      "Features": [
        {
          "Name": "Bluetooth",
          "Value": "Yes"
        },
        {
          "Name": "Call Waiting",
          "Value": "Yes"
        },
        {
          "Name": "Caller ID (CID)",
          "Value": "Yes"
        },
        {
          "Name": "Conference Calling",
          "Value": "Yes"
        },
        {
          "Name": "Corded or Cordless",
          "Value": "Corded"
        },
        {
          "Name": "EHS",
          "Value": "Yes"
        },
        {
          "Name": "Ethernet Ports",
          "Value": "2"
        },
        {
          "Name": "Headset Port",
          "Value": "Yes"
        },
        {
          "Name": "LCD Backlit Display",
          "Value": "Yes"
        },
        {
          "Name": "Number SIP Accounts/Identities",
          "Value": "10+"
        },
        {
          "Name": "Power Source",
          "Value": "PoE"
        },
        {
          "Name": "SIP or Proprietary IP",
          "Value": "SIP Phones"
        },
        {
          "Name": "Speakerphone",
          "Value": "Yes"
        },
        {
          "Name": "Voicemail",
          "Value": "Yes"
        },
        {
          "Name": "Wall Mountable",
          "Value": "Yes"
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": "Retail Box"
        },
        {
          "Name": "Warranty",
          "Value": "1 Year"
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-SIP-T44U",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-SIP-T44U",
      "Manufacturer": "Yealink",
      "ProductName": "1301214 Feature-rich SIP Phone",
      "UnitPrice": 83,
      "MSRP": 169,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 1000,
      "UPC": "841885120670"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 169,
      "PriceChangeDate": "2023-10-31T11:15:04.873",
      "ShipmentRecievedDate": "2024-01-02T00:00:00",
      "StandardPrice": 92,
      "EnergyStartCompliant": false,
      "ProductDescription": "- 2.8” 320x240-pixel color LCD with backlight<br/>- Dual USB ports<br/>- Dual firmware images<br/>- Built-in Bluetooth 4.2<br/>- Built-in dual band 2.4G/5G Wi-Fi (802.11a/b/g/n/ac)<br/>- T4U Auto-P template unified<br/>- T4U firmware unified<br/>- Up to 12 SIP accounts<br/>- PoE support<br/>- USB headset and EHS support<br/>- Supports color-screen expansion modules<br/>- Stand with 2 adjustable angles<br/>- Wall mountable<br/>- Handset with hall switch",
      "SKU": "1301213 Feature-rich SIP Phone",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-SIP-T44W",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/78cf7283-a435-452d-8ff1-4bb8636259bb.jpg"
        }
      ],
      "Documents": [
        {
          "Description": "Datasheet",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/bc358e61-8583-4495-a6ba-b35ff06010cb.pdf"
        }
      ],
      "Relatedproducts": [
        "YEA-SIP-T43U",
        "YEA-SIP-T44U",
        "YEA-SIP-T46U",
        "YEA-SIP-T48U"
      ],
      "Accessories": [
        "YEA-WMB-T4S",
        "YEA-PS5V1200US",
        "YEA-WARR-B"
      ],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": true,
      "Height": 9,
      "Length": 11,
      "Width": 5,
      "Weight": 3.1,
      "DimensionalAirWeigth": 3.56,
      "DimensionalGroundWeight": 2.98,
      "Features": [
        {
          "Name": "Bluetooth",
          "Value": "Yes"
        },
        {
          "Name": "Call Waiting",
          "Value": "Yes"
        },
        {
          "Name": "Caller ID (CID)",
          "Value": "Yes"
        },
        {
          "Name": "Conference Calling",
          "Value": "Yes"
        },
        {
          "Name": "Corded or Cordless",
          "Value": "Corded"
        },
        {
          "Name": "EHS",
          "Value": "Yes"
        },
        {
          "Name": "Ethernet Ports",
          "Value": "2"
        },
        {
          "Name": "Headset Port",
          "Value": "Yes"
        },
        {
          "Name": "LCD Backlit Display",
          "Value": "Yes"
        },
        {
          "Name": "Number SIP Accounts/Identities",
          "Value": "10+"
        },
        {
          "Name": "Power Source",
          "Value": "PoE and AC Adapter"
        },
        {
          "Name": "Speakerphone",
          "Value": "Yes"
        },
        {
          "Name": "Voicemail",
          "Value": "Yes"
        },
        {
          "Name": "Wall Mountable",
          "Value": "Yes"
        },
        {
          "Name": "Wifi",
          "Value": "Yes"
        },
        {
          "Name": "Color",
          "Value": "Black"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": "China"
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": "Retail Box"
        },
        {
          "Name": "Warranty",
          "Value": "1 Year"
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-SIP-T44W",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-SIP-T44W",
      "Manufacturer": "Yealink",
      "ProductName": "1301213 Feature-rich SIP Phone",
      "UnitPrice": 92,
      "MSRP": 179,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 1000,
      "UPC": "841885120663"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 0,
      "PriceChangeDate": "2023-11-02T16:35:03.31",
      "ShipmentRecievedDate": "2024-01-03T00:00:00",
      "StandardPrice": 15,
      "EnergyStartCompliant": false,
      "ProductDescription": "Handset for MP56,MP58, T58W",
      "SKU": "220119300002 Handset for MP56,MP58, T58W",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-HNDST-MP56",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/7834860e-398a-48bc-abba-2682a7b30dae.jpg"
        }
      ],
      "Documents": [],
      "Relatedproducts": [
        "YEA-MP56-TEAMS",
        "YEA-MP56-ZOOM",
        "YEA-MP58-TEAMS",
        "YEA-MP58-WH-ZOOM",
        "YEA-MP58-ZOOM",
        "YEA-SIP-T58W",
        "YEA-SIP-T58W-PRO",
        "YEA-SIP-T58W-PRO-CAM"
      ],
      "Accessories": [],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 8,
      "Length": 3,
      "Width": 2,
      "Weight": 0.7,
      "DimensionalAirWeigth": 0.35,
      "DimensionalGroundWeight": 0.29,
      "Features": [
        {
          "Name": "Accessories",
          "Value": "Yes"
        },
        {
          "Name": "Replacement Handsets",
          "Value": "Yes"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": null
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": null
        },
        {
          "Name": "Warranty",
          "Value": null
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "VOIP and UC",
          "SubCategories": [
            {
              "Name": "SIP Phones"
            }
          ]
        }
      ],
      "PartNumber": "YEA-HNDST-MP56",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-HNDST-MP56",
      "Manufacturer": "Yealink",
      "ProductName": "220119300002 Handset for MP56,MP58, T58W",
      "UnitPrice": 15,
      "MSRP": 0,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 154,
      "UPC": "841885112330"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 0,
      "PriceChangeDate": "2023-12-14T08:55:03.25",
      "ShipmentRecievedDate": "2024-03-07T00:00:00",
      "StandardPrice": 5,
      "EnergyStartCompliant": false,
      "ProductDescription": "BH71 Small Ear Tip 3 pcs",
      "SKU": "3311055 BH71 Small Ear Tip 3 pcs",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-ET-BH71-SMALL",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/4f8201f0-e888-48ff-bc02-73eadd178b0f.jpg"
        }
      ],
      "Documents": [],
      "Relatedproducts": [
        "YEA-BH71",
        "YEA-BH71-PRO",
        "YEA-BH71-WORKSTATION",
        "YEA-BH71-WORKSTATION-PRO",
        "YEA-ET-BH71-LARGE",
        "YEA-ET-BH71-MEDIUM"
      ],
      "Accessories": [],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 1,
      "Length": 1,
      "Width": 1,
      "Weight": 0.5,
      "DimensionalAirWeigth": 0.01,
      "DimensionalGroundWeight": 0.01,
      "Features": [
        {
          "Name": "Range - Feet",
          "Value": null
        },
        {
          "Name": "Windscreens, Cushions, and Eartips",
          "Value": "Yes"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": null
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": null
        },
        {
          "Name": "Warranty",
          "Value": null
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "Business Equipment",
          "SubCategories": [
            {
              "Name": "Headsets"
            }
          ]
        }
      ],
      "PartNumber": "YEA-ET-BH71-SMALL",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-ET-BH71-SMALL",
      "Manufacturer": "Yealink",
      "ProductName": "3311055 BH71 Small Ear Tip 3 pcs",
      "UnitPrice": 5,
      "MSRP": 0,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 89,
      "UPC": "841885120724"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 0,
      "PriceChangeDate": "2023-12-14T08:55:03.25",
      "ShipmentRecievedDate": "2024-03-07T00:00:00",
      "StandardPrice": 5,
      "EnergyStartCompliant": false,
      "ProductDescription": "BH71 Medium Ear Tip 3 pcs",
      "SKU": "3311056 BH71 Medium Ear Tip 3 pcs",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-ET-BH71-MEDIUM",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/8d2e63e1-dcaf-4dcf-82dd-a14549064cdc.jpg"
        }
      ],
      "Documents": [],
      "Relatedproducts": [
        "YEA-BH71",
        "YEA-BH71-PRO",
        "YEA-BH71-WORKSTATION",
        "YEA-BH71-WORKSTATION-PRO",
        "YEA-ET-BH71-LARGE",
        "YEA-ET-BH71-SMALL"
      ],
      "Accessories": [],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 1,
      "Length": 1,
      "Width": 1,
      "Weight": 0.5,
      "DimensionalAirWeigth": 0.01,
      "DimensionalGroundWeight": 0.01,
      "Features": [
        {
          "Name": "Range - Feet",
          "Value": null
        },
        {
          "Name": "Windscreens, Cushions, and Eartips",
          "Value": "Yes"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": null
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": null
        },
        {
          "Name": "Warranty",
          "Value": null
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "Business Equipment",
          "SubCategories": [
            {
              "Name": "Headsets"
            }
          ]
        }
      ],
      "PartNumber": "YEA-ET-BH71-MEDIUM",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-ET-BH71-MEDIUM",
      "Manufacturer": "Yealink",
      "ProductName": "3311056 BH71 Medium Ear Tip 3 pcs",
      "UnitPrice": 5,
      "MSRP": 0,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 89,
      "UPC": "841885120731"
    },
    {
      "DisplayStatus": "Active",
      "OpportunityBuy": false,
      "LastStandardPrice": 0,
      "PriceChangeDate": "2023-12-14T08:55:03.25",
      "ShipmentRecievedDate": "2024-03-07T00:00:00",
      "StandardPrice": 5,
      "EnergyStartCompliant": false,
      "ProductDescription": "BH71 Large Ear Tip 3 pcs",
      "SKU": "3311057 BH71 Large Ear Tip 3 pcs",
      "BrandName": "Yealink",
      "ManufacturerLogo": "https://www.teledynamics.com/tdresources/cc0d63ca-9469-41eb-ac67-3a77e6587a3a.jpg",
      "BrandLogo": null,
      "RequireCertification": false,
      "Images": [
        {
          "Description": "YEA-ET-BH71-LARGE",
          "ResourceUrl": "https://www.teledynamics.com/tdresources/5c6ccaaa-cd04-4e92-8241-ba1480a3c4f8.jpg"
        }
      ],
      "Documents": [],
      "Relatedproducts": [
        "YEA-BH71",
        "YEA-BH71-PRO",
        "YEA-BH71-WORKSTATION",
        "YEA-BH71-WORKSTATION-PRO",
        "YEA-ET-BH71-MEDIUM",
        "YEA-ET-BH71-SMALL"
      ],
      "Accessories": [],
      "Leasable": false,
      "Virtual": false,
      "AvailableForSale": false,
      "CanExport": true,
      "CanProvision": false,
      "Height": 1,
      "Length": 1,
      "Width": 1,
      "Weight": 0.5,
      "DimensionalAirWeigth": 0.01,
      "DimensionalGroundWeight": 0.01,
      "Features": [
        {
          "Name": "Range - Feet",
          "Value": null
        },
        {
          "Name": "Windscreens, Cushions, and Eartips",
          "Value": "Yes"
        }
      ],
      "EnvironmentalFeatures": [
        {
          "Name": "Energy Star Qualified",
          "Value": null
        },
        {
          "Name": "Recycled Packaging",
          "Value": null
        }
      ],
      "OtherFeatures": [
        {
          "Name": "Country of Origin",
          "Value": null
        },
        {
          "Name": "RoHS Compliant",
          "Value": null
        },
        {
          "Name": "Type of Packaging",
          "Value": null
        },
        {
          "Name": "Warranty",
          "Value": null
        },
        {
          "Name": "Website Link",
          "Value": "www.yealink.com"
        }
      ],
      "Categories": [
        {
          "Name": "Business Equipment",
          "SubCategories": [
            {
              "Name": "Headsets"
            }
          ]
        }
      ],
      "PartNumber": "YEA-ET-BH71-LARGE",
      "ResrouceURL": "http://www.teledynamics.com/#/productdetails/YEA-ET-BH71-LARGE",
      "Manufacturer": "Yealink",
      "ProductName": "3311057 BH71 Large Ear Tip 3 pcs",
      "UnitPrice": 5,
      "MSRP": 0,
      "MAP": null,
      "SpecialOrder": true,
      "Quantity": 90,
      "UPC": "841885120748"
    }
  ];